var pbawp;
(function (pbawp) {
    class App extends Phaser.Game {
        constructor() {
            let config = {
                type: DetectPhaserRenderMode(),
                width: App.CANVAS_WIDTH,
                height: App.CANVAS_HEIGHT,
                scale: {
                    mode: FitScaleManager.detectBestScaleMode(),
                    autoCenter: Phaser.Scale.CENTER_BOTH
                },
                transparent: false,
                scene: {
                    create: () => {
                        this.scene.add('Boot', pbawp.scene.Boot, true);
                    }
                }
            };
            super(config);
        }
    }
    App.CANVAS_WIDTH = 600;
    App.CANVAS_HEIGHT = 500;
    pbawp.App = App;
})(pbawp || (pbawp = {}));
function setupPopUpWindowAnalytics(popUpWindow) {
    if (!popUpWindow)
        return;
    let fbBtn = popUpWindow.document.querySelector("#container > div:nth-child(4) > div > a:nth-child(1) > img");
    if (fbBtn) {
        fbBtn.addEventListener("click", () => {
            sendEvent(petaGA_GameCategory_Game, 'Share Video Facebook', 'Pokémon Red White and Blue - Share Video Facebook');
        });
    }
    let twtBtn = popUpWindow.document.querySelector("#container > div:nth-child(4) > div > a:nth-child(2) > img");
    if (twtBtn) {
        twtBtn.addEventListener("click", () => {
            sendEvent(petaGA_GameCategory_Game, 'Share Video Twitter', 'Pokémon Red White and Blue - Share Video Twitter');
        });
    }
    let regScrLink = popUpWindow.document.querySelector("#container > p:nth-child(3) > a:nth-child(4)");
    if (regScrLink) {
        regScrLink.addEventListener("click", () => {
            sendEvent(petaGA_GameCategory_Game, 'Bonus Wallpaper Regular', 'Pokémon Red White and Blue - Bonus Wallpaper Regular');
        });
    }
    let wideScrLink = popUpWindow.document.querySelector("#container > p:nth-child(3) > a:nth-child(5)");
    if (wideScrLink) {
        wideScrLink.addEventListener("click", () => {
            sendEvent(petaGA_GameCategory_Game, 'Bonus Wallpaper Wide', 'Pokémon Red White and Blue - Bonus Wallpaper Wide');
        });
    }
    let dwnlNowLink = popUpWindow.document.querySelector("#container > p:nth-child(3) > a");
    if (dwnlNowLink) {
        dwnlNowLink.addEventListener("click", () => {
            sendEvent(petaGA_GameCategory_Game, 'Bonus Trading Cards', 'Pokémon Red White and Blue - Bonus Trading Cards');
        });
    }
}
function isEmpty(arg) {
    return !(arg !== undefined && arg !== null && (typeof arg !== "string" || arg.length > 0));
}
function toGlobal(object, point) {
    let pos = point ? { x: point.x, y: point.y } : { x: 0, y: 0 };
    let parentContainer = object;
    while (parentContainer) {
        pos.x *= parentContainer.scaleX;
        pos.y *= parentContainer.scaleY;
        pos.x += parentContainer.x;
        pos.y += parentContainer.y;
        parentContainer = parentContainer.parentContainer;
    }
    return pos;
}
let game;
window.onload = () => {
    pbawp.code.FontHelper.rewriteWordWrapping();
    game = new pbawp.App();
};
function DetectPhaserRenderMode() {
    return Phaser.WEBGL;
    /*var ua = window.navigator.userAgent;
    var isIE = ua.indexOf('MSIE ') > 0 || ua.indexOf('Trident/') > 0;
    var isOldIPhone = (ua.indexOf('iPhone ') > -1 && window.screen.width <= 414 && window.screen.height <= 736);
    var isFirefox = ua.toLowerCase().indexOf('firefox') > -1;
    var isAndroid = ua.toLowerCase().indexOf("android") > -1;
    return isIE || isFirefox || isOldIPhone || isAndroid ? Phaser.CANVAS : Phaser.AUTO;*/
}
;
function delayedCall(delay, callback, args, callbackScope) {
    let scene = game.scene.getAt(0);
    if (scene) {
        return scene.time.delayedCall(delay, callback, args, callbackScope);
    }
    return setTimeout(callback, delay);
}
/**
 * @author Roman Parada
 * This class is created to fix overlapping of bottom part of canvas by navigation bar in iOS.
 * It make a delayed resize of the canvas (like Phaser-3 FIT methods does) and it overrides Phaser-3 input window to Phaser-3 core transform methods
 *
 * How to use:
 * Just call the code line below in Boot scene's init() method of your project:
 * new FitScaleManager(this.game).setup();
 */
class FitScaleManager {
    constructor(game) {
        this.doResize = () => {
            let scale = this.calculateScale();
            let newCanvasWidth = this.phaserScaleManager.width * scale;
            let newCanvasHeight = this.phaserScaleManager.height * scale;
            this.canvasStyle.width = newCanvasWidth + 'px';
            this.canvasStyle.height = newCanvasHeight + 'px';
            this.canvasStyle.marginLeft = (window.innerWidth - newCanvasWidth) / 2 + 'px';
            this.canvasStyle.marginTop = (window.innerHeight - newCanvasHeight) / 2 + 'px';
        };
        this.game = game;
        this.canvasStyle = this.game.canvas.style;
        this.phaserScaleManager = this.game.scale;
    }
    static detectBestScaleMode() {
        // let iOS = /iPad|iPhone|iPod/.test(navigator.platform || "");
        // let isAndroid = window.navigator.userAgent.toLowerCase().indexOf("android") > -1;
        // return iOS || isAndroid ? Phaser.Scale.FIT : Phaser.Scale.NONE;
        return Phaser.Scale.FIT;
    }
    ;
    /**
     * Just call this method once in Boot scene's init() method
     */
    setup() {
        this.phaserScaleManager.addListener(Phaser.Scale.Events.RESIZE, this.onResize, this);
        this.overridePhaserTransformMethods();
        this.onResize();
    }
    calculateScale() {
        if (game.scale.scaleMode == Phaser.Scale.NONE)
            return 1;
        return Math.min(window.innerWidth / this.phaserScaleManager.width, window.innerHeight / this.phaserScaleManager.height);
    }
    overridePhaserTransformMethods() {
        this.game.scale.transformX = (pageX) => {
            return (pageX - parseInt(this.canvasStyle.marginLeft.split("px")[0])) / this.calculateScale();
        };
        this.game.scale.transformY = (pageY) => {
            return (pageY - parseInt(this.canvasStyle.marginTop.split("px")[0])) / this.calculateScale();
        };
    }
    onResize() {
        setTimeout(this.doResize, FitScaleManager.RESIZE_DELAY);
    }
}
FitScaleManager.RESIZE_DELAY = 500;
var pbawp;
(function (pbawp) {
    var assets;
    (function (assets) {
        var fla;
        (function (fla) {
            class GenderIcon extends Phaser.GameObjects.Container {
                constructor(scene) {
                    super(scene);
                    this.male = this.scene.add.image(0, 0, 'ui-atlas', 'male' + '0000');
                    this.add(this.male);
                    this.female = this.scene.add.image(0, 0, 'ui-atlas', 'female' + '0000');
                    this.add(this.female);
                }
                gotoAndStop(label) {
                    if (label == "female") {
                        this.female.visible = true;
                        this.female.setPosition(0, 0);
                        this.male.visible = false;
                    }
                    else if (label == "male") {
                        this.female.visible = false;
                        this.male.visible = true;
                        this.male.setPosition(0, 0);
                    }
                    else if (label == "plural") {
                        this.female.visible = true;
                        this.female.setPosition(5, 0);
                        this.male.visible = true;
                        this.male.setPosition(-17, 0);
                    }
                }
                calculateWidth() {
                    return (this.male.width + this.female.width) + this.male.x + this.female.x;
                }
            }
            fla.GenderIcon = GenderIcon;
        })(fla = assets.fla || (assets.fla = {}));
    })(assets = pbawp.assets || (pbawp.assets = {}));
})(pbawp || (pbawp = {}));
var pbawp;
(function (pbawp) {
    var assets;
    (function (assets) {
        var fla;
        (function (fla) {
            class _AttackButton extends Phaser.GameObjects.Container {
                constructor(scene) {
                    super(scene);
                    this.background = new Phaser.GameObjects.Image(this.scene, 0, 0, 'ui-atlas', '_AttackButton_background' + '0000');
                    this.add(this.background);
                    this.elementSymbol = new Phaser.GameObjects.Image(this.scene, -41, 10, 'ui-atlas', 'elementSymbol' + '0000');
                    this.add(this.elementSymbol);
                    this.hoverImage = new Phaser.GameObjects.Image(this.scene, 0, 0, 'ui-atlas', '_AttackButton_hoverImage' + '0000');
                    this.add(this.hoverImage);
                    this.moveName = this.scene.add.text(-50, -18, "Thunder Shock", {
                        "fontFamily": "Agency FB",
                        "fontSize": 18,
                        "color": "#FFFFFF",
                        "align": 'left'
                    });
                    this.add(this.moveName);
                    this.ppAmount = this.scene.add.text(15, 2, "25/25", {
                        "fontFamily": "Agency FB",
                        "fontSize": 10,
                        "color": "#FFFFFF",
                        "align": 'left'
                    });
                    this.add(this.ppAmount);
                    this.ppText = this.scene.add.text(1, 2, "PP", {
                        "fontFamily": "Agency FB",
                        "fontSize": 10,
                        "color": "#FFFFFF",
                        "align": 'left'
                    });
                    this.add(this.ppText);
                }
                backgroundGotoAndStop(label) {
                    if (label == "topLeft" || label == "bottomRight") {
                        this.background.scaleX = 1;
                    }
                    else {
                        this.background.scaleX = -1;
                    }
                }
                backgroundButtonGotoAndStop(label) {
                    let map = {
                        'normalOut': '0000',
                        'normalOver': '0009',
                        'normalDown': '0019',
                        'petaOut': '0029',
                        'petaOver': '0039',
                        'petaDown': '0049',
                        'electricOut': '0059',
                        'electricOver': '0069',
                        'electricDown': '0079',
                        'grassOut': '0089',
                        'grassOver': '0099',
                        'grassDown': '0109',
                        'fireOut': '0119',
                        'fireOver': '0129',
                        'fireDown': '0139',
                        'waterOut': '0149',
                        'waterOver': '0159',
                        'waterDown': '0169'
                    };
                    this.background.setFrame('_AttackButton_background' + (map[label] ? map[label] : '0000'));
                }
                elementSymbolGotoAndStop(label) {
                    let map = {
                        'normal': '0000',
                        'peta': '0009',
                        'electric': '0019',
                        'fire': '0029',
                        'water': '0039',
                        'grass': '0049',
                    };
                    this.elementSymbol.setFrame('elementSymbol' + (map[label] ? map[label] : '0000'));
                }
                hoverImageGotoAndStop(label) {
                    let map = {
                        'electric': '0000',
                        'peta': '0009',
                        'normal': '0019',
                        'grass': '0029',
                        'fire': '0039',
                        'water': '0049'
                    };
                    this.hoverImage.setFrame('_AttackButton_hoverImage' + (map[label] ? map[label] : '0000'));
                }
                gotoAndStop(label) {
                    if (label == "disabled") {
                        this.elementSymbol.alpha = 0.5;
                        this.background.alpha = 0.5;
                    }
                    else {
                        this.elementSymbol.alpha = 1;
                        this.background.alpha = 1;
                    }
                }
            }
            fla._AttackButton = _AttackButton;
        })(fla = assets.fla || (assets.fla = {}));
    })(assets = pbawp.assets || (pbawp.assets = {}));
})(pbawp || (pbawp = {}));
var pbawp;
(function (pbawp) {
    var assets;
    (function (assets) {
        var fla;
        (function (fla) {
            class _BattleManager extends Phaser.GameObjects.Container {
                constructor(scene) {
                    super(scene);
                    this.background = this.scene.add.image(0, 0, 'BattleManager_background-atlas', '_BattleManager_background' + '0000').setOrigin(0, 0);
                    this.add(this.background);
                    this.background["gotoAndStop"] = (label) => {
                        let map = {
                            'stadium': '0000',
                            'grass': '0009',
                            'desert': '0019',
                            'night': '0029'
                        };
                        this.background.setFrame('_BattleManager_background' + map[label]);
                    };
                    this.background2 = this.scene.add.image(0, 0, 'BattleManager_background-atlas', '_BattleManager_background' + '0000').setOrigin(0, 0);
                    this.add(this.background2);
                    this.background2["gotoAndStop"] = (label) => {
                        let map = {
                            'stadium': '0000',
                            'grass': '0009',
                            'desert': '0019',
                            'night': '0029'
                        };
                        this.background2.setFrame('_BattleManager_background' + map[label]);
                    };
                    this.opponentBattleInfo = new fla._OpponentBattleInfo(this.scene);
                    this.opponentBattleInfo.setPosition(130, 47);
                    this.add(this.opponentBattleInfo);
                    this.playerBattleInfo = new fla._PlayerBattleInfo(this.scene);
                    this.playerBattleInfo.setPosition(464, 354);
                    this.add(this.playerBattleInfo);
                    this.opponent = new Phaser.GameObjects.Container(this.scene);
                    this.opponent.setPosition(0, 0);
                    this.add(this.opponent);
                    this.player = new Phaser.GameObjects.Container(this.scene);
                    this.player.setPosition(0, 0);
                    this.add(this.player);
                    this.opponentPokemon = new Phaser.GameObjects.Container(this.scene);
                    this.opponentPokemon.setPosition(135, 15);
                    this.add(this.opponentPokemon);
                    this.opponentMask = new Phaser.GameObjects.Graphics(this.scene);
                    this.opponentMask.setPosition(0, -300);
                    this.opponentMask.fillStyle(0xFFFFFF, 1);
                    this.opponentMask.fillRect(0, 0, 600, 270);
                    this.opponent.setMask(this.opponentMask.createGeometryMask());
                    this.playerMask = new Phaser.GameObjects.Graphics(this.scene);
                    this.playerMask.setPosition(600, -260);
                    this.playerMask.fillStyle(0xFFFFFF, 1);
                    this.playerMask.fillRect(0, 0, 600, 490);
                    this.player.setMask(this.playerMask.createGeometryMask());
                    this.dialogBox = new fla._DialogBox(this.scene);
                    this.dialogBox.setPosition(6, 379);
                    this.add(this.dialogBox);
                    this.advanceDialogButton = this.scene.add.image(-5, 360, 'ui-atlas', 'advanceDialogButton' + '0000').setOrigin(0, 0);
                    this.add(this.advanceDialogButton);
                }
            }
            fla._BattleManager = _BattleManager;
        })(fla = assets.fla || (assets.fla = {}));
    })(assets = pbawp.assets || (pbawp.assets = {}));
})(pbawp || (pbawp = {}));
var pbawp;
(function (pbawp) {
    var assets;
    (function (assets) {
        var fla;
        (function (fla) {
            class _Credits extends Phaser.GameObjects.Container {
                constructor(scene) {
                    super(scene);
                    let bg = new Phaser.GameObjects.Image(this.scene, 0, 0, 'ui-atlas', '_CreditsBG' + '0000');
                    bg.setOrigin(0, 0);
                    this.add(bg);
                    this.backButton = new pbawp.util.BasicLabeledButton(this.scene, 300, 454, 'ui-atlas', 'GO!');
                    this.add(this.backButton);
                }
            }
            fla._Credits = _Credits;
        })(fla = assets.fla || (assets.fla = {}));
    })(assets = pbawp.assets || (pbawp.assets = {}));
})(pbawp || (pbawp = {}));
var pbawp;
(function (pbawp) {
    var assets;
    (function (assets) {
        var fla;
        (function (fla) {
            class _DialogBox extends Phaser.GameObjects.Container {
                constructor(scene) {
                    super(scene);
                    this.dialogBackground = new Phaser.GameObjects.Image(this.scene, 294, 56, 'ui-atlas', 'dialogBackground' + '0000');
                    this.add(this.dialogBackground);
                    this.dialogArrow = new Phaser.GameObjects.Container(this.scene, 541, 79);
                    this.add(this.dialogArrow);
                    let arrow = new Phaser.GameObjects.Image(this.scene, 0, 0, 'ui-atlas', 'arrow' + '0000');
                    this.dialogArrow.add(arrow);
                    this.dialogArrow["arrow"] = arrow;
                    this.scene.time.addEvent({
                        delay: 550,
                        callback: () => { arrow.alpha = arrow.alpha == 1 ? 0 : 1; },
                        loop: true
                    });
                    this.dialogText = this.scene.add.text(30, 19, "", {
                        "fontFamily": "Banda Regular",
                        "fontSize": 16,
                        "color": "#FFFFFF",
                        "align": 'left'
                    });
                    this.add(this.dialogText);
                    this.dialogText.setWordWrapWidth(504);
                    this.backButton = new pbawp.util.BasicButton(this.scene, 540, 330, 'ui-atlas', 'backButton' + '0000', 'backButton' + '0001', 'backButton' + '0002');
                    this.add(this.backButton);
                    this.continueButton = new pbawp.util.BasicLabeledButton(this.scene, 267, 619, 'ui-atlas', 'CONTINUE');
                    this.add(this.continueButton);
                    this.pokemonName = this.scene.add.text(300, 449, "", {
                        "fontFamily": "Banda Regular",
                        "fontSize": 22,
                        "color": "#FFFFFF",
                        "align": 'center'
                    });
                    this.add(this.pokemonName);
                    this.pokemonName.setOrigin(0.5, 0);
                    this.pokemonName.setWordWrapWidth(561);
                    this.sendInButton = new pbawp.util.BasicLabeledButton(this.scene, 172, 515, 'ui-atlas', 'SEND IN');
                    this.add(this.sendInButton);
                    this.statsButton = new pbawp.util.BasicLabeledButton(this.scene, 172, 515, 'ui-atlas', 'SUMMARY');
                    this.add(this.statsButton);
                    this.pokemonButton1 = new fla._PokemonSelectButton(this.scene);
                    this.pokemonButton1.setPosition(659, 518);
                    this.add(this.pokemonButton1);
                    this.pokemonButton2 = new fla._PokemonSelectButton(this.scene);
                    this.pokemonButton2.setPosition(659, 588);
                    this.add(this.pokemonButton2);
                    this.pokemonButton3 = new fla._PokemonSelectButton(this.scene);
                    this.pokemonButton3.setPosition(949, 518);
                    this.add(this.pokemonButton3);
                    this.pokemonButton4 = new fla._PokemonSelectButton(this.scene);
                    this.pokemonButton4.setPosition(949, 588);
                    this.add(this.pokemonButton4);
                    this.battleButton = new pbawp.util.BasicLabeledButton(this.scene, 280, 549, 'ui-atlas', 'BATTLE');
                    this.add(this.battleButton);
                    this.yesButton = new pbawp.util.BasicLabeledButton(this.scene, 187, 267, 'ui-atlas', 'YES');
                    this.add(this.yesButton);
                    this.noButton = new pbawp.util.BasicLabeledButton(this.scene, 385, 267, 'ui-atlas', 'NO');
                    this.add(this.noButton);
                    this.skipButton = new pbawp.util.BasicLabeledButton(this.scene, 196, 482, 'ui-atlas', 'SKIP');
                    this.add(this.skipButton);
                    this.watchButton = new pbawp.util.BasicLabeledButton(this.scene, 363, 482, 'ui-atlas', 'VIEW');
                    this.add(this.watchButton);
                    this.ignoreButton = new pbawp.util.BasicLabeledButton(this.scene, 187, 417, 'ui-atlas', 'IGNORE');
                    this.add(this.ignoreButton);
                    this.openButton = new pbawp.util.BasicLabeledButton(this.scene, 365, 417, 'ui-atlas', 'OPEN');
                    this.add(this.openButton);
                    this._underline = new Phaser.GameObjects.Image(this.scene, 303, 42, 'ui-atlas', '_underline' + '0000');
                    this._underline.setOrigin(0, 0);
                    this._underline.visible = false;
                    this.add(this._underline);
                    this.submitButton = new pbawp.util.BasicLabeledButton(this.scene, 365, 417, 'ui-atlas', 'SUBMIT');
                    this.add(this.submitButton);
                    this.newPokemonName = new fla._NamePokemonTextField(this.scene);
                    this.newPokemonName.setPosition(103, 418);
                    this.add(this.newPokemonName);
                    this.fightButton = new pbawp.util.BasicLabeledButton(this.scene, 330, 215, 'ui-atlas', 'Fight!', 'fightButton');
                    this.add(this.fightButton);
                    this.pokemonButton = new pbawp.util.BasicLabeledButton(this.scene, 330, 254, 'ui-atlas', 'Pokemon', 'pokemonButton');
                    this.add(this.pokemonButton);
                    this.attackButton1 = new fla._AttackButton(this.scene);
                    this.attackButton1.setPosition(20, 299);
                    this.add(this.attackButton1);
                    this.attackButton2 = new fla._AttackButton(this.scene);
                    this.attackButton2.setPosition(20, 349);
                    this.add(this.attackButton2);
                    this.attackButton4 = new fla._AttackButton(this.scene);
                    this.attackButton4.setPosition(310, 349);
                    this.add(this.attackButton4);
                    this.attackButton3 = new fla._AttackButton(this.scene);
                    this.attackButton3.setPosition(310, 299);
                    this.add(this.attackButton3);
                }
                dialogBackgroundGotoAndStop(label) {
                    let map = {
                        'full': '0000',
                        'half': '0009',
                        'speechBubble': '0019',
                        'map': '0029'
                    };
                    this.dialogBackground.setFrame('dialogBackground' + map[label]);
                }
                dialogArrowGotoAndStop(label) {
                    if (label == "start") {
                        this.dialogArrow.visible = true;
                    }
                    else {
                        this.dialogArrow.visible = false;
                    }
                }
                dialogArrowArrowGotoAndStop(label) {
                    if (label == "white") {
                        this.dialogArrow["arrow"].setFrame('arrow' + '0000');
                    }
                    else if (label == "black") {
                        this.dialogArrow["arrow"].setFrame('arrow' + '0009');
                    }
                }
                gotoAndStop(label) {
                    if (label == "dialogOnly") {
                        this.dialogBackground.setPosition(295, 56);
                        this.dialogArrow.setPosition(541, 79);
                        this.dialogText.setPosition(30, 19);
                        this.dialogText.setWordWrapWidth(504);
                        this.dialogText.setColor('#FFFFFF');
                        this.backButton.setPosition(540, 330);
                        this.continueButton.setPosition(269, 619);
                        this.pokemonName.setPosition(300, 449);
                        this.sendInButton.setPosition(172, 515);
                        this.statsButton.setPosition(382, 515);
                        this.pokemonButton1.setPosition(659, 518);
                        this.pokemonButton2.setPosition(659, 588);
                        this.pokemonButton3.setPosition(949, 518);
                        this.pokemonButton4.setPosition(949, 588);
                        this.battleButton.setPosition(280, 549);
                        this.yesButton.setPosition(187, 267);
                        this.noButton.setPosition(385, 267);
                        this.skipButton.setPosition(196, 482);
                        this.watchButton.setPosition(363, 482);
                        this.ignoreButton.setPosition(187, 417);
                        this.openButton.setPosition(365, 417);
                        this._underline.visible = false;
                        this.newPokemonName.setPosition(103, 418);
                        this.submitButton.setPosition(429, 420);
                        this.pokemonButton.setPosition(330, 254);
                        this.fightButton.setPosition(330, 215);
                        this.attackButton1.setPosition(120, 299);
                        this.attackButton2.setPosition(130, 349);
                        this.attackButton4.setPosition(310, 349);
                        this.attackButton3.setPosition(310, 299);
                    }
                    else if (label == "mainMenu") {
                        this.dialogBackground.setPosition(295, 56);
                        this.dialogArrow.setPosition(541, 79);
                        this.dialogText.setPosition(30, 19);
                        this.dialogText.setWordWrapWidth(200);
                        this.dialogText.setColor('#FFFFFF');
                        this.backButton.setPosition(540, 330);
                        this.continueButton.setPosition(269, 619);
                        this.pokemonName.setPosition(300, 449);
                        this.sendInButton.setPosition(172, 515);
                        this.statsButton.setPosition(382, 515);
                        this.pokemonButton1.setPosition(659, 518);
                        this.pokemonButton2.setPosition(659, 588);
                        this.pokemonButton3.setPosition(949, 518);
                        this.pokemonButton4.setPosition(949, 588);
                        this.battleButton.setPosition(280, 549);
                        this.yesButton.setPosition(187, 267);
                        this.noButton.setPosition(385, 267);
                        this.skipButton.setPosition(196, 482);
                        this.watchButton.setPosition(363, 482);
                        this.ignoreButton.setPosition(187, 417);
                        this.openButton.setPosition(365, 417);
                        this._underline.visible = false;
                        this.newPokemonName.setPosition(103, 418);
                        this.submitButton.setPosition(429, 420);
                        this.pokemonButton.setPosition(421, 86);
                        this.fightButton.setPosition(421, 29);
                        this.attackButton1.setPosition(120, 299);
                        this.attackButton2.setPosition(130, 349);
                        this.attackButton4.setPosition(310, 349);
                        this.attackButton3.setPosition(310, 299);
                    }
                    else if (label == "fight") {
                        this.dialogBackground.setPosition(295, 56);
                        this.dialogArrow.setPosition(541, 79);
                        this.dialogText.setPosition(30, 19);
                        this.dialogText.setWordWrapWidth(200);
                        this.dialogText.setColor('#FFFFFF');
                        this.backButton.setPosition(578, 85);
                        this.continueButton.setPosition(269, 619);
                        this.pokemonName.setPosition(300, 449);
                        this.sendInButton.setPosition(172, 515);
                        this.statsButton.setPosition(382, 515);
                        this.pokemonButton1.setPosition(659, 518);
                        this.pokemonButton2.setPosition(659, 588);
                        this.pokemonButton3.setPosition(949, 518);
                        this.pokemonButton4.setPosition(949, 588);
                        this.battleButton.setPosition(280, 549);
                        this.yesButton.setPosition(187, 267);
                        this.noButton.setPosition(385, 267);
                        this.skipButton.setPosition(196, 482);
                        this.watchButton.setPosition(363, 482);
                        this.ignoreButton.setPosition(187, 417);
                        this.openButton.setPosition(365, 417);
                        this._underline.visible = false;
                        this.newPokemonName.setPosition(103, 418);
                        this.submitButton.setPosition(429, 420);
                        this.pokemonButton.setPosition(330, 254);
                        this.fightButton.setPosition(330, 215);
                        this.attackButton1.setPosition(355, 28);
                        this.attackButton2.setPosition(355, 84);
                        this.attackButton4.setPosition(492, 84);
                        this.attackButton3.setPosition(492, 28);
                    }
                    else if (label == "pokemonGet") {
                        this.dialogBackground.setPosition(295, 56);
                        this.dialogArrow.setPosition(541, 79);
                        this.dialogText.setPosition(30, 19);
                        this.dialogText.setWordWrapWidth(504);
                        this.dialogText.setColor('#FFFFFF');
                        this.backButton.setPosition(548, 345);
                        this.continueButton.setPosition(269, 619);
                        this.pokemonName.setPosition(300, 449);
                        this.sendInButton.setPosition(172, 515);
                        this.statsButton.setPosition(382, 515);
                        this.pokemonButton1.setPosition(659, 518);
                        this.pokemonButton2.setPosition(659, 588);
                        this.pokemonButton3.setPosition(949, 518);
                        this.pokemonButton4.setPosition(949, 588);
                        this.battleButton.setPosition(280, 549);
                        this.yesButton.setPosition(187, 267);
                        this.noButton.setPosition(385, 267);
                        this.skipButton.setPosition(196, 482);
                        this.watchButton.setPosition(363, 482);
                        this.ignoreButton.setPosition(187, 417);
                        this.openButton.setPosition(365, 417);
                        this._underline.visible = true;
                        this.newPokemonName.setPosition(300, 20);
                        this.submitButton.setPosition(289, 80);
                        this.pokemonButton.setPosition(330, 254);
                        this.fightButton.setPosition(330, 215);
                        this.attackButton1.setPosition(20, 299);
                        this.attackButton2.setPosition(20, 349);
                        this.attackButton4.setPosition(310, 349);
                        this.attackButton3.setPosition(310, 299);
                    }
                    else if (label == "mapDialog") {
                        this.dialogBackground.setPosition(295, 56);
                        this.dialogArrow.setPosition(543, 95);
                        this.dialogText.setPosition(18, 36);
                        this.dialogText.setWordWrapWidth(534);
                        this.dialogText.setColor('#000000');
                        this.backButton.setPosition(548, 345);
                        this.continueButton.setPosition(269, 619);
                        this.pokemonName.setPosition(300, 449);
                        this.sendInButton.setPosition(172, 515);
                        this.statsButton.setPosition(382, 515);
                        this.pokemonButton1.setPosition(659, 518);
                        this.pokemonButton2.setPosition(659, 588);
                        this.pokemonButton3.setPosition(949, 518);
                        this.pokemonButton4.setPosition(949, 588);
                        this.battleButton.setPosition(280, 549);
                        this.yesButton.setPosition(187, 267);
                        this.noButton.setPosition(385, 267);
                        this.skipButton.setPosition(196, 482);
                        this.watchButton.setPosition(363, 482);
                        this.ignoreButton.setPosition(187, 417);
                        this.openButton.setPosition(365, 417);
                        this._underline.visible = false;
                        this.newPokemonName.setPosition(103, 418);
                        this.submitButton.setPosition(429, 420);
                        this.pokemonButton.setPosition(330, 254);
                        this.fightButton.setPosition(330, 215);
                        this.attackButton1.setPosition(20, 299);
                        this.attackButton2.setPosition(20, 349);
                        this.attackButton4.setPosition(310, 349);
                        this.attackButton3.setPosition(310, 299);
                    }
                    else if (label == "mapInfo") {
                        this.dialogBackground.setPosition(295, 56);
                        this.dialogArrow.setPosition(541, 94);
                        this.dialogText.setPosition(30, 8);
                        this.dialogText.setWordWrapWidth(504);
                        this.dialogText.setColor('#FFFFFF');
                        this.backButton.setPosition(548, 345);
                        this.continueButton.setPosition(269, 619);
                        this.pokemonName.setPosition(300, 449);
                        this.sendInButton.setPosition(172, 515);
                        this.statsButton.setPosition(382, 515);
                        this.pokemonButton1.setPosition(659, 518);
                        this.pokemonButton2.setPosition(659, 588);
                        this.pokemonButton3.setPosition(949, 518);
                        this.pokemonButton4.setPosition(949, 588);
                        this.battleButton.setPosition(280, 549);
                        this.yesButton.setPosition(187, 267);
                        this.noButton.setPosition(385, 267);
                        this.skipButton.setPosition(196, 482);
                        this.watchButton.setPosition(363, 482);
                        this.ignoreButton.setPosition(187, 417);
                        this.openButton.setPosition(365, 417);
                        this._underline.visible = false;
                        this.newPokemonName.setPosition(103, 418);
                        this.submitButton.setPosition(429, 420);
                        this.pokemonButton.setPosition(330, 254);
                        this.fightButton.setPosition(330, 215);
                        this.attackButton1.setPosition(20, 299);
                        this.attackButton2.setPosition(20, 349);
                        this.attackButton4.setPosition(310, 349);
                        this.attackButton3.setPosition(310, 299);
                    }
                    else if (label == "treasureFind") {
                        this.dialogBackground.setPosition(295, 56);
                        this.dialogArrow.setPosition(541, 94);
                        this.dialogText.setPosition(30, 8);
                        this.dialogText.setWordWrapWidth(515);
                        this.dialogText.setColor('#FFFFFF');
                        this.backButton.setPosition(548, 345);
                        this.continueButton.setPosition(269, 619);
                        this.pokemonName.setPosition(300, 449);
                        this.sendInButton.setPosition(172, 515);
                        this.statsButton.setPosition(382, 515);
                        this.pokemonButton1.setPosition(659, 518);
                        this.pokemonButton2.setPosition(659, 588);
                        this.pokemonButton3.setPosition(949, 518);
                        this.pokemonButton4.setPosition(949, 588);
                        this.battleButton.setPosition(280, 549);
                        this.yesButton.setPosition(187, 267);
                        this.noButton.setPosition(385, 267);
                        this.skipButton.setPosition(196, 482);
                        this.watchButton.setPosition(363, 482);
                        this.ignoreButton.setPosition(187, 77);
                        this.openButton.setPosition(385, 77);
                        this._underline.visible = false;
                        this.newPokemonName.setPosition(103, 418);
                        this.submitButton.setPosition(429, 420);
                        this.pokemonButton.setPosition(330, 254);
                        this.fightButton.setPosition(330, 215);
                        this.attackButton1.setPosition(20, 299);
                        this.attackButton2.setPosition(20, 349);
                        this.attackButton4.setPosition(310, 349);
                        this.attackButton3.setPosition(310, 299);
                    }
                    else if (label == "treasureOpen") {
                        this.dialogBackground.setPosition(295, 56);
                        this.dialogArrow.setPosition(541, 94);
                        this.dialogText.setPosition(30, 8);
                        this.dialogText.setWordWrapWidth(515);
                        this.dialogText.setColor('#FFFFFF');
                        this.backButton.setPosition(548, 345);
                        this.continueButton.setPosition(269, 619);
                        this.pokemonName.setPosition(300, 449);
                        this.sendInButton.setPosition(172, 515);
                        this.statsButton.setPosition(382, 515);
                        this.pokemonButton1.setPosition(659, 518);
                        this.pokemonButton2.setPosition(659, 588);
                        this.pokemonButton3.setPosition(949, 518);
                        this.pokemonButton4.setPosition(949, 588);
                        this.battleButton.setPosition(280, 549);
                        this.yesButton.setPosition(187, 267);
                        this.noButton.setPosition(385, 267);
                        this.skipButton.setPosition(187, 77);
                        this.watchButton.setPosition(385, 77);
                        this.ignoreButton.setPosition(187, 417);
                        this.openButton.setPosition(365, 417);
                        this._underline.visible = false;
                        this.newPokemonName.setPosition(103, 418);
                        this.submitButton.setPosition(429, 420);
                        this.pokemonButton.setPosition(330, 254);
                        this.fightButton.setPosition(330, 215);
                        this.attackButton1.setPosition(20, 299);
                        this.attackButton2.setPosition(20, 349);
                        this.attackButton4.setPosition(310, 349);
                        this.attackButton3.setPosition(310, 299);
                    }
                    else if (label == "treasureAreYouSure") {
                        this.dialogBackground.setPosition(295, 56);
                        this.dialogArrow.setPosition(541, 94);
                        this.dialogText.setPosition(30, 8);
                        this.dialogText.setWordWrapWidth(515);
                        this.dialogText.setColor('#FFFFFF');
                        this.backButton.setPosition(548, 345);
                        this.continueButton.setPosition(269, 619);
                        this.pokemonName.setPosition(300, 449);
                        this.sendInButton.setPosition(172, 515);
                        this.statsButton.setPosition(382, 515);
                        this.pokemonButton1.setPosition(659, 518);
                        this.pokemonButton2.setPosition(659, 588);
                        this.pokemonButton3.setPosition(949, 518);
                        this.pokemonButton4.setPosition(949, 588);
                        this.battleButton.setPosition(280, 549);
                        this.yesButton.setPosition(187, 77);
                        this.noButton.setPosition(385, 77);
                        this.skipButton.setPosition(187, 337);
                        this.watchButton.setPosition(385, 337);
                        this.ignoreButton.setPosition(187, 417);
                        this.openButton.setPosition(365, 417);
                        this._underline.visible = false;
                        this.newPokemonName.setPosition(103, 418);
                        this.submitButton.setPosition(429, 420);
                        this.pokemonButton.setPosition(330, 254);
                        this.fightButton.setPosition(330, 215);
                        this.attackButton1.setPosition(20, 299);
                        this.attackButton2.setPosition(20, 349);
                        this.attackButton4.setPosition(310, 349);
                        this.attackButton3.setPosition(310, 299);
                    }
                    else if (label == "mapBattle") {
                        this.dialogBackground.setPosition(295, 56);
                        this.dialogArrow.setPosition(541, 94);
                        this.dialogText.setPosition(30, 8);
                        this.dialogText.setWordWrapWidth(515);
                        this.dialogText.setColor('#FFFFFF');
                        this.backButton.setPosition(548, 345);
                        this.continueButton.setPosition(269, 619);
                        this.pokemonName.setPosition(300, 449);
                        this.sendInButton.setPosition(172, 515);
                        this.statsButton.setPosition(382, 515);
                        this.pokemonButton1.setPosition(659, 518);
                        this.pokemonButton2.setPosition(659, 588);
                        this.pokemonButton3.setPosition(949, 518);
                        this.pokemonButton4.setPosition(949, 588);
                        this.battleButton.setPosition(294, 77);
                        this.yesButton.setPosition(187, 307);
                        this.noButton.setPosition(385, 307);
                        this.skipButton.setPosition(187, 337);
                        this.watchButton.setPosition(385, 337);
                        this.ignoreButton.setPosition(187, 417);
                        this.openButton.setPosition(365, 417);
                        this._underline.visible = false;
                        this.newPokemonName.setPosition(103, 418);
                        this.submitButton.setPosition(429, 420);
                        this.pokemonButton.setPosition(330, 254);
                        this.fightButton.setPosition(330, 215);
                        this.attackButton1.setPosition(20, 299);
                        this.attackButton2.setPosition(20, 349);
                        this.attackButton4.setPosition(310, 349);
                        this.attackButton3.setPosition(310, 299);
                    }
                    else if (label == "switchPokemon") {
                        this.dialogBackground.setPosition(295, 56);
                        this.dialogArrow.setPosition(541, 94);
                        this.dialogText.setPosition(30, 403);
                        this.dialogText.setWordWrapWidth(504);
                        this.dialogText.setColor('#FFFFFF');
                        this.backButton.setPosition(578, 85);
                        this.continueButton.setPosition(269, 619);
                        this.pokemonName.setPosition(300, 449);
                        this.sendInButton.setPosition(172, 515);
                        this.statsButton.setPosition(382, 515);
                        this.pokemonButton1.setPosition(140, 30);
                        this.pokemonButton2.setPosition(140, 85);
                        this.pokemonButton3.setPosition(420, 30);
                        this.pokemonButton4.setPosition(420, 85);
                        this.battleButton.setPosition(294, 519);
                        this.yesButton.setPosition(187, 307);
                        this.noButton.setPosition(385, 307);
                        this.skipButton.setPosition(187, 337);
                        this.watchButton.setPosition(385, 337);
                        this.ignoreButton.setPosition(187, 417);
                        this.openButton.setPosition(365, 417);
                        this._underline.visible = false;
                        this.newPokemonName.setPosition(103, 418);
                        this.submitButton.setPosition(429, 420);
                        this.pokemonButton.setPosition(330, 254);
                        this.fightButton.setPosition(330, 215);
                        this.attackButton1.setPosition(20, 299);
                        this.attackButton2.setPosition(20, 349);
                        this.attackButton4.setPosition(310, 349);
                        this.attackButton3.setPosition(310, 299);
                    }
                    else if (label == "confirmPokemon") {
                        this.dialogBackground.setPosition(295, 56);
                        this.dialogArrow.setPosition(541, 94);
                        this.dialogText.setPosition(30, 403);
                        this.dialogText.setWordWrapWidth(504);
                        this.dialogText.setColor('#FFFFFF');
                        this.backButton.setPosition(553, 77);
                        this.continueButton.setPosition(269, 619);
                        this.pokemonName.setPosition(300, 9);
                        this.sendInButton.setPosition(172, 75);
                        this.statsButton.setPosition(382, 75);
                        this.pokemonButton1.setPosition(659, 518);
                        this.pokemonButton2.setPosition(659, 588);
                        this.pokemonButton3.setPosition(949, 518);
                        this.pokemonButton4.setPosition(949, 588);
                        this.battleButton.setPosition(294, 519);
                        this.yesButton.setPosition(187, 307);
                        this.noButton.setPosition(385, 307);
                        this.skipButton.setPosition(187, 337);
                        this.watchButton.setPosition(385, 337);
                        this.ignoreButton.setPosition(187, 417);
                        this.openButton.setPosition(365, 417);
                        this._underline.visible = false;
                        this.newPokemonName.setPosition(103, 418);
                        this.submitButton.setPosition(429, 420);
                        this.pokemonButton.setPosition(330, 254);
                        this.fightButton.setPosition(330, 215);
                        this.attackButton1.setPosition(20, 299);
                        this.attackButton2.setPosition(20, 349);
                        this.attackButton4.setPosition(310, 349);
                        this.attackButton3.setPosition(310, 299);
                    }
                    else if (label == "treasureDone") {
                        this.dialogBackground.setPosition(295, 56);
                        this.dialogArrow.setPosition(541, 94);
                        this.dialogText.setPosition(30, 403);
                        this.dialogText.setWordWrapWidth(504);
                        this.dialogText.setColor('#FFFFFF');
                        this.backButton.setPosition(578, 265);
                        this.continueButton.setPosition(294, 77);
                        this.pokemonName.setPosition(300, 319);
                        this.sendInButton.setPosition(172, 385);
                        this.statsButton.setPosition(382, 385);
                        this.pokemonButton1.setPosition(659, 518);
                        this.pokemonButton2.setPosition(659, 588);
                        this.pokemonButton3.setPosition(949, 518);
                        this.pokemonButton4.setPosition(949, 588);
                        this.battleButton.setPosition(294, 519);
                        this.yesButton.setPosition(187, 307);
                        this.noButton.setPosition(385, 307);
                        this.skipButton.setPosition(187, 337);
                        this.watchButton.setPosition(385, 337);
                        this.ignoreButton.setPosition(187, 417);
                        this.openButton.setPosition(365, 417);
                        this._underline.visible = false;
                        this.newPokemonName.setPosition(103, 418);
                        this.submitButton.setPosition(429, 420);
                        this.pokemonButton.setPosition(330, 254);
                        this.fightButton.setPosition(330, 215);
                        this.attackButton1.setPosition(20, 299);
                        this.attackButton2.setPosition(20, 349);
                        this.attackButton4.setPosition(310, 349);
                        this.attackButton3.setPosition(310, 299);
                    }
                }
            }
            fla._DialogBox = _DialogBox;
        })(fla = assets.fla || (assets.fla = {}));
    })(assets = pbawp.assets || (pbawp.assets = {}));
})(pbawp || (pbawp = {}));
var pbawp;
(function (pbawp) {
    var assets;
    (function (assets) {
        var fla;
        (function (fla) {
            class _GameAlmostWin extends Phaser.GameObjects.Container {
                constructor(scene) {
                    super(scene);
                    this.skipButton = new Phaser.GameObjects.Image(this.scene, 0, 0, 'ui-atlas', '_GameAlmostWin_' + '0000');
                    this.skipButton.setOrigin(0, 0);
                    this.add(this.skipButton);
                }
            }
            fla._GameAlmostWin = _GameAlmostWin;
        })(fla = assets.fla || (assets.fla = {}));
    })(assets = pbawp.assets || (pbawp.assets = {}));
})(pbawp || (pbawp = {}));
var pbawp;
(function (pbawp) {
    var assets;
    (function (assets) {
        var fla;
        (function (fla) {
            class _GameOver extends Phaser.GameObjects.Container {
                constructor(scene) {
                    super(scene);
                    this.bg = new Phaser.GameObjects.Graphics(this.scene);
                    this.bg.fillStyle(0x000000, 1);
                    this.bg.fillRect(0, 0, game.scale.width, game.scale.height);
                    this.add(this.bg);
                    this.continueButton = new pbawp.util.BasicLabeledButton(this.scene, 200, 394, 'ui-atlas', 'CONTINUE');
                    this.add(this.continueButton);
                    this.treasureButton = new pbawp.util.BasicLabeledButton(this.scene, 402, 394, 'ui-atlas', 'TREASURE');
                    this.add(this.treasureButton);
                    this.quitButton = new pbawp.util.BasicLabeledButton(this.scene, 300, 458, 'ui-atlas', 'QUIT');
                    this.add(this.quitButton);
                    this.noButton = new pbawp.util.BasicLabeledButton(this.scene, 402, 458, 'ui-atlas', 'NO');
                    this.add(this.noButton);
                    this.yesButton = new pbawp.util.BasicLabeledButton(this.scene, 200, 458, 'ui-atlas', 'YES');
                    this.add(this.yesButton);
                    this.gameOverText = this.scene.add.text(game.scale.width / 2, 44, "GAME OVER", {
                        "fontFamily": "Agency FB Bold",
                        "fontSize": 60,
                        "color": "#FFFFFF",
                        "align": 'center'
                    });
                    this.gameOverText.setOrigin(0.5, 0.5);
                    this.add(this.gameOverText);
                    this.gameOver1 = this.scene.add.text(65, 133, "You have been defeated by the ruthless Trainer.\n" +
                        "\n" +
                        "Seek sanctuary in the nearest Pokémon Center, where you can recuperate before making another valiant attempt to take your message of compassion and respect toward all Pokémon to the World!", {
                        "fontFamily": "Banda Regular",
                        "fontSize": 23,
                        "color": "#FFFFFF",
                        "align": 'center'
                    });
                    this.add(this.gameOver1);
                    this.gameOver1.setWordWrapWidth(470);
                    this.areYouSureText = this.scene.add.text(game.scale.width / 2, 368, "ARE YOU SURE?", {
                        "fontFamily": "Agency FB Bold",
                        "fontSize": 35,
                        "color": "#FFFFFF",
                        "align": 'center'
                    });
                    this.areYouSureText.setOrigin(0.5, 0);
                    this.add(this.areYouSureText);
                    this.gameOverMask = new Phaser.GameObjects.Graphics(this.scene);
                    this.gameOverMask.setPosition(0, -47);
                    this.gameOverMask.fillStyle(0xFFFFFF, 1);
                    this.gameOverMask.fillRect(0, 0, 600, 181);
                    this.gameOver1.setMask(this.gameOverMask.createGeometryMask());
                }
            }
            fla._GameOver = _GameOver;
        })(fla = assets.fla || (assets.fla = {}));
    })(assets = pbawp.assets || (pbawp.assets = {}));
})(pbawp || (pbawp = {}));
var pbawp;
(function (pbawp) {
    var assets;
    (function (assets) {
        var fla;
        (function (fla) {
            class _GameWin extends Phaser.GameObjects.Container {
                constructor(scene) {
                    super(scene);
                    this.add(this.scene.add.image(0, 0, 'ui-atlas', '_GameWinBG' + '0000').setOrigin(0, 0));
                    this.creditsButton = new pbawp.util.BasicLabeledButton(this.scene, 83, 36, 'ui-atlas', 'CREDITS');
                    this.creditsButton.setScale(148 / 183);
                    this.add(this.creditsButton);
                    this.playAgainButton = new pbawp.util.BasicLabeledButton(this.scene, 103, 453, 'ui-atlas', 'PLAY AGAIN');
                    this.add(this.playAgainButton);
                    this.shareButton = new pbawp.util.BasicLabeledButton(this.scene, 300, 453, 'ui-atlas', 'SHARE VIDEO');
                    this.add(this.shareButton);
                    this.treasureButton = new pbawp.util.BasicLabeledButton(this.scene, 495, 453, 'ui-atlas', 'TREASURE');
                    this.add(this.treasureButton);
                    this.congratulationsText = this.scene.add.text(0, 160, "CONGRATULATIONS!" +
                        "YOU'VE WON!", {
                        "fontFamily": "Junegull-Regular",
                        "fontSize": 28,
                        "color": "#FFFFFF",
                        "align": 'center',
                        'stroke': '#35770D',
                        'strokeThickness': 6
                    });
                    this.congratulationsText.setWordWrapWidth(578);
                    this.add(this.congratulationsText);
                    this.winText = this.scene.add.text(0, 205, "You've uncovered the evil conspiracy to use cute cartoon characters to destroy kids' empathy and sell food made from tortured animals. If you believe in promoting empathy over exploitation, speak up for Pokémon and animal liberation by sharing the message of kindness for all beings.\n\nAnd stay tuned for \"Pokémon: Purple—a PETA Parody,\" a re-release of this game with no noticeable improvements, because it wouldn't be Pokémon if we didn't (soy) milk this thing for all it's worth.", {
                        "fontFamily": "Junegull-Regular",
                        "fontSize": 15,
                        "color": "#FEEB60",
                        "align": 'center',
                        'stroke': '#35770D',
                        'strokeThickness': 6,
                    });
                    this.add(this.winText);
                    this.winText.setWordWrapWidth(578);
                    this.winText.setLineSpacing(-3);
                    this.winTextMask = new Phaser.GameObjects.Graphics(this.scene);
                    this.winTextMask.setPosition(this.winText.x, 180);
                    this.winTextMask.fillStyle(0x000000, 1);
                    this.winTextMask.fillRect(0, 0, 600, 200);
                    this.winText.setMask(this.winTextMask.createGeometryMask());
                    this.cheatText = this.scene.add.text(0, 375, "PLAY AGAIN AND TYPE IN \"PETA\" ONE TIME DURING A BATTLE TO CALL IN SOME SPECIAL HELP!", {
                        "fontFamily": "Junegull-Regular",
                        "fontSize": 18,
                        "color": "#FFFFFF",
                        "align": 'center',
                        'stroke': '#35770D',
                        'strokeThickness': 4
                    });
                    this.add(this.cheatText);
                    this.cheatText.setWordWrapWidth(578);
                    this.cheatText.setLineSpacing(-3);
                    this.cheatTextMask = new Phaser.GameObjects.Graphics(this.scene);
                    this.cheatTextMask.setPosition(this.cheatText.x, 360);
                    this.cheatTextMask.fillStyle(0x000000, 1);
                    this.cheatTextMask.fillRect(0, 0, 600, 60);
                    this.cheatText.setMask(this.cheatTextMask.createGeometryMask());
                }
                static updateTextField(tf) {
                    tf.x = (game.scale.width - tf.width) / 2;
                }
                updateTextFields() {
                    _GameWin.updateTextField(this.congratulationsText);
                    _GameWin.updateTextField(this.winText);
                    _GameWin.updateTextField(this.cheatText);
                }
            }
            fla._GameWin = _GameWin;
        })(fla = assets.fla || (assets.fla = {}));
    })(assets = pbawp.assets || (pbawp.assets = {}));
})(pbawp || (pbawp = {}));
var pbawp;
(function (pbawp) {
    var assets;
    (function (assets) {
        var fla;
        (function (fla) {
            class _HealthBar extends Phaser.GameObjects.Image {
                constructor(scene) {
                    super(scene, 0, 0, 'ui-atlas', '_HealthBar_' + 'green' + '0000');
                    this.setOrigin(0, 0.5);
                }
                gotoAndStop(label) {
                    this.setFrame('_HealthBar_' + label + '0000');
                }
            }
            fla._HealthBar = _HealthBar;
        })(fla = assets.fla || (assets.fla = {}));
    })(assets = pbawp.assets || (pbawp.assets = {}));
})(pbawp || (pbawp = {}));
var pbawp;
(function (pbawp) {
    var assets;
    (function (assets) {
        var fla;
        (function (fla) {
            class _Help extends Phaser.GameObjects.Container {
                constructor(scene) {
                    super(scene);
                    this.add(this.bg = this.scene.add.image(0, 0, 'ui-atlas', '_Help_bg' + '0000').setOrigin(0, 0));
                    this.titleText = this.scene.add.text(game.scale.width / 2, 110, "HOW TO PLAY", {
                        "fontFamily": "Agency FB Bold",
                        "fontSize": 42,
                        "color": "#FFFFFF",
                        "align": 'center'
                    });
                    this.titleText.setOrigin(0.5, 0.5);
                    this.add(this.titleText);
                    this.helpText1 = this.scene.add.text(61, 284, "Select FIGHT to attack, or Pokémon to \n" +
                        "change Pokémon!", {
                        "fontFamily": "Banda Regular",
                        "fontSize": 13,
                        "color": "#FFFFFF",
                        "align": 'center'
                    });
                    this.add(this.helpText1);
                    this.helpText1.setWordWrapWidth(160);
                    this.helpText2 = this.scene.add.text(227, 284, "Each trainer &\n" +
                        "Pokémon is associated\n" +
                        "with an element.", {
                        "fontFamily": "Banda Regular",
                        "fontSize": 13,
                        "color": "#FFFFFF",
                        "align": 'center'
                    });
                    this.add(this.helpText2);
                    this.helpText2.setWordWrapWidth(160);
                    this.helpText3 = this.scene.add.text(400, 284, "Deal more damage\n" +
                        "by using the right\n" +
                        "attack type against\n" +
                        "each trainer!", {
                        "fontFamily": "Banda Regular",
                        "fontSize": 13,
                        "color": "#FFFFFF",
                        "align": 'center'
                    });
                    this.add(this.helpText3);
                    this.helpText3.setWordWrapWidth(160);
                    this.goButton = new pbawp.util.BasicLabeledButton(this.scene, 300, 385, 'ui-atlas', 'GO!');
                    this.add(this.goButton);
                    this.cancelButton = new pbawp.util.BasicButton(this.scene, 548, 94, 'ui-atlas', '_Stats_cancelButton' + '0000', '_Stats_cancelButton' + '0001', '_Stats_cancelButton' + '0002');
                    this.add(this.cancelButton);
                }
            }
            fla._Help = _Help;
        })(fla = assets.fla || (assets.fla = {}));
    })(assets = pbawp.assets || (pbawp.assets = {}));
})(pbawp || (pbawp = {}));
var pbawp;
(function (pbawp) {
    var assets;
    (function (assets) {
        var fla;
        (function (fla) {
            class _Intro extends Phaser.GameObjects.Container {
                constructor(scene) {
                    super(scene);
                    let bg = this.scene.add.graphics();
                    bg.fillStyle(0x000000, 1);
                    bg.fillRect(0, 0, game.scale.width, game.scale.height);
                    this.add(bg);
                    this._intro_characters_logo = new Phaser.GameObjects.Image(this.scene, game.scale.width / 2, game.scale.height / 2 + 85, 'ui-atlas', '_intro_characters_logo' + '0000');
                    this.add(this._intro_characters_logo);
                    this.intro1 = this.scene.add.text(62, 54, "", {
                        "fontFamily": "Banda Regular",
                        "fontSize": 15,
                        "color": "#FFFFFF",
                        "align": 'left'
                    });
                    this.add(this.intro1);
                    this.intro1.setWordWrapWidth(520);
                    this.intro2 = this.scene.add.text(62, 130, "", {
                        "fontFamily": "Banda Regular",
                        "fontSize": 15,
                        "color": "#FFFFFF",
                        "align": 'left'
                    });
                    this.add(this.intro2);
                    this.intro2.setWordWrapWidth(520);
                    this.intro3 = this.scene.add.text(62, 190, "", {
                        "fontFamily": "Banda Regular",
                        "fontSize": 15,
                        "color": "#FFFFFF",
                        "align": 'left'
                    });
                    this.add(this.intro3);
                    this.intro3.setWordWrapWidth(520);
                    this.goButton = new pbawp.util.BasicLabeledButton(this.scene, game.scale.width / 2, 453, 'ui-atlas', 'GO!');
                    this.add(this.goButton);
                }
            }
            fla._Intro = _Intro;
        })(fla = assets.fla || (assets.fla = {}));
    })(assets = pbawp.assets || (pbawp.assets = {}));
})(pbawp || (pbawp = {}));
var pbawp;
(function (pbawp) {
    var assets;
    (function (assets) {
        var fla;
        (function (fla) {
            class _Map extends Phaser.GameObjects.Container {
                constructor(scene) {
                    super(scene);
                    this.mapBackground = this.scene.add.image(0, -1015, 'mapBackgrounds-atlas', 'map0' + '0000').setOrigin(0, 0);
                    this.add(this.mapBackground);
                    this.mapBackground["gotoAndStop"] = (label) => {
                        this.mapBackground.setFrame(label + '0000');
                    };
                    this.mapBackground2 = this.scene.add.image(-610, -1525, 'mapBackgrounds-atlas', 'map0' + '0000').setOrigin(0, 0);
                    this.mapBackground2.setScale(1, 1.005); //fix
                    this.add(this.mapBackground2);
                    this.mapBackground2["gotoAndStop"] = (label) => {
                        this.mapBackground2.setFrame(label + '0000');
                    };
                    this.treasure = new Phaser.GameObjects.Container(this.scene, 295, 140);
                    this.add(this.treasure);
                    this.speechBubble = new fla._SpeechBubble(this.scene);
                    this.speechBubble.setPosition(296, 150);
                    this.add(this.speechBubble);
                    this.dialogBox = new fla._DialogBox(this.scene);
                    this.dialogBox.setPosition(6, 379);
                    this.add(this.dialogBox);
                    this.advanceDialogButton = this.scene.add.image(-5, 375, 'ui-atlas', 'advanceDialogButton' + '0000').setOrigin(0, 0);
                    this.add(this.advanceDialogButton);
                    window["_Map"] = this;
                }
                gotoAndStop(label) {
                    if (label == "characterSpeak") {
                        this.dialogBox.setPosition(6, 379);
                        this.advanceDialogButton.setPosition(-5, 330);
                    }
                    else {
                        if (label == "trainerWalkOff") {
                            this.dialogBox.setPosition(17, 937);
                        }
                        else if (label == "startBattleDialog") {
                            this.dialogBox.setPosition(6, 379);
                        }
                        else if (label == "dialog") {
                            this.dialogBox.setPosition(6, 379);
                        }
                        else if (label == "noDialog") {
                            this.dialogBox.setPosition(17, 917);
                        }
                        this.advanceDialogButton.setPosition(-5, 375 + 640);
                    }
                }
            }
            fla._Map = _Map;
        })(fla = assets.fla || (assets.fla = {}));
    })(assets = pbawp.assets || (pbawp.assets = {}));
})(pbawp || (pbawp = {}));
var pbawp;
(function (pbawp) {
    var assets;
    (function (assets) {
        var fla;
        (function (fla) {
            class _MenuMain extends Phaser.GameObjects.Container {
                constructor(scene) {
                    super(scene);
                    this.add(this.bg = this.scene.add.image(0, 0, 'preloader-atlas', '_Preloader_BG_english' + '0000').setOrigin(0, 0));
                    this.popLogo = this.scene.add.image(300, 471, 'ui-atlas', 'popLogo' + '0000');
                    this.add(this.popLogo);
                    this.petaLogo = this.scene.add.image(9, 5, 'ui-atlas', 'petaLogo_peta' + '0000');
                    this.petaLogo.setOrigin(0, 0);
                    this.add(this.petaLogo);
                    this.treasureButton = new pbawp.util.BasicLabeledButton(this.scene, 103, 453, 'ui-atlas', 'TREASURE');
                    this.add(this.treasureButton);
                    this.playButton = new pbawp.util.BasicLabeledButton(this.scene, 495, 453, 'ui-atlas', 'GO!');
                    this.add(this.playButton);
                    this.changeLanguageButton = new pbawp.util.BasicLabeledButton(this.scene, 481, 25, 'ui-atlas', 'GO!');
                    this.add(this.changeLanguageButton);
                    this.changeLanguageButton.setScale(0.75);
                }
                titleLogoGotoAndStop(label) {
                    this.bg.setFrame('_Preloader_BG_' + label + '0000');
                }
                popLogoGotoAndStop(label) {
                    this.popLogo.setFrame('popLogo' + (label == "chinese" ? '0001' : '0000'));
                }
                petaLogoGotoAndStop(label) {
                    this.petaLogo.setFrame('petaLogo' + '_' + label + '0000');
                }
            }
            fla._MenuMain = _MenuMain;
        })(fla = assets.fla || (assets.fla = {}));
    })(assets = pbawp.assets || (pbawp.assets = {}));
})(pbawp || (pbawp = {}));
var pbawp;
(function (pbawp) {
    var assets;
    (function (assets) {
        var fla;
        (function (fla) {
            class _NamePokemonTextField extends Phaser.GameObjects.Container {
                constructor(scene) {
                    super(scene);
                    this.pokemonNameDiv = null;
                    this.inputTextField = null;
                    this.inputTextFieldWidth = 236;
                    this.inputTextFieldHeight = 40;
                    this.inputTextFieldFontSize = 26;
                    this.inputTextFieldPosition = { x: 0, y: 7 };
                    this.adjustEmailInput = () => {
                        let globalPos = toGlobal(this, this.inputTextFieldPosition);
                        const px = 'px';
                        let pr = 1; //this.scene.game.device.os.desktop ? 1 : Math.min(this.scene.game.device.os.pixelRatio, 3);
                        this.inputTextField.style.width = Math.ceil(this.inputTextFieldWidth / pr / this.scene.game.scale.displayScale.x) + px;
                        this.inputTextField.style.height = this.inputTextFieldHeight + px;
                        this.inputTextField.style.fontSize = this.inputTextFieldFontSize / this.scene.game.scale.displayScale.y + px;
                        let mt = parseInt(this.scene.game.canvas.style.marginTop.split(px)[0]);
                        let ml = parseInt(game.canvas.style.marginLeft.split(px)[0]);
                        this.pokemonNameDiv.style.marginTop = (mt + Math.ceil(globalPos.y / pr / this.scene.game.scale.displayScale.y) - this.inputTextFieldHeight / 2) + px;
                        this.pokemonNameDiv.style.marginLeft = (ml + Math.ceil(globalPos.x / pr / this.scene.game.scale.displayScale.x)) + px;
                    };
                    this.cursor = new Phaser.GameObjects.Graphics(this.scene);
                    this.cursor.fillStyle(0x00FFA3, 1);
                    this.cursor["width"] = 6;
                    this.cursor.fillRect(2, -25 / 2, this.cursor["width"], 25);
                    this.cursor.setPosition(4, 7);
                    this.add(this.cursor);
                    this.scene.time.addEvent({
                        delay: 350,
                        callback: () => { if (this && this.cursor)
                            this.cursor.alpha = this.cursor.alpha == 1 ? 0 : 1; },
                        callbackScope: this,
                        loop: true
                    });
                    this.pokemonNameDiv = document.querySelector('#pokemonNameDiv');
                    this.inputTextField = document.querySelector('#pokemonInputId');
                }
                initializeInput() {
                    this.setInputTextFieldContainerVisible(true);
                    this.adjustEmailInput();
                    this.scene.game.scale.addListener(Phaser.Scale.Events.RESIZE, this.adjustEmailInput);
                }
                destroyInput() {
                    this.setInputTextFieldContainerVisible(false);
                    this.scene.game.scale.removeListener(Phaser.Scale.Events.RESIZE, this.adjustEmailInput);
                }
                setInputTextFieldContainerVisible(visible) {
                    document.querySelector('.inputContainer').style.display = visible ? 'block' : 'none';
                    if (visible) {
                        this.inputTextField.focus();
                    }
                }
            }
            fla._NamePokemonTextField = _NamePokemonTextField;
        })(fla = assets.fla || (assets.fla = {}));
    })(assets = pbawp.assets || (pbawp.assets = {}));
})(pbawp || (pbawp = {}));
var pbawp;
(function (pbawp) {
    var assets;
    (function (assets) {
        var fla;
        (function (fla) {
            class _OpponentBattleInfo extends Phaser.GameObjects.Container {
                constructor(scene) {
                    super(scene);
                    this.background = new Phaser.GameObjects.Image(this.scene, -1, 1, 'ui-atlas', '_OpponentBattleInfo_background' + '0000');
                    this.add(this.background);
                    this.healthBar = new fla._HealthBar(this.scene);
                    this.healthBar.setPosition(-92, -3);
                    this.add(this.healthBar);
                    this.displayName = this.scene.add.text(-75, -42, "This", {
                        "fontFamily": "Agency FB Bold",
                        "fontSize": 24,
                        "color": "#FFFFFF",
                        "align": 'left',
                        'stroke': '#000000',
                        'strokeThickness': 4
                    });
                    this.add(this.displayName);
                    this.gender = new pbawp.assets.fla.GenderIcon(this.scene);
                    this.gender.setPosition(-94, -31);
                    this.add(this.gender);
                }
                backgroundGotoAndStop(label) {
                    this.background.setFrame('_PlayerBattleInfo_background' + (label == "normal" ? '0000' : '0009'));
                }
                genderGotoAndStop(label) {
                    this.gender.gotoAndStop(label);
                }
            }
            fla._OpponentBattleInfo = _OpponentBattleInfo;
        })(fla = assets.fla || (assets.fla = {}));
    })(assets = pbawp.assets || (pbawp.assets = {}));
})(pbawp || (pbawp = {}));
var pbawp;
(function (pbawp) {
    var assets;
    (function (assets) {
        var fla;
        (function (fla) {
            class _Overlay extends Phaser.GameObjects.Container {
                constructor(scene) {
                    super(scene);
                    this.helpButton = new pbawp.util.BasicButton(this.scene, 538, 25, 'ui-atlas', 'helpButton' + '0000', 'helpButton' + '0001', 'helpButton' + '0002');
                    this.add(this.helpButton);
                    this.muteButton = new pbawp.util.BasicButton(this.scene, 573, 25, 'ui-atlas', 'muteButton' + '0000', 'muteButton' + '0001', 'muteButton' + '0002');
                    this.add(this.muteButton);
                    this.unmuteButton = new pbawp.util.BasicButton(this.scene, 573, 25, 'ui-atlas', 'unmuteButton' + '0000', 'unmuteButton' + '0001', 'unmuteButton' + '0002');
                    this.add(this.unmuteButton);
                    this.versionNo = this.scene.add.text(582, 50, 'v19', {
                        "fontFamily": "Junegull-Regular",
                        "fontSize": 12,
                        "color": "#000000",
                        "align": 'right'
                    });
                    this.add(this.versionNo);
                }
            }
            fla._Overlay = _Overlay;
        })(fla = assets.fla || (assets.fla = {}));
    })(assets = pbawp.assets || (pbawp.assets = {}));
})(pbawp || (pbawp = {}));
var pbawp;
(function (pbawp) {
    var assets;
    (function (assets) {
        var fla;
        (function (fla) {
            class _PlayerBattleInfo extends Phaser.GameObjects.Container {
                constructor(scene) {
                    super(scene);
                    this.background = new Phaser.GameObjects.Image(this.scene, -1, 1, 'ui-atlas', '_PlayerBattleInfo_background' + '0000');
                    this.add(this.background);
                    this.healthBar = new fla._HealthBar(this.scene);
                    this.healthBar.setPosition(-88, -7);
                    this.add(this.healthBar);
                    let _PlayerBattleInfo_fg = new Phaser.GameObjects.Image(this.scene, 85, -7, 'ui-atlas', '_PlayerBattleInfo_fg' + '0000');
                    _PlayerBattleInfo_fg.setOrigin(0, 0.5);
                    this.add(_PlayerBattleInfo_fg);
                    this.health = this.scene.add.text(-15, -1, "50 / 50", {
                        "fontFamily": "Agency FB Bold",
                        "fontSize": 10,
                        "color": "#FFFFFF",
                        "align": 'center'
                    });
                    this.add(this.health);
                    this.displayName = this.scene.add.text(-75, -45, "This", {
                        "fontFamily": "Agency FB Bold",
                        "fontSize": 24,
                        "color": "#FFFFFF",
                        "align": 'left',
                        'stroke': '#000000',
                        'strokeThickness': 4
                    });
                    this.add(this.displayName);
                    this.gender = new pbawp.assets.fla.GenderIcon(this.scene);
                    this.gender.setPosition(-94, -33);
                    this.add(this.gender);
                }
                backgroundGotoAndStop(label) {
                    this.background.setFrame('_PlayerBattleInfo_background' + (label == "normal" ? '0000' : '0009'));
                }
                genderGotoAndStop(label) {
                    this.gender.gotoAndStop(label);
                }
            }
            fla._PlayerBattleInfo = _PlayerBattleInfo;
        })(fla = assets.fla || (assets.fla = {}));
    })(assets = pbawp.assets || (pbawp.assets = {}));
})(pbawp || (pbawp = {}));
var pbawp;
(function (pbawp) {
    var assets;
    (function (assets) {
        var fla;
        (function (fla) {
            class _PokemonSelectButton extends Phaser.GameObjects.Container {
                constructor(scene) {
                    super(scene);
                    this.background = new Phaser.GameObjects.Image(this.scene, 0, 0, 'ui-atlas', '_PokemonSelectButton_background' + '0000');
                    this.add(this.background);
                    this._PokemonSelectButton_background_disabled = new Phaser.GameObjects.Image(this.scene, 10, 0, 'ui-atlas', '_PokemonSelectButton_background_disabled' + '0000');
                    this._PokemonSelectButton_background_disabled.visible = false;
                    this.add(this._PokemonSelectButton_background_disabled);
                    this.hoverImage = new Phaser.GameObjects.Image(this.scene, 0, 0, 'ui-atlas', '_PokemonSelectButton_hoverImage' + '0000');
                    this.add(this.hoverImage);
                    this.pokemonName = this.scene.add.text(-120, 0, "", {
                        "fontFamily": "Agency FB Bold",
                        "fontSize": 24,
                        "color": "#FFFFFF",
                        "align": 'right'
                    });
                    this.pokemonName.setOrigin(0, 0.5);
                    this.add(this.pokemonName);
                    this.pokemonHealth = this.scene.add.text(60, 0, "", {
                        "fontFamily": "Agency FB Bold",
                        "fontSize": 17,
                        "color": "#FFFFFF",
                        "align": 'right'
                    });
                    this.pokemonHealth.setOrigin(0, 0.5);
                    this.add(this.pokemonHealth);
                }
                backgroundButtonGotoAndStop(label) {
                    let map = {
                        'normalOut': '0000',
                        'normalOver': '0000',
                        'normalDown': '0000',
                        'petaOut': '0000',
                        'petaOver': '0000',
                        'petaDown': '0000',
                        'electricOut': '0059',
                        'electricOver': '0069',
                        'electricDown': '0079',
                        'grassOut': '0089',
                        'grassOver': '0099',
                        'grassDown': '0109',
                        'fireOut': '0119',
                        'fireOver': '0129',
                        'fireDown': '0139',
                        'waterOut': '0149',
                        'waterOver': '0159',
                        'waterDown': '0169',
                        'disabledTLBR': '0179',
                        'disabledTRBL': '0189'
                    };
                    this.background.setFrame('_PokemonSelectButton_background' + (map[label] ? map[label] : '0000'));
                }
                hoverImageGotoAndStop(label) {
                    let map = {
                        'electric': '0000',
                        'peta': '0000',
                        'normal': '0000',
                        'grass': '0029',
                        'fire': '0039',
                        'water': '0049'
                    };
                    this.hoverImage.setFrame('_PokemonSelectButton_hoverImage' + (map[label] ? map[label] : '0000'));
                }
                gotoAndStop(label) {
                    if (label == "disabled") {
                        this._PokemonSelectButton_background_disabled.visible = true;
                    }
                    else {
                        this._PokemonSelectButton_background_disabled.visible = false;
                    }
                }
            }
            fla._PokemonSelectButton = _PokemonSelectButton;
        })(fla = assets.fla || (assets.fla = {}));
    })(assets = pbawp.assets || (pbawp.assets = {}));
})(pbawp || (pbawp = {}));
var pbawp;
(function (pbawp) {
    var assets;
    (function (assets) {
        var fla;
        (function (fla) {
            class _Preloader extends Phaser.GameObjects.Container {
                constructor(scene) {
                    super(scene);
                    this.add(this.scene.add.image(0, 0, 'preloader-atlas', '_Preloader_BG_english' + '0000').setOrigin(0, 0));
                    this.add(this.scene.add.image(302, 481, 'preloader-atlas', 'loader' + '0000'));
                    this.bar = this.scene.add.image(72, 482, 'preloader-atlas', 'bar' + '0000');
                    this.bar.setOrigin(0, 0.5);
                    this.add(this.bar);
                    this.loadingText = this.scene.add.text(43, 482, "LOADING", {
                        "fontFamily": "Agency FB Bold",
                        "fontSize": 14,
                        "color": "#FFFFFF",
                        "align": 'center',
                    });
                    this.loadingText.setOrigin(0.5);
                    this.add(this.loadingText);
                }
            }
            fla._Preloader = _Preloader;
        })(fla = assets.fla || (assets.fla = {}));
    })(assets = pbawp.assets || (pbawp.assets = {}));
})(pbawp || (pbawp = {}));
var pbawp;
(function (pbawp) {
    var assets;
    (function (assets) {
        var fla;
        (function (fla) {
            class _SpeechBubble extends Phaser.GameObjects.Container {
                constructor(scene) {
                    super(scene);
                    this.arrow = new Phaser.GameObjects.Image(this.scene, 0, 0, 'ui-atlas', '_SpeechBubble_arrow' + '0000');
                    this.arrow.setOrigin(0, 0);
                    this.add(this.arrow);
                    this.bubble = new Phaser.GameObjects.Image(this.scene, 0, 241, 'ui-atlas', '_SpeechBubble_bubble' + '0000');
                    this.bubble.setOrigin(0.5, 0);
                    this.add(this.bubble);
                }
            }
            fla._SpeechBubble = _SpeechBubble;
        })(fla = assets.fla || (assets.fla = {}));
    })(assets = pbawp.assets || (pbawp.assets = {}));
})(pbawp || (pbawp = {}));
var pbawp;
(function (pbawp) {
    var assets;
    (function (assets) {
        var fla;
        (function (fla) {
            class _Stats extends Phaser.GameObjects.Container {
                constructor(scene) {
                    super(scene);
                    this.add(this.bg = this.scene.add.image(0, 0, 'ui-atlas', '_StatsBG' + '0000').setOrigin(0, 0));
                    this.panelButton = this.scene.add.image(31, 75, 'ui-atlas', '_Stats_panelButton' + '0000').setOrigin(0, 0);
                    this.panelButton.setInteractive({ cursor: 'pointer' });
                    this.add(this.panelButton);
                    this.pokemon = this.scene.add.image(440, 218, 'ui-atlas', 'pikachu' + '0000');
                    this.add(this.pokemon);
                    this.gender = new pbawp.assets.fla.GenderIcon(this.scene);
                    this.gender.setPosition(485, 354);
                    this.add(this.gender);
                    this.cancelButton = new pbawp.util.BasicButton(this.scene, 545, 95, 'ui-atlas', '_Stats_cancelButton' + '0000', '_Stats_cancelButton' + '0001', '_Stats_cancelButton' + '0002');
                    this.add(this.cancelButton);
                    this.pokemonName = this.scene.add.text(397, 342, "SNIVY", {
                        "fontFamily": "Agency FB Bold",
                        "fontSize": 24,
                        "color": "#000000",
                        "align": 'center',
                    });
                    this.add(this.pokemonName);
                    this.pokemonInfoText = this.scene.add.text(55, 91, "POKÉMON INFO", {
                        "fontFamily": "Agency FB Bold",
                        "fontSize": 30,
                        "color": "#000000",
                        "align": 'left',
                    });
                    this.add(this.pokemonInfoText);
                    this.dexNoText = this.scene.add.text(55, 149, "National No.", {
                        "fontFamily": "Agency FB Bold",
                        "fontSize": 18,
                        "color": "#000000",
                        "align": 'left',
                    });
                    this.add(this.dexNoText);
                    this.nameText = this.scene.add.text(55, 169, "Name", {
                        "fontFamily": "Agency FB Bold",
                        "fontSize": 18,
                        "color": "#000000",
                        "align": 'left',
                    });
                    this.add(this.nameText);
                    this.typeText = this.scene.add.text(55, 189, "Type", {
                        "fontFamily": "Agency FB Bold",
                        "fontSize": 18,
                        "color": "#000000",
                        "align": 'left',
                    });
                    this.add(this.typeText);
                    this.otText = this.scene.add.text(55, 209, "OT", {
                        "fontFamily": "Agency FB Bold",
                        "fontSize": 18,
                        "color": "#000000",
                        "align": 'left',
                    });
                    this.add(this.otText);
                    this.idNoText = this.scene.add.text(55, 229, "Species", {
                        "fontFamily": "Agency FB Bold",
                        "fontSize": 18,
                        "color": "#000000",
                        "align": 'left',
                    });
                    this.add(this.idNoText);
                    this.heightWeight = this.scene.add.text(56, 258, "HEIGHT 2'0\" WEIGHT 17.9 lbs", {
                        "fontFamily": "Agency FB",
                        "fontSize": 18,
                        "color": "#000000",
                        "align": 'left',
                    });
                    this.add(this.heightWeight);
                    this.infoText = this.scene.add.text(55, 289, "Info:", {
                        "fontFamily": "Agency FB Bold",
                        "fontSize": 18,
                        "color": "#000000",
                        "align": 'left',
                    });
                    this.add(this.infoText);
                    this.movesText = this.scene.add.text(202, 289, "Moves:", {
                        "fontFamily": "Agency FB Bold",
                        "fontSize": 18,
                        "color": "#000000",
                        "align": 'left',
                    });
                    this.add(this.movesText);
                    this.infoValue = this.scene.add.text(55, 311, "Pokémon who’s freed himself from Ash's circus of abuse and is leading Pokémon Liberation.", {
                        "fontFamily": "Agency FB",
                        "fontSize": 15,
                        "color": "#000000",
                        "align": 'left',
                    });
                    this.add(this.infoValue);
                    this.infoValue.setWordWrapWidth(125);
                    this.movesValue = this.scene.add.text(202, 311, "Vine Whip\n" +
                        "Wrap\n" +
                        "Mega Drain\n" +
                        "Protein Shake-Up", {
                        "fontFamily": "Agency FB",
                        "fontSize": 18,
                        "color": "#938D00",
                        "align": 'left',
                    });
                    this.add(this.movesValue);
                    this.movesValue.setWordWrapWidth(124);
                    this.dexNoValue = this.scene.add.text(150, 149, "57", {
                        "fontFamily": "Agency FB",
                        "fontSize": 18,
                        "color": "#000000",
                        "align": 'left',
                    });
                    this.add(this.dexNoValue);
                    this.nameValue = this.scene.add.text(150, 169, "SNIVY", {
                        "fontFamily": "Agency FB",
                        "fontSize": 18,
                        "color": "#000000",
                        "align": 'left',
                    });
                    this.add(this.nameValue);
                    this.typeValue = this.scene.add.text(150, 189, "ELECTRIC", {
                        "fontFamily": "Agency FB",
                        "fontSize": 18,
                        "color": "#D6D6D6",
                        "align": 'left',
                    });
                    this.add(this.typeValue);
                    this.otValue = this.scene.add.text(150, 209, "Professor Juniper", {
                        "fontFamily": "Agency FB",
                        "fontSize": 18,
                        "color": "#000000",
                        "align": 'left',
                    });
                    this.add(this.otValue);
                    this.idNoValue = this.scene.add.text(150, 229, "Grass Snake Pokémon", {
                        "fontFamily": "Agency FB",
                        "fontSize": 18,
                        "color": "#000000",
                        "align": 'left',
                    });
                    this.add(this.idNoValue);
                }
                panelButtonAddEventListenerClick(callback) {
                    this.panelButton.on('pointerup', callback);
                }
                panelButtonRemoveEventListenerClick(callback) {
                    this.panelButton.off('pointerup', callback);
                }
                pokemonGotoAndStop(label) {
                    this.pokemon.setFrame(label + '0000');
                }
                genderGotoAndStop(label) {
                    this.gender.gotoAndStop(label);
                }
            }
            fla._Stats = _Stats;
        })(fla = assets.fla || (assets.fla = {}));
    })(assets = pbawp.assets || (pbawp.assets = {}));
})(pbawp || (pbawp = {}));
var pbawp;
(function (pbawp) {
    var assets;
    (function (assets) {
        var fla;
        (function (fla) {
            class _TreasureButton extends Phaser.GameObjects.Container {
                constructor(scene) {
                    super(scene);
                    this.downloadButton = new pbawp.util.BasicLabeledButton(this.scene, 1, 71, 'ui-atlas', 'VIEW');
                    this.downloadButton.setScale(0.75);
                    this.add(this.downloadButton);
                    this.hoverImage = new Phaser.GameObjects.Image(this.scene, 0, -8, 'ui-atlas', 'hoverImage' + '0000');
                    this.add(this.hoverImage);
                }
            }
            fla._TreasureButton = _TreasureButton;
        })(fla = assets.fla || (assets.fla = {}));
    })(assets = pbawp.assets || (pbawp.assets = {}));
})(pbawp || (pbawp = {}));
var pbawp;
(function (pbawp) {
    var assets;
    (function (assets) {
        var fla;
        (function (fla) {
            class _TreasureScreen extends Phaser.GameObjects.Container {
                constructor(scene) {
                    super(scene);
                    this.add(this.scene.add.image(0, 0, 'ui-atlas', '_TreasureScreenBG' + '0000').setOrigin(0, 0));
                    this.backButton = new pbawp.util.BasicLabeledButton(this.scene, 105, 454, 'ui-atlas', 'TREASURE');
                    this.add(this.backButton);
                    this.treasureText = this.scene.add.text(200, 15, "TREASURE", {
                        "fontFamily": "Agency FB Bold",
                        "fontSize": 65,
                        "color": "#000000",
                        "align": 'center',
                    });
                    this.treasureText.setShadow(4, 4, '#3B6C7D');
                    this.add(this.treasureText);
                    this.unlockedText = this.scene.add.text(game.scale.width / 2, 90, "YOU'VE UNLOCKED 1 OF 3 TREASURE CHESTS!", {
                        "fontFamily": "Junegull-Regular",
                        "fontSize": 22,
                        "color": "#FFFFFF",
                        "align": 'center',
                        'stroke': '#7CC2E6',
                        'strokeThickness': 6,
                    });
                    this.unlockedText.setOrigin(0.5, 0);
                    this.add(this.unlockedText);
                    this.freeMeVideoText = this.scene.add.text(28 + 85, 297, "'FREE ME' VIDEO", {
                        "fontFamily": "Junegull-Regular",
                        "fontSize": 22,
                        "color": "#FFFFFF",
                        "align": 'center',
                        'stroke': '#2782A1',
                        'strokeThickness': 6,
                    });
                    this.freeMeVideoText.setOrigin(0.5, 0);
                    this.add(this.freeMeVideoText);
                    this.wallpaperText = this.scene.add.text(225 + 75, 297, "WALLPAPER", {
                        "fontFamily": "Junegull-Regular",
                        "fontSize": 22,
                        "color": "#FFFFFF",
                        "align": 'center',
                        'stroke': '#2782A1',
                        'strokeThickness': 6,
                    });
                    this.wallpaperText.setOrigin(0.5, 0);
                    this.add(this.wallpaperText);
                    this.tradingCardsText = this.scene.add.text(403 + 75, 297, "TRADING CARDS", {
                        "fontFamily": "Junegull-Regular",
                        "fontSize": 22,
                        "color": "#FFFFFF",
                        "align": 'center',
                        'stroke': '#2782A1',
                        'strokeThickness': 6,
                    });
                    this.tradingCardsText.setOrigin(0.5, 0);
                    this.add(this.tradingCardsText);
                    this.treasureButton1 = new fla._TreasureButton(this.scene);
                    this.treasureButton1.setPosition(115, 280);
                    this.add(this.treasureButton1);
                    this.treasureButton2 = new fla._TreasureButton(this.scene);
                    this.treasureButton2.setPosition(300, 280);
                    this.add(this.treasureButton2);
                    this.treasureButton3 = new fla._TreasureButton(this.scene);
                    this.treasureButton3.setPosition(485, 280);
                    this.add(this.treasureButton3);
                }
            }
            fla._TreasureScreen = _TreasureScreen;
        })(fla = assets.fla || (assets.fla = {}));
    })(assets = pbawp.assets || (pbawp.assets = {}));
})(pbawp || (pbawp = {}));
var pbawp;
(function (pbawp) {
    var assets;
    (function (assets) {
        var swf;
        (function (swf) {
            class _AnimationTransitionSWF extends Phaser.GameObjects.Container {
                constructor(scene) {
                    super(scene);
                    this.animName = 'transition-playing';
                    this.transition = this.scene.add.sprite(0, 0, 'animation_transition-atlas');
                    this.transition.setOrigin(0, 0);
                    this.add(this.transition);
                    if (!this.scene.anims.exists(this.animName)) {
                        this.scene.anims.create({
                            key: this.animName,
                            frames: this.scene.anims.generateFrameNames(this.transition.texture.key, {
                                start: 0, end: 28, zeroPad: 4,
                                prefix: 'transition', suffix: ''
                            }),
                            frameRate: 24
                        });
                    }
                    this.transition.setScale(1.5);
                }
                gotoAndPlay() {
                    this.transition.anims.play(this.animName);
                }
            }
            swf._AnimationTransitionSWF = _AnimationTransitionSWF;
        })(swf = assets.swf || (assets.swf = {}));
    })(assets = pbawp.assets || (pbawp.assets = {}));
})(pbawp || (pbawp = {}));
var pbawp;
(function (pbawp) {
    var assets;
    (function (assets) {
        var swf;
        (function (swf) {
            class _TopdownSWF {
                constructor(scene) {
                    this.childrenAnimationsConfig = {
                        'cherenStop': { start: 0, end: 0, repeat: 0, originX: 0, originY: 0 },
                        'juniperStop': { start: 0, end: 0, repeat: 0, originX: 0, originY: 0 },
                        'ashStop': { start: 0, end: 0, repeat: 0, originX: 0, originY: 0 },
                        'ghetsisStop': { start: 0, end: 0, repeat: 0, originX: 0, originY: 0 },
                        'nurseJoyStop': { start: 0, end: 0, repeat: 0, originX: 0, originY: 0 },
                        'nurseJoyWalk': { start: 0, end: 17, repeat: -1, originX: 0, originY: 0 },
                        'snorlaxStop': { start: 0, end: 0, repeat: 0, originX: 0, originY: 0 },
                        'snorlaxFall': { start: 0, end: 19, repeat: 0, originX: 0.05, originY: 0.65, sfx: '43' },
                        'pikachuWalk': { start: 0, end: 18, repeat: -1, originX: -0.2, originY: -0.42 },
                        'pikachuStop': { start: 0, end: 2, repeat: 0, originX: -0.13, originY: -0.5 },
                        'pikachuChest': { start: 0, end: 32, repeat: 0, originX: -0.11, originY: -0.45 },
                        'mudkipStop': { start: 0, end: 0, repeat: 0, originX: 0, originY: 0 },
                        'mudkipJump': { start: 0, end: 33, repeat: 0, originX: 0.19, originY: 0.21 },
                        'oshawottWalk': { start: 0, end: 18, repeat: -1, originX: -0.9, originY: -0.55 },
                        'oshawottStop': { start: 0, end: 2, repeat: 0, originX: -0.9, originY: -0.55 },
                        'tepigStop': { start: 0, end: 2, repeat: 0, originX: -0.83, originY: -0.3 },
                        'tepigWalk': { start: 0, end: 18, repeat: -1, originX: -0.85, originY: -0.3 },
                        'snivyStop': { start: 0, end: 1, repeat: 0, originX: 0.13, originY: 0 },
                        'snivyWalk': { start: 0, end: 17, repeat: -1, originX: 0.19, originY: 0.02 },
                        'slowpokeStop': { start: 0, end: 0, repeat: 0, originX: 0, originY: 0 },
                        'slowpokeWalk': { start: 0, end: 10, repeat: -1, originX: 0, originY: 0, sfx: '51' },
                        'mysteriousStrangerFront': { start: 0, end: 0, repeat: 0, originX: 0.5, originY: 0.95, speechOffset: -30 },
                        'mysteriousStrangerBack': { start: 0, end: 0, repeat: 0, originX: 0.5, originY: 0.95, speechOffset: -30 },
                        'mcdonaldsCustomer': { start: 0, end: 0, repeat: 0, originX: 0.5, originY: 0.5, speechOffset: 5 },
                        'slaughterhouseWorkers': { start: 0, end: 0, repeat: 0, originX: 0.5, originY: 0.5 },
                        'ronald': { start: 0, end: 0, repeat: 0, originX: 0.5, originY: 0.5, speechOffset: 10 },
                        'miltank': { start: 0, end: 18, repeat: -1, originX: 0.42, originY: 0.42, speechOffset: 0 },
                        'jigglypuff': { start: 0, end: 18, repeat: -1, originX: 0.5, originY: 0.5, speechOffset: -20 },
                        'grimace': { start: 0, end: 18, repeat: -1, originX: 0.5, originY: 0.5, speechOffset: 0 },
                        'ash': { start: 0, end: 15, repeat: -1, originX: 0.45, originY: 0.5, speechOffset: -10 },
                        'protesters': { start: 0, end: 15, repeat: -1, originX: 0.5, originY: 0.5, speechOffset: 20 },
                        'portal': { start: 0, end: 70, repeat: -1, originX: 0.5, originY: 0.65, scale: 1.5 }
                    };
                    this.scene = scene;
                }
                getChildByName(name) {
                    let childName = '' + name;
                    let s = this.scene.add.sprite(0, 0, 'topdown-atlas', childName + '0000');
                    s.setOrigin(this.childrenAnimationsConfig[childName]['originX'], this.childrenAnimationsConfig[childName]['originY']);
                    if (this.childrenAnimationsConfig[childName].hasOwnProperty('scale')) {
                        s.setScale(this.childrenAnimationsConfig[childName]['scale']);
                    }
                    if (this.childrenAnimationsConfig[childName].hasOwnProperty('speechOffset')) {
                        s['speechOffset'] = this.childrenAnimationsConfig[childName]['speechOffset'];
                    }
                    s["gotoAndPlay"] = (fromFrame, animationDoneCallback = null) => {
                        let animName = childName + '-playingFrom' + fromFrame;
                        if (!this.scene.anims.exists(animName)) {
                            this.scene.anims.create({
                                key: animName,
                                frames: this.scene.anims.generateFrameNames(s.texture.key, {
                                    start: fromFrame,
                                    end: this.childrenAnimationsConfig[childName]['end'],
                                    zeroPad: 4,
                                    prefix: childName, suffix: ''
                                }),
                                frameRate: 24, repeat: this.childrenAnimationsConfig[childName]['repeat']
                            });
                        }
                        s.anims.play(animName);
                        if (animationDoneCallback) {
                            let onAnimationComplete = () => {
                                animationDoneCallback();
                                s.off('animationcomplete', onAnimationComplete);
                            };
                            s.on('animationcomplete', onAnimationComplete);
                        }
                        ;
                        if (this.childrenAnimationsConfig[childName].hasOwnProperty('sfx')) {
                            pbawp.code.GameWorld.soundManager.playSound(this.childrenAnimationsConfig[childName]['sfx']);
                        }
                    };
                    s["gotoAndStop"] = (fromFrame) => {
                        s.anims.stop();
                        s.setFrame(this.scene.anims.generateFrameNames(s.texture.key, {
                            start: fromFrame,
                            end: fromFrame,
                            zeroPad: 4,
                            prefix: childName, suffix: ''
                        })[0].frame);
                    };
                    s["totalFrames"] = this.childrenAnimationsConfig[childName]['end'];
                    return s;
                }
            }
            swf._TopdownSWF = _TopdownSWF;
        })(swf = assets.swf || (assets.swf = {}));
    })(assets = pbawp.assets || (pbawp.assets = {}));
})(pbawp || (pbawp = {}));
var pbawp;
(function (pbawp) {
    var assets;
    (function (assets) {
        var swf;
        (function (swf) {
            class _TreasureboxSWF extends Phaser.GameObjects.Container {
                constructor(scene) {
                    super(scene);
                    this.treasurebox = this.scene.add.sprite(0, 0, 'treasurebox-atlas', 'treasurebox0000');
                    this.treasurebox.setOrigin(0, 0);
                    this.add(this.treasurebox);
                    let animName_show = 'show';
                    if (!this.scene.anims.exists(animName_show)) {
                        this.scene.anims.create({
                            key: animName_show,
                            frames: this.scene.anims.generateFrameNames(this.treasurebox.texture.key, {
                                start: 0, end: 40, zeroPad: 4,
                                prefix: 'treasurebox', suffix: ''
                            }),
                            frameRate: 24
                        });
                    }
                    let animName_open = 'open';
                    if (!this.scene.anims.exists(animName_open)) {
                        this.scene.anims.create({
                            key: animName_open,
                            frames: this.scene.anims.generateFrameNames(this.treasurebox.texture.key, {
                                start: 41, end: 107, zeroPad: 4,
                                prefix: 'treasurebox', suffix: ''
                            }),
                            frameRate: 24
                        });
                    }
                }
                gotoAndStop(label) {
                    this.treasurebox.play(label);
                }
            }
            swf._TreasureboxSWF = _TreasureboxSWF;
        })(swf = assets.swf || (assets.swf = {}));
    })(assets = pbawp.assets || (pbawp.assets = {}));
})(pbawp || (pbawp = {}));
var pbawp;
(function (pbawp) {
    var assets;
    (function (assets) {
        var swf;
        (function (swf) {
            class _WinSWF extends Phaser.GameObjects.Container {
                constructor(scene) {
                    super(scene);
                    this.win_pikachu = this.scene.add.sprite(111, 30, 'win-atlas');
                    this.win_pikachu.setOrigin(0, 0);
                    this.add(this.win_pikachu);
                    let animName_win_pikachu = 'win_pikachu-playing';
                    if (!this.scene.anims.exists(animName_win_pikachu)) {
                        this.scene.anims.create({
                            key: animName_win_pikachu,
                            frames: this.scene.anims.generateFrameNames(this.win_pikachu.texture.key, {
                                start: 0, end: 15, zeroPad: 4,
                                prefix: 'win_pikachu', suffix: ''
                            }),
                            frameRate: 24, repeat: -1
                        });
                    }
                    this.win_pikachu.anims.play(animName_win_pikachu);
                    this.win_miltank = this.scene.add.sprite(205, 37, 'win-atlas');
                    this.win_miltank.setOrigin(0, 0);
                    this.add(this.win_miltank);
                    let animName_win_miltank = 'win_miltank-playing';
                    if (!this.scene.anims.exists(animName_win_miltank)) {
                        this.scene.anims.create({
                            key: animName_win_miltank,
                            frames: this.scene.anims.generateFrameNames(this.win_miltank.texture.key, {
                                start: 0, end: 15, zeroPad: 4,
                                prefix: 'win_miltank', suffix: ''
                            }),
                            frameRate: 24, repeat: -1
                        });
                    }
                    this.win_miltank.anims.play(animName_win_miltank);
                    this.win_jigglypuff = this.scene.add.sprite(300, 54, 'win-atlas');
                    this.win_jigglypuff.setOrigin(0, 0);
                    this.add(this.win_jigglypuff);
                    let animName_win_jigglypuff = 'win_jigglypuff-playing';
                    if (!this.scene.anims.exists(animName_win_jigglypuff)) {
                        this.scene.anims.create({
                            key: animName_win_jigglypuff,
                            frames: this.scene.anims.generateFrameNames(this.win_jigglypuff.texture.key, {
                                start: 0, end: 15, zeroPad: 4,
                                prefix: 'win_jigglypuff', suffix: ''
                            }),
                            frameRate: 24, repeat: -1
                        });
                    }
                    this.win_jigglypuff.anims.play(animName_win_jigglypuff);
                    this.win_grimace = this.scene.add.sprite(386, 26, 'win-atlas');
                    this.win_grimace.setOrigin(0, 0);
                    this.add(this.win_grimace);
                    let animName_win_grimace = 'win_grimace-playing';
                    if (!this.scene.anims.exists(animName_win_grimace)) {
                        this.scene.anims.create({
                            key: animName_win_grimace,
                            frames: this.scene.anims.generateFrameNames(this.win_grimace.texture.key, {
                                start: 0, end: 13, zeroPad: 4,
                                prefix: 'win_grimace', suffix: ''
                            }),
                            frameRate: 24, repeat: -1
                        });
                    }
                    this.win_grimace.anims.play(animName_win_grimace);
                    for (let i = 0; i < 50; i++) {
                        let confetti_ = new Phaser.GameObjects.Image(this.scene, Math.random() * game.scale.width, Math.random() > 0.25 ? 0 : game.scale.height / 2 + (Math.random() - 0.5) * 150, 'win-atlas', 'confetti_' + Math.ceil(Math.random() * 8) + '0000');
                        let duration = (game.scale.height - confetti_.y) / 100 * 500;
                        this.scene.tweens.add({
                            targets: confetti_,
                            duration: 1000,
                            repeat: -1,
                            angle: Math.random() > 0.5 ? 360 : -360
                        });
                        this.scene.tweens.add({
                            targets: confetti_,
                            duration: duration,
                            y: game.scale.height,
                            delay: i * 50,
                            repeat: -1,
                            onStart: () => this.add(confetti_)
                        });
                    }
                }
            }
            swf._WinSWF = _WinSWF;
        })(swf = assets.swf || (assets.swf = {}));
    })(assets = pbawp.assets || (pbawp.assets = {}));
})(pbawp || (pbawp = {}));
var pbawp;
(function (pbawp) {
    var assets;
    (function (assets) {
        var swf;
        (function (swf) {
            var character;
            (function (character) {
                class _BaseCharacterSWF extends Phaser.GameObjects.Container {
                    constructor(scene, atlas, mainCharacterName, mainCharacterScale = 1, effectsData = null) {
                        super(scene);
                        this.effectsSprite = null;
                        this.effectsData = null;
                        this._isDonePlayingCurrentLabel = false;
                        this._currentPlayingLabel = null;
                        this.mainCharacterScale = mainCharacterScale;
                        this.mainCharacterName = mainCharacterName;
                        this.animationsData = _BaseCharacterSWF.ANIMATIONS[this.mainCharacterName];
                        for (let k in this.animationsData) {
                            let animName = this.createAnimName(k);
                            if (!this.scene.anims.exists(animName)) {
                                this.scene.anims.create({
                                    key: animName,
                                    frames: this.scene.anims.generateFrameNames(atlas, {
                                        start: this.animationsData[k]["start"], end: this.animationsData[k]["end"], zeroPad: 4,
                                        prefix: this.mainCharacterName, suffix: ''
                                    }),
                                    frameRate: 40, repeat: this.animationsData[k]["repeat"]
                                });
                            }
                        }
                        this.mainCharacterSprite = this.scene.add.sprite(0, 0, atlas, this.mainCharacterName + "0000");
                        this.mainCharacterSprite.setScale(this.mainCharacterScale);
                        this.mainCharacterSprite.setOrigin(_BaseCharacterSWF.ANCHORS[this.mainCharacterName]['x'] * this.mainCharacterSprite.scaleX, _BaseCharacterSWF.ANCHORS[this.mainCharacterName]['y'] * this.mainCharacterSprite.scaleY);
                        this.add(this.mainCharacterSprite);
                        this.mainCharacterSprite.on('animationcomplete', () => {
                            this._isDonePlayingCurrentLabel = true;
                            this._currentPlayingLabel = null;
                        });
                        this.effectsData = effectsData;
                        if (effectsData) {
                            this.effectsSprite = this.scene.add.sprite(0, 0, this.effectsData.hasOwnProperty('atlas') ? this.effectsData['atlas'] : atlas, effectsData['startFrame']);
                            this.effectsSprite.setScale(this.mainCharacterScale);
                            if (effectsData.hasOwnProperty('scale'))
                                this.effectsSprite.setScale(this.effectsSprite.scale * effectsData['scale']);
                            this.effectsSprite.setOrigin(effectsData['originX'], effectsData['originY']);
                            this.add(this.effectsSprite);
                            for (let k in this.animationsData) {
                                let animName = this.createEffectsAnimName(k);
                                if (!this.scene.anims.exists(animName)) {
                                    this.scene.anims.create({
                                        key: animName,
                                        frames: this.scene.anims.generateFrameNames(this.effectsSprite.texture.key, {
                                            start: this.animationsData[k]["start"], end: this.animationsData[k]["end"], zeroPad: 4,
                                            prefix: effectsData['name'], suffix: ''
                                        }),
                                        frameRate: 40, repeat: this.animationsData[k]["repeat"]
                                    });
                                }
                            }
                        }
                    }
                    gotoAndPlay(label) {
                        this._isDonePlayingCurrentLabel = false;
                        this.mainCharacterSprite.anims.play(this.createAnimName(label));
                        this._currentPlayingLabel = label;
                        if (this.effectsSprite) {
                            this.effectsSprite.anims.play(this.createEffectsAnimName(label));
                        }
                        if (this.animationsData[label].hasOwnProperty('sfx')) {
                            pbawp.code.GameWorld.soundManager.playSound(this.animationsData[label]['sfx']);
                        }
                    }
                    gotoAndStop(label) {
                        this._isDonePlayingCurrentLabel = true;
                        this.mainCharacterSprite.anims.stop();
                        this.mainCharacterSprite.setFrame(this.scene.anims.generateFrameNames(this.mainCharacterSprite.texture.key, {
                            start: this.animationsData[label]["start"], end: this.animationsData[label]["start"], zeroPad: 4,
                            prefix: this.mainCharacterName, suffix: ''
                        })[0].frame);
                        this._currentPlayingLabel = label;
                        if (this.effectsSprite) {
                            this.effectsSprite.anims.stop();
                            this.effectsSprite.setFrame(this.scene.anims.generateFrameNames(this.effectsSprite.texture.key, {
                                start: this.animationsData[label]["start"], end: this.animationsData[label]["start"], zeroPad: 4,
                                prefix: this.effectsData['name'], suffix: ''
                            })[0].frame);
                        }
                    }
                    getChildByName(name) {
                        if (name == this.mainCharacterName) {
                            return this.mainCharacterSprite;
                        }
                        return null;
                    }
                    createAnimName(animNameBase) {
                        return this.mainCharacterName + "_" + animNameBase;
                    }
                    createEffectsAnimName(animNameBase) {
                        return this.createAnimName(animNameBase) + '_effects';
                    }
                    getMainCharacterSprite() {
                        return this.mainCharacterSprite;
                    }
                    isDonePlayingCurrentLabel() {
                        return this._isDonePlayingCurrentLabel;
                    }
                    getCurrentPlayingLabel() {
                        return this._currentPlayingLabel;
                    }
                    getCurrentFrame() {
                        let n = this.mainCharacterSprite.frame.name;
                        let frm = this.mainCharacterSprite.frame.name.substring(n.length - 4, n.length);
                        return Number(frm);
                    }
                }
                _BaseCharacterSWF.ANCHORS = {
                    'pikachu': { x: 0.58 * 0.75 * 0.77, y: 0.05 * 0.75 * 0.77 },
                    'ghetsis': { x: -1, y: 0 },
                    'cheren': { x: -0.1, y: -0.12 },
                    'ash': { x: -0.02, y: 0.02 },
                    'oshawott': { x: -0.5 * 0.86, y: -1.05 * 0.86 },
                    'juniper': { x: -0.12, y: -0.12 },
                    'tepig': { x: -0.36 * 0.99, y: -1.52 * 0.99 },
                    'snivy': { x: -0.35 * 0.89, y: -1.25 * 0.89 },
                    'grimace': { x: -0.2, y: -0.17 },
                    'jigglypuff': { x: -0.32 * 0.75 * 0.95, y: -0.38 * 0.75 * 0.95 },
                    'mcdonaldsCustomer': { x: -0.7 * 0.88, y: -0.23 * 0.88 },
                    'miltank': { x: -0.05 / 0.9 * 0.8, y: -0.42 / 0.9 * 0.8 },
                    'mysteriousStranger': { x: -0.88 * 0.88, y: -0.25 * 0.88 },
                    'ronald': { x: -0.54 * 0.86, y: -0.03 * 0.86 },
                    'slaughterhouseWorkers': { x: -0.15 * 0.85, y: 0.12 * 0.85 }
                };
                _BaseCharacterSWF.ANIMATIONS = {
                    'pikachu': {
                        'appear': { start: 0, end: 49, repeat: 0 },
                        'ready': { start: 50, end: 106, repeat: 0 },
                        'dodge': { start: 107, end: 131, repeat: 0 },
                        'takeDamage': { start: 132, end: 167, repeat: 0 },
                        'Charge Beam': { start: 168, end: 217, repeat: 0, sfx: '36' },
                        'Slam': { start: 218, end: 252, repeat: 0, sfx: '80' },
                        'Protest': { start: 253, end: 306, repeat: 0, sfx: '105' },
                        'GroupHug': { start: 307, end: 410, repeat: 0, sfx: '105' }
                    },
                    'ghetsis': {
                        'normal': { start: 0, end: 37, repeat: 0 },
                        'defeat': { start: 38, end: 89, repeat: 0 },
                        'takeDamage': { start: 90, end: 110, repeat: 0 },
                        'dodge': { start: 111, end: 131, repeat: 0 },
                        'MeatCleaver': { start: 132, end: 165, repeat: 0, sfx: '75' },
                        'Electrocution': { start: 166, end: 218, repeat: 0, sfx: '123' },
                        'Trap': { start: 219, end: 263, repeat: 0, sfx: '148' }
                    },
                    'cheren': {
                        'normal': { start: 0, end: 44, repeat: 0 },
                        'defeat': { start: 45, end: 85, repeat: 0 },
                        'dodge': { start: 86, end: 111, repeat: 0 },
                        'takeDamage': { start: 112, end: 136, repeat: 0 },
                        'dicipline': { start: 137, end: 168, repeat: 0, sfx: '65' },
                        'ChokeCollar': { start: 169, end: 210, repeat: 0, sfx: '80' },
                        'DockTail': { start: 211, end: 248, repeat: 0, sfx: '93' }
                    },
                    'ash': {
                        'ready': { start: 0, end: 40, repeat: 0 },
                        'defeat': { start: 41, end: 73, repeat: 0 },
                        'dodge': { start: 74, end: 112, repeat: 0 },
                        'takeDamages': { start: 113, end: 148, repeat: 0 },
                        'whipLash': { start: 149, end: 198, repeat: 0, sfx: '49' },
                        'bullhogBlash': { start: 199, end: 235, repeat: 0, sfx: '59' },
                        'cagetoss': { start: 236, end: 326, repeat: 0, sfx: '65' }
                    },
                    'oshawott': {
                        'normal': { start: 0, end: 34, repeat: 0 },
                        'takeDamage': { start: 35, end: 57, repeat: 0 },
                        'dodge': { start: 58, end: 84, repeat: 0 },
                        'Tackle': { start: 85, end: 122, repeat: 0, sfx: '48' },
                        'WaterGun': { start: 123, end: 185, repeat: 0, sfx: '61' },
                        'Recruit': { start: 186, end: 248, repeat: 0, sfx: '76' },
                        'ProteinShakeUp': { start: 249, end: 319, repeat: 0, sfx: '76' }
                    },
                    'juniper': {
                        'normal': { start: 0, end: 34, repeat: 0 },
                        'defeat': { start: 35, end: 75, repeat: 0 },
                        'takeDamage': { start: 76, end: 95, repeat: 0 },
                        'dodge': { start: 95, end: 115, repeat: 0 },
                        'Dissection': { start: 116, end: 158, repeat: 0, sfx: '85' },
                        'PerfumePulse': { start: 159, end: 205, repeat: 0, sfx: '124' },
                        'Toxin': { start: 206, end: 274, repeat: 0, sfx: '143' }
                    },
                    'tepig': {
                        'ready': { start: 0, end: 46, repeat: 0 },
                        'dodge': { start: 47, end: 70, repeat: 0 },
                        'takeDamage': { start: 71, end: 94, repeat: 0 },
                        'ember': { start: 95, end: 149, repeat: 0, sfx: '117' },
                        'shame': { start: 150, end: 212, repeat: 0, sfx: '131' },
                        'takeDown': { start: 213, end: 272, repeat: 0, sfx: '183' },
                        'petition': { start: 273, end: 323, repeat: 0, sfx: '131' }
                    },
                    'snivy': {
                        'normal': { start: 0, end: 45, repeat: 0 },
                        'takeDamage': { start: 46, end: 74, repeat: 0 },
                        'Dodge': { start: 75, end: 103, repeat: 0 },
                        'Wrap': { start: 104, end: 185, repeat: 0, sfx: '49' },
                        'Educate': { start: 186, end: 231, repeat: 0, sfx: '66' },
                        'BullHorn': { start: 232, end: 278, repeat: 0, sfx: '66' },
                        'MegaDrain': { start: 279, end: 367, repeat: 0, sfx: '153' }
                    },
                    'grimace': {
                        'normal': { start: 0, end: 47, repeat: 0 },
                        'takeDamage': { start: 48, end: 70, repeat: 0 },
                        'dodge': { start: 71, end: 97, repeat: 0 },
                        'Attack: Poison Jab': { start: 98, end: 135, repeat: 0, sfx: '37' },
                        'Attack: Pursuit': { start: 138, end: 196, repeat: 0, sfx: '92' },
                        'PETA Attack: Paint': { start: 197, end: 241, repeat: 0, sfx: '92' },
                        'PETA Attack: Bulk Up': { start: 242, end: 328, repeat: 0, sfx: '131' }
                    },
                    'jigglypuff': {
                        'normal': { start: 0, end: 33, repeat: 0 },
                        'takeDamage': { start: 34, end: 56, repeat: 0 },
                        'dodge': { start: 57, end: 83, repeat: 0 },
                        'Attack: Sing': { start: 84, end: 140, repeat: 0, sfx: '38' },
                        'Attack: Rest': { start: 141, end: 208, repeat: 0, sfx: '52' },
                        'PETA Attack: Rally': { start: 209, end: 268, repeat: 0, sfx: '128' },
                        'PETA Attack: Lettuce Lady': { start: 269, end: 322, repeat: 0, sfx: '158' }
                    },
                    'mcdonaldsCustomer': {
                        'normal': { start: 0, end: 31, repeat: 0 },
                        'Defeated': { start: 32, end: 49, repeat: 0 },
                        'takeDamage': { start: 50, end: 72, repeat: 0 },
                        'dodge': { start: 73, end: 99, repeat: 0 },
                        'Attack: Bite': { start: 100, end: 137, repeat: 0, sfx: '75' },
                        'Attack: DDoS': { start: 138, end: 198, repeat: 0, sfx: '159' },
                        'Attack: Rant': { start: 199, end: 253, repeat: 0, sfx: '167' }
                    },
                    'miltank': {
                        'normal': { start: 0, end: 34, repeat: 0 },
                        'takeDamage': { start: 35, end: 57, repeat: 0 },
                        'dodge': { start: 58, end: 84, repeat: 0 },
                        'Attack: Rollout': { start: 85, end: 129, repeat: 0, sfx: '39' },
                        'Attack: Zen Headbutt': { start: 130, end: 159, repeat: 0, sfx: '96' },
                        'Attack: Bull Horn': { start: 160, end: 228, repeat: 0, sfx: '100' },
                        'Attack: Udder Madness': { start: 229, end: 281, repeat: 0, sfx: '115' }
                    },
                    'mysteriousStranger': {
                        'normal': { start: 0, end: 30, repeat: 0 },
                        'Defeated': { start: 31, end: 58, repeat: 0 },
                        'takeDamage': { start: 59, end: 81, repeat: 0 },
                        'dodge': { start: 82, end: 108, repeat: 0 },
                        'Attack: Cage Lasso': { start: 109, end: 159, repeat: 0, sfx: '43' },
                        'Attack: Butcher': { start: 160, end: 207, repeat: 0, sfx: '61' },
                        'Attack: Dehorning': { start: 208, end: 261, repeat: 0, sfx: '85' }
                    },
                    'ronald': {
                        'normal': { start: 0, end: 33, repeat: 0 },
                        'Defeated': { start: 34, end: 56, repeat: 0 },
                        'takeDamage': { start: 57, end: 79, repeat: 0 },
                        'dodge': { start: 80, end: 106, repeat: 0 },
                        'Attack: Revealed': { start: 107, end: 143, repeat: 0 },
                        'Attack: Done': { start: 144, end: 144, repeat: 0 },
                        'Attack: McCapture': { start: 145, end: 212, repeat: 0, sfx: '82' },
                        'Attack: McPunishment': { start: 213, end: 267, repeat: 0, sfx: '95' },
                        'Attack: McBrand': { start: 268, end: 303, repeat: 0, sfx: '187' }
                    },
                    'slaughterhouseWorkers': {
                        'normal': { start: 0, end: 33, repeat: 0 },
                        'Defeated': { start: 34, end: 54, repeat: 0 },
                        'takeDamage': { start: 55, end: 77, repeat: 0 },
                        'dodge': { start: 78, end: 104, repeat: 0 },
                        'Attack: Meat Cleaver': { start: 105, end: 142, repeat: 0, sfx: '94' },
                        'Attack: Cattle Prod': { start: 143, end: 188, repeat: 0, sfx: '133' },
                        'Attack: Pink Slime': { start: 189, end: 243, repeat: 0, sfx: '146' }
                    }
                };
                character._BaseCharacterSWF = _BaseCharacterSWF;
            })(character = swf.character || (swf.character = {}));
        })(swf = assets.swf || (assets.swf = {}));
    })(assets = pbawp.assets || (pbawp.assets = {}));
})(pbawp || (pbawp = {}));
///<reference path="_BaseCharacterSWF.ts"/>
var pbawp;
(function (pbawp) {
    var assets;
    (function (assets) {
        var swf;
        (function (swf) {
            var character;
            (function (character) {
                class _Animation_asset_ashSWF extends character._BaseCharacterSWF {
                    constructor(scene) {
                        super(scene, 'animation_asset_ash-atlas', 'ash');
                    }
                }
                character._Animation_asset_ashSWF = _Animation_asset_ashSWF;
            })(character = swf.character || (swf.character = {}));
        })(swf = assets.swf || (assets.swf = {}));
    })(assets = pbawp.assets || (pbawp.assets = {}));
})(pbawp || (pbawp = {}));
///<reference path="_BaseCharacterSWF.ts"/>
var pbawp;
(function (pbawp) {
    var assets;
    (function (assets) {
        var swf;
        (function (swf) {
            var character;
            (function (character) {
                class _Animation_asset_cherenSWF extends character._BaseCharacterSWF {
                    constructor(scene) {
                        super(scene, 'animation_asset_cheren-atlas', 'cheren');
                    }
                }
                character._Animation_asset_cherenSWF = _Animation_asset_cherenSWF;
            })(character = swf.character || (swf.character = {}));
        })(swf = assets.swf || (assets.swf = {}));
    })(assets = pbawp.assets || (pbawp.assets = {}));
})(pbawp || (pbawp = {}));
///<reference path="_BaseCharacterSWF.ts"/>
var pbawp;
(function (pbawp) {
    var assets;
    (function (assets) {
        var swf;
        (function (swf) {
            var character;
            (function (character) {
                class _Animation_asset_ghetsisSWF extends character._BaseCharacterSWF {
                    constructor(scene) {
                        super(scene, 'animation_asset_ghetsis-atlas', 'ghetsis', 1, {
                            'name': 'ghetsis_effects',
                            'startFrame': 'ghetsis_effects0188',
                            'originX': -0.25,
                            'originY': 0.1
                        });
                    }
                }
                character._Animation_asset_ghetsisSWF = _Animation_asset_ghetsisSWF;
            })(character = swf.character || (swf.character = {}));
        })(swf = assets.swf || (assets.swf = {}));
    })(assets = pbawp.assets || (pbawp.assets = {}));
})(pbawp || (pbawp = {}));
///<reference path="_BaseCharacterSWF.ts"/>
var pbawp;
(function (pbawp) {
    var assets;
    (function (assets) {
        var swf;
        (function (swf) {
            var character;
            (function (character) {
                class _Animation_asset_grimaceSWF extends character._BaseCharacterSWF {
                    constructor(scene) {
                        super(scene, 'animation_asset_grimace-atlas', 'grimace', 1 / (0.88 * 0.92), {
                            'name': 'grimace_effects',
                            'startFrame': 'grimace_effects0181',
                            'atlas': 'animation_asset_grimace_effects-atlas',
                            'originX': 0 * 0.92,
                            'originY': 0.1 * 0.92
                        });
                    }
                }
                character._Animation_asset_grimaceSWF = _Animation_asset_grimaceSWF;
            })(character = swf.character || (swf.character = {}));
        })(swf = assets.swf || (assets.swf = {}));
    })(assets = pbawp.assets || (pbawp.assets = {}));
})(pbawp || (pbawp = {}));
///<reference path="_BaseCharacterSWF.ts"/>
var pbawp;
(function (pbawp) {
    var assets;
    (function (assets) {
        var swf;
        (function (swf) {
            var character;
            (function (character) {
                class _Animation_asset_jigglypuffSWF extends character._BaseCharacterSWF {
                    constructor(scene) {
                        super(scene, 'animation_asset_jigglypuff-atlas', 'jigglypuff', 1 / 0.74 / 0.95, {
                            'name': 'jigglypuff_effects',
                            'startFrame': 'jigglypuff_effects0228',
                            'atlas': 'animation_asset_jigglypuff_effects-atlas',
                            'originX': -0.23 * 0.74 * 0.95,
                            'originY': -0.1 * 0.74 * 0.95
                        });
                    }
                }
                character._Animation_asset_jigglypuffSWF = _Animation_asset_jigglypuffSWF;
            })(character = swf.character || (swf.character = {}));
        })(swf = assets.swf || (assets.swf = {}));
    })(assets = pbawp.assets || (pbawp.assets = {}));
})(pbawp || (pbawp = {}));
///<reference path="_BaseCharacterSWF.ts"/>
var pbawp;
(function (pbawp) {
    var assets;
    (function (assets) {
        var swf;
        (function (swf) {
            var character;
            (function (character) {
                class _Animation_asset_mcdonaldsCustomerSWF extends character._BaseCharacterSWF {
                    constructor(scene) {
                        super(scene, 'animation_asset_mcdonaldsCustomer-atlas', 'mcdonaldsCustomer', 1 / 0.88, {
                            'name': 'mcdonaldsCustomer_effects',
                            'startFrame': 'mcdonaldsCustomer_effects0125',
                            'originX': -0.1,
                            'originY': -0.5
                        });
                    }
                }
                character._Animation_asset_mcdonaldsCustomerSWF = _Animation_asset_mcdonaldsCustomerSWF;
            })(character = swf.character || (swf.character = {}));
        })(swf = assets.swf || (assets.swf = {}));
    })(assets = pbawp.assets || (pbawp.assets = {}));
})(pbawp || (pbawp = {}));
///<reference path="_BaseCharacterSWF.ts"/>
var pbawp;
(function (pbawp) {
    var assets;
    (function (assets) {
        var swf;
        (function (swf) {
            var character;
            (function (character) {
                class _Animation_asset_miltankSWF extends character._BaseCharacterSWF {
                    constructor(scene) {
                        super(scene, 'animation_asset_miltank-atlas', 'miltank', 1 / 0.8, {
                            'name': 'miltank_effects',
                            'startFrame': 'miltank_effects0143',
                            'originX': -0.22 / 0.9 * 0.8,
                            'originY': -0.1 / 0.9 * 0.8
                        });
                    }
                }
                character._Animation_asset_miltankSWF = _Animation_asset_miltankSWF;
            })(character = swf.character || (swf.character = {}));
        })(swf = assets.swf || (assets.swf = {}));
    })(assets = pbawp.assets || (pbawp.assets = {}));
})(pbawp || (pbawp = {}));
///<reference path="_BaseCharacterSWF.ts"/>
var pbawp;
(function (pbawp) {
    var assets;
    (function (assets) {
        var swf;
        (function (swf) {
            var character;
            (function (character) {
                class _Animation_asset_mysteriousStrangerSWF extends character._BaseCharacterSWF {
                    constructor(scene) {
                        super(scene, 'animation_asset_mysteriousStranger-atlas', 'mysteriousStranger', 1 / 0.88, {
                            'name': 'mysteriousStranger_effects',
                            'startFrame': 'mysteriousStranger_effects0149',
                            'atlas': 'animation_asset_mysteriousStranger_effects-atlas',
                            'originX': 0.03,
                            'originY': 0.3,
                            'scale': 1 / 0.75
                        });
                    }
                }
                character._Animation_asset_mysteriousStrangerSWF = _Animation_asset_mysteriousStrangerSWF;
            })(character = swf.character || (swf.character = {}));
        })(swf = assets.swf || (assets.swf = {}));
    })(assets = pbawp.assets || (pbawp.assets = {}));
})(pbawp || (pbawp = {}));
var pbawp;
(function (pbawp) {
    var assets;
    (function (assets) {
        var swf;
        (function (swf) {
            var character;
            (function (character) {
                class _Animation_asset_oshawottSWF extends character._BaseCharacterSWF {
                    constructor(scene) {
                        super(scene, 'animation_asset_oshawott-atlas', 'oshawott', 1 / 0.86, {
                            'name': 'oshawott_effects',
                            'startFrame': 'oshawott_effects0144',
                            'originX': -0.28 * 0.86,
                            'originY': -0.12 * 0.86
                        });
                    }
                }
                character._Animation_asset_oshawottSWF = _Animation_asset_oshawottSWF;
            })(character = swf.character || (swf.character = {}));
        })(swf = assets.swf || (assets.swf = {}));
    })(assets = pbawp.assets || (pbawp.assets = {}));
})(pbawp || (pbawp = {}));
///<reference path="_BaseCharacterSWF.ts"/>
var pbawp;
(function (pbawp) {
    var assets;
    (function (assets) {
        var swf;
        (function (swf) {
            var character;
            (function (character) {
                class _Animation_asset_pikachuSWF extends character._BaseCharacterSWF {
                    constructor(scene) {
                        super(scene, 'animation_asset_pikachu-atlas', 'pikachu', 1 / 0.75 / 0.77, {
                            'name': 'pikachu_effects',
                            'startFrame': 'pikachu_effects0175',
                            'atlas': 'animation_asset_pikachu_effects-atlas',
                            'originX': 0.02 * 0.75 * 0.77,
                            'originY': 0.01 * 0.75 * 0.77
                        });
                        this.mainCharacterSprite.setFrame(this.mainCharacterName + "0175");
                        window["p"] = this;
                    }
                }
                character._Animation_asset_pikachuSWF = _Animation_asset_pikachuSWF;
            })(character = swf.character || (swf.character = {}));
        })(swf = assets.swf || (assets.swf = {}));
    })(assets = pbawp.assets || (pbawp.assets = {}));
})(pbawp || (pbawp = {}));
///<reference path="_BaseCharacterSWF.ts"/>
var pbawp;
(function (pbawp) {
    var assets;
    (function (assets) {
        var swf;
        (function (swf) {
            var character;
            (function (character) {
                class _Animation_asset_profjuniperSWF extends character._BaseCharacterSWF {
                    constructor(scene) {
                        super(scene, 'animation_asset_profjuniper-atlas', 'juniper', 1 / 0.85);
                    }
                }
                character._Animation_asset_profjuniperSWF = _Animation_asset_profjuniperSWF;
            })(character = swf.character || (swf.character = {}));
        })(swf = assets.swf || (assets.swf = {}));
    })(assets = pbawp.assets || (pbawp.assets = {}));
})(pbawp || (pbawp = {}));
///<reference path="_BaseCharacterSWF.ts"/>
var pbawp;
(function (pbawp) {
    var assets;
    (function (assets) {
        var swf;
        (function (swf) {
            var character;
            (function (character) {
                class _Animation_asset_ronaldSWF extends character._BaseCharacterSWF {
                    constructor(scene) {
                        super(scene, 'animation_asset_ronald-atlas', 'ronald', 1 / 0.86, {
                            'name': 'ronald_effects',
                            'startFrame': 'ronald_effects0275',
                            'originX': 0.11 * 0.86,
                            'originY': -0.1 * 0.86
                        });
                    }
                }
                character._Animation_asset_ronaldSWF = _Animation_asset_ronaldSWF;
            })(character = swf.character || (swf.character = {}));
        })(swf = assets.swf || (assets.swf = {}));
    })(assets = pbawp.assets || (pbawp.assets = {}));
})(pbawp || (pbawp = {}));
///<reference path="_BaseCharacterSWF.ts"/>
var pbawp;
(function (pbawp) {
    var assets;
    (function (assets) {
        var swf;
        (function (swf) {
            var character;
            (function (character) {
                class _Animation_asset_slaughterhouseWorkersSWF extends character._BaseCharacterSWF {
                    constructor(scene) {
                        super(scene, 'animation_asset_slaughterhouseWorkers-atlas', 'slaughterhouseWorkers', 1 / 0.85, {
                            'name': 'slaughterhouseWorkers_effects',
                            'startFrame': 'slaughterhouseWorkers_effects0162',
                            'atlas': 'animation_asset_slaughterhouseWorkers_effects-atlas',
                            'originX': 0.05 * 0.85,
                            'originY': 0.15 * 0.85,
                            'scale': 1 / 0.85
                        });
                    }
                }
                character._Animation_asset_slaughterhouseWorkersSWF = _Animation_asset_slaughterhouseWorkersSWF;
            })(character = swf.character || (swf.character = {}));
        })(swf = assets.swf || (assets.swf = {}));
    })(assets = pbawp.assets || (pbawp.assets = {}));
})(pbawp || (pbawp = {}));
var pbawp;
(function (pbawp) {
    var assets;
    (function (assets) {
        var swf;
        (function (swf) {
            var character;
            (function (character) {
                class _Animation_asset_snivySWF extends character._BaseCharacterSWF {
                    constructor(scene) {
                        super(scene, 'animation_asset_snivy-atlas', 'snivy', 1 / 0.89, {
                            'name': 'snivy_effects',
                            'startFrame': 'snivy_effects0334',
                            'originX': -0.4 * 0.89,
                            'originY': -0.05 * 0.89
                        });
                    }
                }
                character._Animation_asset_snivySWF = _Animation_asset_snivySWF;
            })(character = swf.character || (swf.character = {}));
        })(swf = assets.swf || (assets.swf = {}));
    })(assets = pbawp.assets || (pbawp.assets = {}));
})(pbawp || (pbawp = {}));
///<reference path="_BaseCharacterSWF.ts"/>
var pbawp;
(function (pbawp) {
    var assets;
    (function (assets) {
        var swf;
        (function (swf) {
            var character;
            (function (character) {
                class _Animation_asset_tepigSWF extends character._BaseCharacterSWF {
                    constructor(scene) {
                        super(scene, 'animation_asset_tepig-atlas', 'tepig', 1 / 0.99, {
                            'name': 'tepig_effects',
                            'startFrame': 'tepig_effects0169',
                            'originX': -0.35 * 0.99,
                            'originY': -0.1 * 0.99
                        });
                    }
                }
                character._Animation_asset_tepigSWF = _Animation_asset_tepigSWF;
            })(character = swf.character || (swf.character = {}));
        })(swf = assets.swf || (assets.swf = {}));
    })(assets = pbawp.assets || (pbawp.assets = {}));
})(pbawp || (pbawp = {}));
var pbawp;
(function (pbawp) {
    var code;
    (function (code) {
        class StatEffect {
            constructor() {
                this.isNew = false;
                this.maxedOut = false;
                this.level = 0;
                this.negativeEffect = new Array();
                this.positiveEffect = new Array();
            }
            incrementLevel(increment) {
                var prevLevel = this.level;
                this.level = this.level + increment;
                this.level = Math.max(this.level, -(this.negativeEffect.length - 1));
                this.level = Math.min(this.level, this.positiveEffect.length - 1);
                this.isNew = true;
                this.maxedOut = false;
                if (prevLevel == this.level) {
                    this.maxedOut = true;
                }
                console.log("increment level: " + this.type + " --- " + this.level);
            }
            preAttack() {
                this.isNew = false;
            }
            postAttack() {
            }
            checkNew() {
                if (this.isNew) {
                    this.isNew = false;
                    return true;
                }
                return false;
            }
            getEffectFactor() {
                if (this.level > 0) {
                    console.log("get effect factor: " + this.type + " --- " + this.positiveEffect[this.level]);
                    return this.positiveEffect[this.level];
                }
                if (this.level < 0) {
                    console.log("get effect factor: " + this.type + " --- " + this.negativeEffect[Math.abs(this.level)]);
                    return this.negativeEffect[Math.abs(this.level)];
                }
                console.log("get effect factor: " + this.type + " --- 1");
                return 1;
            }
            applyEffect(baseStat) {
                return baseStat * this.getEffectFactor();
            }
        }
        code.StatEffect = StatEffect;
    })(code = pbawp.code || (pbawp.code = {}));
})(pbawp || (pbawp = {}));
///<reference path="StatEffect.ts"/>
var pbawp;
(function (pbawp) {
    var code;
    (function (code) {
        class AccuracyStatEffect extends pbawp.code.StatEffect {
            constructor() {
                super();
                this.positiveEffect = new Array(1.33, 1.66, 2, 2.33, 2.66, 3);
                this.negativeEffect = new Array(0.875, 0.8, 0.75, 0.714, 0.6875, 0.665);
                this.type = "accuracy";
            }
        }
        code.AccuracyStatEffect = AccuracyStatEffect;
    })(code = pbawp.code || (pbawp.code = {}));
})(pbawp || (pbawp = {}));
var pbawp;
(function (pbawp) {
    var code;
    (function (code) {
        class AttackButton extends pbawp.assets.fla._AttackButton {
            constructor(scene) {
                super(scene);
                this.isEnabled = false;
                this.elementType = "normal";
                this.down = () => {
                    this.gotoAndStop("mouseDown");
                    this.backgroundButtonGotoAndStop(this.elementType + "Down");
                    this.hoverImage.visible = false;
                };
                this.over = () => {
                    this.gotoAndStop("mouseOver");
                    this.backgroundButtonGotoAndStop(this.elementType + "Over");
                    this.hoverImage.visible = true;
                };
                this.out = () => {
                    this.gotoAndStop("mouseOut");
                    this.backgroundButtonGotoAndStop(this.elementType + "Out");
                    this.hoverImage.visible = false;
                };
                this.callback = null;
                this.hoverImage.scaleX = 0.98;
                this.tweenX = this.scene.tweens.add({
                    targets: this.hoverImage,
                    "scaleX": 1.01,
                    duration: 0.35 * 1000,
                    yoyo: true
                });
                this.hoverImage.scaleY = 0.98;
                this.tweenY = this.scene.tweens.add({
                    targets: this.hoverImage,
                    "scaleX": 1.01,
                    duration: 0.35 * 1000,
                    yoyo: true
                });
                this.gotoAndStop("disabled");
                this.hoverImage.visible = false;
            }
            setEnabled(newEnabled) {
                if (newEnabled && !this.isEnabled) {
                    this.background.setInteractive({ cursor: 'pointer' });
                    this.background.on('pointerdown', this.down);
                    this.background.on('pointerover', this.over);
                    this.background.on('pointerout', this.out);
                    this.out();
                }
                else if (!newEnabled && this.isEnabled) {
                    this.disableInteractive();
                    this.background.off('pointerdown', this.down);
                    this.background.off('pointerover', this.over);
                    this.background.off('pointerout', this.out);
                    this.gotoAndStop("disabled");
                }
                this.isEnabled = newEnabled;
            }
            setType(newType) {
                this.elementType = newType;
                this.elementSymbolGotoAndStop(this.elementType);
                this.backgroundButtonGotoAndStop(this.elementType + "Out");
                this.hoverImageGotoAndStop(this.elementType);
            }
            setNumber(newNum) {
                if (newNum == 1) {
                    this.backgroundGotoAndStop("topLeft");
                }
                else if (newNum == 2) {
                    this.backgroundGotoAndStop("bottomLeft");
                }
                else if (newNum == 3) {
                    this.backgroundGotoAndStop("topRight");
                }
                else {
                    this.backgroundGotoAndStop("bottomRight");
                }
            }
            addEventListenerClick(callback) {
                if (this.callback)
                    return;
                this.callback = callback;
                this.background.on('pointerup', this.callback);
            }
            removeEventListenerClick() {
                if (this.callback) {
                    this.background.off('pointerup', this.callback);
                    this.callback = null;
                }
            }
        }
        code.AttackButton = AttackButton;
    })(code = pbawp.code || (pbawp.code = {}));
})(pbawp || (pbawp = {}));
var pbawp;
(function (pbawp) {
    var code;
    (function (code) {
        class AttackMove extends Phaser.GameObjects.Container {
            constructor(xml, scene) {
                super(scene);
                this.elementType = "Normal";
                this.displayName = "";
                this.baseDamage = 0;
                this.baseSpeed = 0;
                this.className = null;
                this.accuracy = 100;
                this.recoil = 0;
                this.paralyze = 0;
                this.drain = 0;
                this.confuse = 0;
                this.poison = 0;
                this.trap = 0;
                this.sleep = 0;
                this.rest = 0;
                this.attackEffect = 0;
                this.defenseEffect = 0;
                this.evadeEffect = 0;
                this.accuracyEffect = 0;
                this.description = "";
                this.id = "";
                this.startScreenShake = new Array();
                this.endScreenShake = new Array();
                this.loadFromXML(xml);
            }
            loadFromXML(xml) {
                let shakes = null;
                let i = NaN;
                this.elementType = pbawp.util.XMLParser.getAttribute(xml, "type");
                this.displayName = pbawp.util.XMLParser.getAttribute(xml, "name");
                this.baseDamage = Number(pbawp.util.XMLParser.getAttribute(xml, "damage"));
                this.baseSpeed = Number(pbawp.util.XMLParser.getAttribute(xml, "speed"));
                this.maxPP = Number(pbawp.util.XMLParser.getAttribute(xml, "pp"));
                this.curPP = this.maxPP;
                this.description = pbawp.util.XMLParser.getAttribute(xml, "description");
                this.id = pbawp.util.XMLParser.getAttribute(xml, "id");
                let mcName = pbawp.util.XMLParser.getAttribute(xml, "mcName");
                if (!isEmpty(mcName)) {
                    this.className = mcName;
                }
                let accuracy = pbawp.util.XMLParser.getAttribute(xml, "accuracy");
                if (!isEmpty(accuracy)) {
                    this.accuracy = Number(accuracy);
                }
                let recoil = pbawp.util.XMLParser.getAttribute(xml, "recoil");
                if (!isEmpty(recoil)) {
                    this.recoil = Number(recoil) / 100;
                }
                let paralyze = pbawp.util.XMLParser.getAttribute(xml, "paralyze");
                if (!isEmpty(paralyze)) {
                    this.paralyze = Number(paralyze);
                }
                let drain = pbawp.util.XMLParser.getAttribute(xml, "drain");
                if (!isEmpty(drain)) {
                    this.drain = Number(drain) / 100;
                }
                let confuse = pbawp.util.XMLParser.getAttribute(xml, "confuse");
                if (!isEmpty(confuse)) {
                    this.confuse = Number(confuse);
                }
                let poison = pbawp.util.XMLParser.getAttribute(xml, "poison");
                if (!isEmpty(poison)) {
                    this.poison = Number(poison);
                }
                let trap = pbawp.util.XMLParser.getAttribute(xml, "trap");
                if (!isEmpty(trap)) {
                    this.trap = Number(trap);
                }
                let sleep = pbawp.util.XMLParser.getAttribute(xml, "sleep");
                if (!isEmpty(sleep)) {
                    this.sleep = Number(sleep);
                }
                let rest = pbawp.util.XMLParser.getAttribute(xml, "rest");
                if (!isEmpty(rest)) {
                    this.rest = Number(rest);
                }
                let attackEffect = pbawp.util.XMLParser.getAttribute(xml, "attackEffect");
                if (!isEmpty(attackEffect)) {
                    this.attackEffect = Number(attackEffect);
                }
                let defenseEffect = pbawp.util.XMLParser.getAttribute(xml, "defenseEffect");
                if (!isEmpty(defenseEffect)) {
                    this.defenseEffect = Number(defenseEffect);
                }
                let evadeEffect = pbawp.util.XMLParser.getAttribute(xml, "evadeEffect");
                if (!isEmpty(evadeEffect)) {
                    this.evadeEffect = Number(evadeEffect);
                }
                let accuracyEffect = pbawp.util.XMLParser.getAttribute(xml, "accuracyEffect");
                if (!isEmpty(accuracyEffect)) {
                    this.accuracyEffect = Number(accuracyEffect);
                }
                let shake = pbawp.util.XMLParser.getAttribute(xml, "shake");
                if (!isEmpty(shake)) {
                    shakes = String(shake).split(",");
                    for (i = 0; i < shakes.length; i = i + 2) {
                        this.startScreenShake.push(Number(shakes[i]));
                        this.endScreenShake.push(Number(shakes[i + 1]));
                    }
                }
            }
            reset() {
                this.curPP = this.maxPP;
            }
            loadStatusEffect(statusEffectID) {
                var xml = code.GameWorld.constants.getObjectWithID(statusEffectID, "statusEffects");
                this.loadFromXML(xml);
            }
            didAttackMiss() {
                var ran = Math.random() * 100;
                if (ran >= this.owner.applyStat("accuracy", this.accuracy)) {
                    return true;
                }
                return false;
            }
            usedMove() {
                this.curPP--;
                this.curPP = Math.max(0, this.curPP);
            }
            applyNegativeStatusEffects(c) {
                let ran = NaN;
                if (this.paralyze > 0) {
                    ran = Math.random() * 100;
                    if (ran <= this.paralyze) {
                        c.addStatusEffect("paralyze");
                    }
                }
                if (this.confuse > 0) {
                    ran = Math.random() * 100;
                    if (ran <= this.confuse) {
                        c.addStatusEffect("confuse");
                    }
                }
                if (this.trap > 0) {
                    ran = Math.random() * 100;
                    if (ran <= this.trap) {
                        c.addStatusEffect("trap");
                    }
                }
                if (this.poison > 0) {
                    ran = Math.random() * 100;
                    if (ran <= this.poison) {
                        c.addStatusEffect("poison");
                    }
                }
                if (this.sleep > 0) {
                    ran = Math.random() * 100;
                    if (ran <= this.sleep) {
                        c.addStatusEffect("sleep");
                    }
                }
            }
            applyStatusEffects(c) {
                var ran = NaN;
                if (this.paralyze > 0) {
                    ran = Math.random() * 100;
                    if (ran <= this.paralyze) {
                        c.addStatusEffect("paralyze");
                    }
                }
                if (this.confuse > 0) {
                    ran = Math.random() * 100;
                    if (ran <= this.confuse) {
                        c.addStatusEffect("confuse");
                    }
                }
                if (this.trap > 0) {
                    ran = Math.random() * 100;
                    if (ran <= this.trap) {
                        c.addStatusEffect("trap");
                    }
                }
                if (this.poison > 0) {
                    ran = Math.random() * 100;
                    if (ran <= this.poison) {
                        c.addStatusEffect("poison");
                    }
                }
            }
            applyStatEffects(c) {
                console.log("applying stat effects: " + this.attackEffect + " --- " + this.defenseEffect + " --- " + this.evadeEffect + " --- " + this.accuracyEffect);
                if (c == this.owner && this.attackEffect > 0 || c != this.owner && this.attackEffect < 0) {
                    c.incrementStat("attack", this.attackEffect);
                }
                if (c == this.owner && this.defenseEffect > 0 || c != this.owner && this.defenseEffect < 0) {
                    c.incrementStat("defense", this.defenseEffect);
                }
                if (c == this.owner && this.evadeEffect > 0 || c != this.owner && this.evadeEffect < 0) {
                    c.incrementStat("evasion", this.evadeEffect);
                }
                if (c == this.owner && this.accuracyEffect > 0 || c != this.owner && this.accuracyEffect < 0) {
                    c.incrementStat("accuracy", this.accuracyEffect);
                }
            }
        }
        code.AttackMove = AttackMove;
    })(code = pbawp.code || (pbawp.code = {}));
})(pbawp || (pbawp = {}));
var pbawp;
(function (pbawp) {
    var code;
    (function (code) {
        class Screen extends Phaser.GameObjects.Container {
            constructor(refToGameWorld, scene) {
                super(scene);
                this.shakeDistance = 5;
                this.isShakeUpdateStarted = false;
                this.shakeUpdate = () => {
                    this.x = this.shakeStartPosition.x + (-this.shakeDistance / 2 + Math.random() * this.shakeDistance);
                    this.y = this.shakeStartPosition.y + (-this.shakeDistance / 2 + Math.random() * this.shakeDistance);
                };
                this.gameworld = refToGameWorld;
                this.shakeStartPosition = new Phaser.Geom.Point();
            }
            keyIsDown(keyEvent) {
                return false;
            }
            keyPressed(keyEvent) {
                return false;
            }
            _destroy() {
            }
            stopInput() {
            }
            _update() {
                if (this.isShakeUpdateStarted) {
                    this.shakeUpdate();
                }
            }
            startShake() {
                this.isShakeUpdateStarted = true;
            }
            stopShake() {
                this.isShakeUpdateStarted = false;
                this.x = this.shakeStartPosition.x;
                this.y = this.shakeStartPosition.y;
            }
        }
        code.Screen = Screen;
    })(code = pbawp.code || (pbawp.code = {}));
})(pbawp || (pbawp = {}));
///<reference path="Screen.ts"/>
var pbawp;
(function (pbawp) {
    var code;
    (function (code) {
        class BattleManager extends pbawp.code.Screen {
            constructor(refToGameWorld, scene) {
                super(refToGameWorld, scene);
                this.sendOutPokemon = 0;
                this.previousPokemon = 0;
                this.statusSound = "";
                this.curKeyboardText = "";
                this.BATTLESTATE_INTRO = 0;
                this.BATTLESTATE_INTRO_DIALOG = 1;
                this.BATTLESTATE_MENU = 2;
                this.BATTLESTATE_WIN = 5;
                this.BATTLESTATE_GET_POKEMON = 7;
                this.BATTLESTATE_SWITCH_POKEMON = 9;
                this.BATTLESTATE_POKEMON_DETAIL = 10;
                this.BATTLESTATE_FIGHT_MENU = 11;
                this.BATTLESTATE_DIALOG = 12;
                this.battleState = -1;
                this.checkScript = () => {
                    if (this.actions.length > 0) {
                        if (pbawp.util.XMLParser.getAttribute(code.GameWorld.constants.getElementWithName("gamegenie"), "startBattleOverride") == "true") {
                            this.currentAction = this.actions.pop();
                            this.actions = new Array();
                        }
                        else {
                            this.currentAction = this.actions.shift();
                        }
                        this.performCurrentAction();
                    }
                };
                this.advanceDialog = () => {
                    if (this.dialogBox.isDone() && this.actions.length == 0) {
                        console.log("battle state: " + this.battleState);
                        if (this.battleState == this.BATTLESTATE_INTRO_DIALOG) {
                            this.battleState = this.BATTLESTATE_FIGHT_MENU;
                            this.checkBattleConditions();
                        }
                    }
                    this.dialogBox.advanceLine();
                };
                this.fight = () => {
                    if (this.player.canAttack()) {
                        this._setState(this.BATTLESTATE_FIGHT_MENU);
                    }
                    else {
                        this.dialogBox.addLine(code.GameWorld.constants.getOneLinerWithID("noMovesLeft").replace("%name%", this.player.displayName));
                        this.performAttackMove(this.player.struggleMove);
                    }
                };
                this.playAttackAnimation = () => {
                    console.log("play attack animation!");
                    if (this.attacker.isStatusTriggered("confuse")) {
                        console.log("attacker confused");
                        this.playHealthAnimation();
                    }
                    else if (this.currentAttackMove.didAttackMiss()) {
                        console.log("attack missed");
                        code.GameWorld.soundManager.playSound("dodge");
                        this.currentAttackMove.usedMove();
                        this.dialogBox.addLine(code.GameWorld.constants.getOneLinerWithID("missed"));
                        this.dialogBox.setNextClickCallback(this.checkAttackerStatusEffects);
                        this.dialogBox.advanceLine();
                        this.attacker.checkedRecoil = true;
                    }
                    else if (this.defender.didEvadeAttack(this.currentAttackMove)) {
                        console.log("attack evaded");
                        code.GameWorld.soundManager.playSound("dodge");
                        this.attacker.performMove(this.currentAttackMove, this.attackDodged);
                    }
                    else if (this.attacker.isStatusTriggered("paralyze")) {
                        console.log("attacker paralyzed");
                        this.checkBattleConditions();
                    }
                    else {
                        console.log("attack playing animation: " + this.currentAttackMove.className);
                        this.attacker.performMove(this.currentAttackMove, this.playHealthAnimation);
                    }
                };
                this.playHealthAnimation = () => {
                    var healthBar = null;
                    console.log("play health animation");
                    if (this.attacker.isStatusTriggered("confuse")) {
                        this.dialogBox.updateGenderPronounsWithCharacter(this.attacker);
                        this.dialogBox.addLine(code.GameWorld.constants.getOneLinerWithID("hurtConfused"));
                        this.dialogBox.updateText();
                        this.dialogBox.setNextClickCallback(this.checkAttackEffects);
                        this.attacker.applyConfuse(this.currentAttackMove);
                        if (this.attacker.curHealth < this.attacker.prevHealth) {
                            this.attacker.playFrame(this.attacker.getFrame("damage"));
                        }
                        healthBar = (this.attacker == this.player ? this.playerBattleInfo.healthBar : this.opponentBattleInfo.healthBar);
                        healthBar.updateHealth(this.attacker);
                    }
                    else {
                        if (pbawp.util.XMLParser.getAttribute(code.GameWorld.constants.getElementWithName("gamegenie"), "opponentOneHitKO") == "true" && this.attacker == this.opponent
                            || pbawp.util.XMLParser.getAttribute(code.GameWorld.constants.getElementWithName("gamegenie"), "playerOneHitKO") == "true" && this.attacker == this.player) {
                            this.currentAttackMove.baseDamage = this.defender.curHealth * 3;
                        }
                        this.defender.applyAttack(this.currentAttackMove);
                        this.currentAttackMove.applyStatEffects(this.attacker);
                        healthBar = (this.defender == this.player ? this.playerBattleInfo.healthBar : this.opponentBattleInfo.healthBar);
                        if (this.defender.curHealth != this.defender.prevHealth || this.currentAttackMove.className == "PerfumePulse") {
                            this.defender.playFrame(this.defender.getFrame("damage"));
                        }
                        healthBar.updateHealth(this.defender, this.showMoveDescription);
                    }
                };
                this.showMoveDescription = () => {
                    if (this.actions.length > 0 && pbawp.util.XMLParser.getAttribute(this.currentAction, "dialog") == "false") {
                        this.checkScript();
                    }
                    else if (this.currentAttackMove.description.length > 0) {
                        this.dialogBox.addLine(this.currentAttackMove.description);
                        this.dialogBox.updateText();
                        this.dialogBox.setNextClickCallback(this.checkAttackEffects);
                    }
                    else {
                        this.checkAttackEffects();
                    }
                };
                this.checkAttackEffects = () => {
                    console.log("check attack effects");
                    var effective = "";
                    var weaknessResistanceVar = code.GameWorld.constants.getWeaknessResistanceFactor(this.currentAttackMove.elementType, this.defender.elementType);
                    if (weaknessResistanceVar == 0.5 && this.currentAttackMove.baseDamage > 0) {
                        effective = code.GameWorld.constants.getOneLinerWithID("notEffective");
                    }
                    else if (weaknessResistanceVar == 2 && this.currentAttackMove.baseDamage > 0) {
                        effective = code.GameWorld.constants.getOneLinerWithID("superEffective");
                    }
                    else if (weaknessResistanceVar == 0 && this.currentAttackMove.baseDamage > 0) {
                        effective = code.GameWorld.constants.getOneLinerWithID(this.defender == this.player ? "notAffected" : "notAffectedEnemy").replace("%pokemon%", this.defender.displayName);
                    }
                    if (effective != "") {
                        this.dialogBox.addLine(effective);
                        this.dialogBox.updateText();
                        this.dialogBox.setNextClickCallback(this.checkDefenderStatusEffects);
                    }
                    else {
                        this.checkDefenderStatusEffects();
                    }
                };
                this.checkDefenderStatusEffects = () => {
                    console.log("check defender status effects");
                    this.dialogBox.updateGenderPronounsWithCharacter(this.defender);
                    if (this.attacker.getStatusEffect("rest") != null && this.attacker.getStatusEffect("rest").checkNew()) {
                        this.attacker.applyDamageEffects("rest", this.currentAttackMove);
                        this.applyAttackerStatusEffectDamage();
                        return;
                    }
                    if (this.defender.getDrain(this.currentAttackMove) > 0 && !this.defender.checkedDrain) {
                        this.defender.checkedDrain = true;
                        this.attacker.incrementHealth(this.defender.getDrain(this.currentAttackMove));
                        this.applyDefenderStatusEffectDamage();
                        return;
                    }
                    if (this.defender.getDrain(this.currentAttackMove) > 0 && !this.attacker.checkedDrain) {
                        this.attacker.checkedDrain = true;
                        this.dialogBox.addLineWithPluralCheck(code.GameWorld.constants.getOneLinerWithID(this.defender == this.opponent ? "enemyDrained" : "drained").replace("%name%", this.defender.displayName), this.defender.gender == "plural");
                    }
                    else if (this.defender.curHealth > 0) {
                        if (this.defender.getStatEffect("attack").checkNew()) {
                            if (this.defender.getStatEffect("attack").maxedOut) {
                                this.dialogBox.addLine(code.GameWorld.constants.getOneLinerWithID("statMaxed"));
                            }
                            else {
                                this.statusSound = "statDown";
                                this.dialogBox.addLineWithPluralCheck(code.GameWorld.constants.getOneLinerWithID(this.defender == this.opponent ? "enemyStatDecrease" : "statDecrease").replace("%namePossessive%", this.defender.displayPossessiveName).replace("%name%", this.defender.displayName).replace("%statName%", code.GameWorld.constants.getOneLinerWithID("statAttack")), this.defender.gender == "plural");
                            }
                        }
                        else if (this.defender.getStatEffect("defense").checkNew()) {
                            if (this.defender.getStatEffect("defense").maxedOut) {
                                this.dialogBox.addLine(code.GameWorld.constants.getOneLinerWithID("statMaxed"));
                            }
                            else {
                                this.statusSound = "statDown";
                                this.dialogBox.addLineWithPluralCheck(code.GameWorld.constants.getOneLinerWithID(this.defender == this.opponent ? "enemyStatDecrease" : "statDecrease").replace("%namePossessive%", this.defender.displayPossessiveName).replace("%name%", this.defender.displayName).replace("%statName%", code.GameWorld.constants.getOneLinerWithID("statDefense")), this.defender.gender == "plural");
                            }
                        }
                        else if (this.defender.getStatEffect("evasion").checkNew()) {
                            if (this.defender.getStatEffect("evasion").maxedOut) {
                                this.dialogBox.addLine(code.GameWorld.constants.getOneLinerWithID("statMaxed"));
                            }
                            else {
                                this.statusSound = "statDown";
                                this.dialogBox.addLineWithPluralCheck(code.GameWorld.constants.getOneLinerWithID(this.defender == this.opponent ? "enemyStatDecrease" : "statDecrease").replace("%namePossessive%", this.defender.displayPossessiveName).replace("%name%", this.defender.displayName).replace("%statName%", code.GameWorld.constants.getOneLinerWithID("statEvasion")), this.defender.gender == "plural");
                            }
                        }
                        else if (this.defender.getStatEffect("accuracy").checkNew()) {
                            if (this.defender.getStatEffect("accuracy").maxedOut) {
                                this.dialogBox.addLine(code.GameWorld.constants.getOneLinerWithID("statMaxed"));
                            }
                            else {
                                this.statusSound = "statDown";
                                this.dialogBox.addLineWithPluralCheck(code.GameWorld.constants.getOneLinerWithID(this.defender == this.opponent ? "enemyStatDecrease" : "statDecrease").replace("%namePossessive%", this.defender.displayPossessiveName).replace("%name%", this.defender.displayName).replace("%statName%", code.GameWorld.constants.getOneLinerWithID("statAccuracy")), this.defender.gender == "plural");
                            }
                        }
                        else if (this.defender.getStatusEffect("paralyze") != null && this.defender.getStatusEffect("paralyze").checkNew()) {
                            this.dialogBox.addLineWithPluralCheck(code.GameWorld.constants.getOneLinerWithID(this.defender == this.opponent ? "enemyBecameParalyzed" : "becameParalyzed").replace("%name%", this.defender.displayName), this.defender.gender == "plural");
                        }
                        else if (this.defender.getStatusEffect("sleep") != null && this.defender.getStatusEffect("sleep").checkNew()) {
                            this.dialogBox.addLineWithPluralCheck(code.GameWorld.constants.getOneLinerWithID(this.defender == this.opponent ? "enemyBecameAsleep" : "becameAsleep").replace("%name%", this.defender.displayName), this.defender.gender == "plural");
                            this.battleQueue.splice(0);
                        }
                        else if (this.defender.getStatusEffect("confuse") != null && this.defender.getStatusEffect("confuse").checkNew()) {
                            this.dialogBox.addLineWithPluralCheck(code.GameWorld.constants.getOneLinerWithID(this.defender == this.opponent ? "enemyBecameConfused" : "becameConfused").replace("%name%", this.defender.displayName), this.defender.gender == "plural");
                        }
                        else if (this.defender.getStatusEffect("trap") != null && this.defender.getStatusEffect("trap").checkNew()) {
                            this.dialogBox.addLineWithPluralCheck(code.GameWorld.constants.getOneLinerWithID(this.defender == this.opponent ? "enemyBecameTrapped" : "becameTrapped").replace("%name%", this.defender.displayName), this.defender.gender == "plural");
                        }
                        else if (this.defender.getStatusEffect("poison") != null && this.defender.getStatusEffect("poison").checkNew()) {
                            this.dialogBox.addLineWithPluralCheck(code.GameWorld.constants.getOneLinerWithID(this.defender == this.opponent ? "enemyBecamePoisoned" : "becamePoisoned").replace("%name%", this.defender.displayName), this.defender.gender == "plural");
                            this.defender.noEffectCheck = true;
                        }
                        else if (!this.defender.noEffectCheck && this.currentAttackMove.baseDamage == 0 && this.currentAttackMove.poison > 0) {
                            this.defender.noEffectCheck = true;
                            this.dialogBox.addLine(code.GameWorld.constants.getOneLinerWithID("statusNotEffected"));
                        }
                    }
                    if (this.statusSound != "") {
                        code.GameWorld.soundManager.playSound(this.statusSound);
                        this.statusSound = "";
                    }
                    if (this.dialogBox.isDone()) {
                        this.attacker.checkedDrain = false;
                        this.defender.checkedDrain = false;
                        this.checkAttackerStatusEffects();
                    }
                    else {
                        this.dialogBox.updateText();
                        this.dialogBox.setNextClickCallback(this.applyDefenderStatusEffectDamage);
                    }
                };
                this.applyDefenderStatusEffectDamage = () => {
                    console.log("apply defender status effect damage");
                    var attackerHealthBar = (this.attacker == this.player ? this.playerBattleInfo.healthBar : this.opponentBattleInfo.healthBar);
                    var defenderHealthBar = (this.defender == this.player ? this.playerBattleInfo.healthBar : this.opponentBattleInfo.healthBar);
                    if (this.defender.curHealth < this.defender.prevHealth) {
                        this.defender.playFrame(this.defender.getFrame("damage"));
                    }
                    if (this.attacker.curHealth / this.attacker.maxHealth != attackerHealthBar.scaleX) {
                        attackerHealthBar.updateHealth(this.attacker, this.checkDefenderStatusEffects);
                    }
                    else if (this.defender.curHealth / this.defender.maxHealth != defenderHealthBar.scaleX) {
                        defenderHealthBar.updateHealth(this.defender, this.checkDefenderStatusEffects);
                    }
                    else {
                        this.checkDefenderStatusEffects();
                    }
                };
                this.checkAttackerStatusEffects = () => {
                    console.log("check attacker status effects");
                    this.dialogBox.updateGenderPronounsWithCharacter(this.attacker);
                    if (this.attacker.getStatEffect("attack").checkNew()) {
                        if (this.attacker.getStatEffect("attack").maxedOut) {
                            this.dialogBox.addLine(code.GameWorld.constants.getOneLinerWithID("statMaxed"));
                        }
                        else {
                            this.statusSound = "statUp";
                            this.dialogBox.addLineWithPluralCheck(code.GameWorld.constants.getOneLinerWithID(this.attacker == this.opponent ? "enemyStatIncrease" : "statIncrease").replace("%namePossessive%", this.attacker.displayPossessiveName).replace("%name%", this.attacker.displayName).replace("%statName%", code.GameWorld.constants.getOneLinerWithID("statAttack")), this.attacker.gender == "plural");
                        }
                    }
                    else if (this.attacker.getStatEffect("defense").checkNew()) {
                        if (this.attacker.getStatEffect("defense").maxedOut) {
                            this.dialogBox.addLine(code.GameWorld.constants.getOneLinerWithID("statMaxed"));
                        }
                        else {
                            this.statusSound = "statUp";
                            this.dialogBox.addLineWithPluralCheck(code.GameWorld.constants.getOneLinerWithID(this.attacker == this.opponent ? "enemyStatIncrease" : "statIncrease").replace("%namePossessive%", this.attacker.displayPossessiveName).replace("%name%", this.attacker.displayName).replace("%statName%", code.GameWorld.constants.getOneLinerWithID("statDefense")), this.attacker.gender == "plural");
                        }
                    }
                    else if (this.attacker.getStatEffect("evasion").checkNew()) {
                        if (this.attacker.getStatEffect("evasion").maxedOut) {
                            this.dialogBox.addLine(code.GameWorld.constants.getOneLinerWithID("statMaxed"));
                        }
                        else {
                            this.statusSound = "statUp";
                            this.dialogBox.addLineWithPluralCheck(code.GameWorld.constants.getOneLinerWithID(this.attacker == this.opponent ? "enemyStatIncrease" : "statIncrease").replace("%namePossessive%", this.attacker.displayPossessiveName).replace("%name%", this.attacker.displayName).replace("%statName%", code.GameWorld.constants.getOneLinerWithID("statEvasion")), this.attacker.gender == "plural");
                        }
                    }
                    else if (this.attacker.getStatEffect("accuracy").checkNew()) {
                        if (this.attacker.getStatEffect("accuracy").maxedOut) {
                            this.dialogBox.addLine(code.GameWorld.constants.getOneLinerWithID("statMaxed"));
                        }
                        else {
                            this.statusSound = "statUp";
                            this.dialogBox.addLineWithPluralCheck(code.GameWorld.constants.getOneLinerWithID(this.attacker == this.opponent ? "enemyStatIncrease" : "statIncrease").replace("%namePossessive%", this.attacker.displayPossessiveName).replace("%name%", this.attacker.displayName).replace("%statName%", code.GameWorld.constants.getOneLinerWithID("statAccuracy")), this.attacker.gender == "plural");
                        }
                    }
                    else if (this.attacker.getRecoil(this.currentAttackMove) < 0 && !this.attacker.checkedRecoil) {
                        this.dialogBox.addLineWithPluralCheck(code.GameWorld.constants.getOneLinerWithID(this.attacker == this.opponent ? "enemyRecoilDamage" : "recoilDamage").replace("%name%", this.attacker.displayName), this.attacker.gender == "plural");
                        this.attacker.checkedRecoil = true;
                        this.attacker.applyDamageEffects("recoil", this.currentAttackMove);
                    }
                    else if (this.defender.curHealth > 0) {
                        if (this.attacker.checkStatusEffect("trap")) {
                            this.statusSound = "trap";
                            this.dialogBox.addLineWithPluralCheck(code.GameWorld.constants.getOneLinerWithID(this.attacker == this.opponent ? "enemyIsTrapped" : "isTrapped").replace("%name%", this.attacker.displayName), this.attacker.gender == "plural");
                            this.attacker.applyDamageEffects("trap", this.currentAttackMove);
                        }
                        else if (this.attacker.checkStatusEffect("poison")) {
                            this.statusSound = "poison";
                            this.dialogBox.addLineWithPluralCheck(code.GameWorld.constants.getOneLinerWithID(this.attacker == this.opponent ? "enemyIsPoisoned" : "isPoisoned").replace("%name%", this.attacker.displayName), this.attacker.gender == "plural");
                            this.attacker.applyDamageEffects("poison", this.currentAttackMove);
                        }
                        else if (!this.attacker.noEffectCheck && this.attacker.getStatusEffect("rest") == null && this.currentAttackMove.rest > 0) {
                            this.dialogBox.addLine(code.GameWorld.constants.getOneLinerWithID("statusNotEffected"));
                            this.attacker.noEffectCheck = true;
                        }
                    }
                    if (this.dialogBox.isDone()) {
                        this.attacker.checkedRecoil = false;
                        this.checkBattleConditions();
                    }
                    else {
                        this.dialogBox.setNextClickCallback(this.applyAttackerStatusEffectDamage);
                        this.dialogBox.updateText();
                    }
                };
                this.applyAttackerStatusEffectDamage = () => {
                    var attackerHealthBar = (this.attacker == this.player ? this.playerBattleInfo.healthBar : this.opponentBattleInfo.healthBar);
                    var defenderHealthBar = (this.defender == this.player ? this.playerBattleInfo.healthBar : this.opponentBattleInfo.healthBar);
                    if (this.attacker.curHealth < this.attacker.prevHealth) {
                        this.attacker.playFrame(this.attacker.getFrame("damage"));
                    }
                    if (this.statusSound != "") {
                        code.GameWorld.soundManager.playSound(this.statusSound);
                        this.statusSound = "";
                    }
                    if (this.attacker.curHealth / this.attacker.maxHealth != attackerHealthBar.scaleX) {
                        attackerHealthBar.updateHealth(this.attacker, this.checkAttackerStatusEffects);
                    }
                    else if (this.defender.curHealth / this.defender.maxHealth != defenderHealthBar.scaleX) {
                        defenderHealthBar.updateHealth(this.defender, this.checkAttackerStatusEffects);
                    }
                    else {
                        this.checkAttackerStatusEffects();
                    }
                };
                this.checkLose = () => {
                    console.log("check lose");
                    this.player.faint();
                    this.setMaskEnabled(this.playerMask, true, this.player);
                    this.updatePokemon();
                    var pokemonAlive = false;
                    for (var i = 0; i < this.gameworld.player.pokemon.length; i++) {
                        if (this.gameworld.player.pokemon[i].curHealth > 0) {
                            pokemonAlive = true;
                        }
                    }
                    if (pokemonAlive) {
                        this.choosePokemon();
                    }
                    else {
                        this.setAdvanceDialogEnabled(true);
                        this.dialogBox.addLine(code.GameWorld.constants.getOneLinerWithID("allFaint"));
                        this.dialogBox.updateText();
                        this.dialogBox.setNextClickCallback(this.gameOver);
                    }
                };
                this.gameOver = () => {
                    this.gameworld._setState(this.gameworld.GAMESTATE_GAME_OVER);
                };
                this.choosePokemon = () => {
                    this.gameworld.enableHelpButton(false);
                    if (this.gameworld.player.pokemon.length == 1) {
                        code.GameWorld.soundManager.playSound("error");
                        this.dialogBox.gotoAndStop("dialogOnly");
                        this.dialogBox.addLine(code.GameWorld.constants.getOneLinerWithID("noMorePokemon"));
                        this.dialogBox.updateText();
                        this.setAdvanceDialogEnabled(true);
                        this.dialogBox.setNextClickCallback(this.gotoBattleMenu);
                    }
                    else {
                        this._setState(this.BATTLESTATE_SWITCH_POKEMON);
                    }
                };
                this.back = () => {
                    if (this.battleState == this.BATTLESTATE_SWITCH_POKEMON) {
                        this._setState(this.BATTLESTATE_MENU);
                    }
                    else if (this.battleState == this.BATTLESTATE_POKEMON_DETAIL) {
                        this._setState(this.BATTLESTATE_SWITCH_POKEMON);
                    }
                    else if (this.battleState == this.BATTLESTATE_FIGHT_MENU) {
                        this._setState(this.BATTLESTATE_MENU);
                    }
                };
                this.viewPokemonStats = () => {
                    this.statsScreen = new code.Stats(this.gameworld.player.pokemon[this.sendOutPokemon], this, this.scene);
                    this.add(this.statsScreen);
                };
                this.sendPokemonIn = () => {
                    var curPokemon = this.gameworld.player.pokemon[this.sendOutPokemon];
                    this.dialogBox.gotoAndStop("dialogOnly");
                    this.dialogBox.addLine(code.GameWorld.constants.getOneLinerWithID("sendPokemonOut").replace("%pokemon%", curPokemon.displayName));
                    this.dialogBox.updateText();
                    this.setAdvanceDialogEnabled(true);
                    this.dialogBox.setNextClickCallback(this.startTransition);
                };
                this.startTransition = () => {
                    this.transitionEffect.fadeOut(this.player.animationClip.getMainCharacterSprite(), this.midTransition);
                };
                this.midTransition = () => {
                    this.transitionEffect.playTransition();
                    this.transitionEffect.fadeIn(this.player.animationClip.getMainCharacterSprite(), this.endTransition);
                    code.GameWorld.soundManager.playSound("switchPokemon");
                    if (this.player.curHealth > 0 && this.actions.length == 0) {
                        this.queueMove(this.opponent.getRandomMove());
                    }
                    this.player.unloadMovieClip();
                    if (this.actions.length == 0) {
                        this.gameworld.player.getCurrentPokemon()._swap(this.player);
                    }
                    this.gameworld.player.currentPokemon = this.sendOutPokemon;
                    this.dialogBox.updatePokemonDictionary(this.gameworld.player);
                    this.player._swap(this.gameworld.player.getCurrentPokemon());
                    this.player.reset();
                    this.player.loadMovieClip();
                    this.updateBattleInfo();
                };
                this.endTransition = () => {
                    if (this.actions.length > 0) {
                        this.checkScript();
                    }
                    else {
                        this.checkQueue();
                    }
                };
                this.setPokemonName = () => {
                    var newName = this.dialogBox.getNewPokemonName();
                    this.opponentPokemon.displayName = newName;
                    this.opponentPokemon.displayPossessiveName = newName + code.GameWorld.constants.getOneLinerWithID("possessiveAddOn");
                    this.gameworld.player.pokemon.push(this.opponentPokemon);
                    this.dialogBox.updatePokemonDictionary(this.gameworld.player);
                    this.checkScript();
                };
                this.gotoBattleMenu = () => {
                    this._setState(this.BATTLESTATE_MENU);
                };
                this.appearDone = () => {
                    this.setMaskEnabled(this.playerMask, false, this.opponentPokemon);
                };
                this.attackButtons = new Array();
                this.pokemonButtons = new Array();
                this.actions = new Array();
                this.battleQueue = new Array();
                this.transitionEffect = new code.TransitionEffect(this.scene);
                this.initializeView();
                code.FontHelper.updateTextField(this.opponentBattleInfo.displayName);
                code.FontHelper.updateTextField(this.playerBattleInfo.displayName);
                this.callInCheat = code.GameWorld.constants.getOneLinerWithID("cheatCode").toLowerCase();
                this.opponentPokemon.visible = false;
                this.attackButtons.push(this.dialogBox.attackButton1);
                this.attackButtons.push(this.dialogBox.attackButton2);
                this.attackButtons.push(this.dialogBox.attackButton3);
                this.attackButtons.push(this.dialogBox.attackButton4);
                this.pokemonButtons.push(this.dialogBox.pokemonButton1);
                this.pokemonButtons.push(this.dialogBox.pokemonButton2);
                this.pokemonButtons.push(this.dialogBox.pokemonButton3);
                this.pokemonButtons.push(this.dialogBox.pokemonButton4);
                this.advanceDialogButton.setInteractive({ cursor: 'pointer' });
                this.advanceDialogButton.on('pointerup', this.advanceDialog, this);
                this.dialogBox.fightButton.addEventListenerClick(this.fight);
                this.dialogBox.pokemonButton.addEventListenerClick(this.choosePokemon);
                this.dialogBox.sendInButton.addEventListenerClick(this.sendPokemonIn);
                this.dialogBox.statsButton.addEventListenerClick(this.viewPokemonStats);
                this.dialogBox.backButton.addEventListenerClick(this.back);
                this.dialogBox.submitButton.addEventListenerClick(this.setPokemonName);
                this.loadBattle(this.gameworld.player.currentBattle);
                this.init();
            }
            initializeView() {
                this.view = new pbawp.assets.fla._BattleManager(this.scene);
                this.add(this.view);
                this.background = this.view.background;
                this.background2 = this.view.background2;
                this.playerMask = this.view.playerMask;
                this.player = new code.Pokemon(this.scene);
                this.player.x = this.view.player.x;
                this.player.y = this.view.player.y;
                this.view.addAt(this.player, this.view.getIndex(this.view.player));
                this.view.remove(this.view.player);
                //this.view.player = this.player;
                this.opponentBattleInfo = new code.OpponentBattleInfo(this.scene);
                this.opponentBattleInfo.x = this.view.opponentBattleInfo.x;
                this.opponentBattleInfo.y = this.view.opponentBattleInfo.y;
                this.view.addAt(this.opponentBattleInfo, this.view.getIndex(this.view.opponentBattleInfo));
                this.view.remove(this.view.opponentBattleInfo);
                this.dialogBox = new code.DialogBox(this.scene);
                this.dialogBox.x = this.view.dialogBox.x;
                this.dialogBox.y = this.view.dialogBox.y;
                this.view.addAt(this.dialogBox, this.view.getIndex(this.view.dialogBox));
                this.view.remove(this.view.dialogBox);
                this.view.dialogBox = this.dialogBox;
                this.playerBattleInfo = new code.PlayerBattleInfo(this.scene);
                this.playerBattleInfo.x = this.view.playerBattleInfo.x;
                this.playerBattleInfo.y = this.view.playerBattleInfo.y;
                this.view.addAt(this.playerBattleInfo, this.view.getIndex(this.view.playerBattleInfo));
                this.view.remove(this.view.playerBattleInfo);
                this.opponent = new code.Trainer(this.scene);
                this.opponent.x = this.view.opponent.x;
                this.opponent.y = this.view.opponent.y;
                this.view.addAt(this.opponent, this.view.getIndex(this.view.opponent));
                this.view.remove(this.view.opponent);
                //this.view.opponent = this.opponent;
                this.opponentPokemon = new code.Pokemon(this.scene);
                this.opponentPokemon.x = this.view.opponentPokemon.x;
                this.opponentPokemon.y = this.view.opponentPokemon.y;
                this.view.addAt(this.opponentPokemon, this.view.getIndex(this.view.opponentPokemon));
                this.view.remove(this.view.opponentPokemon);
                //this.view.opponentPokemon = this.opponentPokemon;
                this.opponentMask = this.view.opponentMask;
                this.advanceDialogButton = this.view.advanceDialogButton;
                this.moveChildren(this.view, this);
            }
            moveChildren(from, to) {
                while (from.getAll().length > 0) {
                    var c = from.getAt(from.getAll().length - 1);
                    from.remove(c);
                    to.addAt(c, 0);
                }
            }
            init() {
                this.addAt(this.transitionEffect, this.getIndex(this.dialogBox) - 1);
            }
            _destroy() {
                this.gameworld.enableHelpButton(false);
                this.opponent._destroy();
                this.player._destroy();
                this.opponentPokemon._destroy();
                code.GameWorld.soundManager.playMusic("MusicMap", true);
                this.gameworld.remove(this.background2);
            }
            stopInput() {
                this.advanceDialogButton.off('pointerup', this.advanceDialog, this);
                this.dialogBox.fightButton.removeEventListenerClick(this.fight);
                this.dialogBox.pokemonButton.removeEventListenerClick(this.choosePokemon);
                this.dialogBox.sendInButton.removeEventListenerClick(this.sendPokemonIn);
                this.dialogBox.statsButton.removeEventListenerClick(this.viewPokemonStats);
                this.dialogBox.backButton.removeEventListenerClick(this.back);
                this.dialogBox.submitButton.removeEventListenerClick(this.setPokemonName);
            }
            keyIsDown(e) {
                if (this.statsScreen != null && e.keyCode == 32) {
                    this.statsScreen.cancelPressed();
                    return true;
                }
                return false;
            }
            keyPressed(e) {
                if (pbawp.util.XMLParser.getAttribute(code.GameWorld.constants.getElementWithName("gamegenie"), "skipBattleEnabled") == "true") {
                    if (e.keyCode == 49 && e.shiftKey) {
                        this.gameworld.player.pokemon.push(this.opponentPokemon);
                        this.gameworld.player.currentBattle++;
                        this.gameworld.setState(this.gameworld.GAMESTATE_MAP);
                        return true;
                    }
                    if (e.keyCode == 50 && e.shiftKey) {
                        this.player.curHealth = 0;
                        this.checkBattleConditions();
                        return true;
                    }
                }
                if (this.gameworld.player.canActivateCheat() && (this.battleState == this.BATTLESTATE_MENU || this.battleState == this.BATTLESTATE_FIGHT_MENU) && this.gameworld.help == null) {
                    this.curKeyboardText = this.curKeyboardText.concat(String.fromCharCode(e.keyCode)).toLowerCase();
                    console.log("cur cheat: " + this.curKeyboardText);
                    if (this.callInCheat.indexOf(this.curKeyboardText) == 0) {
                        if (this.callInCheat == this.curKeyboardText) {
                            console.log("cheat activated!");
                            this.gameworld.player.cheatActivated();
                            this.loadScript("battleCheat");
                        }
                    }
                    else {
                        console.log("clear cheat");
                        this.curKeyboardText = "";
                    }
                }
                if (e.keyCode == 32) {
                    if (this.advanceDialogButton["-enabled-"]) {
                        this.advanceDialog();
                        return true;
                    }
                    if (this.statsScreen != null) {
                        this.statsScreen.cancelReleased();
                    }
                }
                return false;
            }
            loadBattle(battleNum) {
                this.loadXML(code.GameWorld.constants.getBattleWithIndex(battleNum));
            }
            loadXML(xml) {
                console.log("BattleManager::loadXML");
                this.opponent.loadInfo(pbawp.util.XMLParser.getAttribute(xml, "opponentID"));
                this.opponent.loadMovieClip();
                this.gameworld.player.startBattlePokemon = this.gameworld.player.currentPokemon;
                this.endWinDialog = pbawp.util.XMLParser.getAttribute(xml, "winTextID");
                this.player._swap(this.gameworld.player.getCurrentPokemon());
                this.player.reset();
                this.player.loadMovieClip();
                this.setupBattleInfo();
                this.background["gotoAndStop"](pbawp.util.XMLParser.getAttribute(xml, "backgroundID"));
                this.background2["gotoAndStop"](pbawp.util.XMLParser.getAttribute(xml, "backgroundID"));
                code.GameWorld.soundManager.playMusic(pbawp.util.XMLParser.getAttribute(xml, "music"), true);
                this.loadScript(pbawp.util.XMLParser.getAttribute(xml, "startTextID"));
                return xml;
            }
            loadScript(battleScriptID) {
                this.actions.splice(0);
                let curBattleScript = code.GameWorld.constants.getBattleScriptWithID(battleScriptID);
                let action = pbawp.util.XMLParser.getChildNode(curBattleScript, "action");
                for (let a of action) {
                    this.actions.push(a);
                }
                this.checkScript();
            }
            performCurrentAction() {
                var newPokemon = undefined;
                var newPokemonID = undefined;
                var swapPokemon = undefined;
                var character = null;
                let currentActionID = pbawp.util.XMLParser.getAttribute(this.currentAction, "id");
                console.log("performing current action: " + currentActionID);
                this.setAdvanceDialogEnabled(true);
                if (currentActionID == "dialog") {
                    this.dialogBox.gotoAndStop("dialogOnly");
                    this.dialogBox.addLine(pbawp.util.XMLParser.getAttribute(this.currentAction, "text"));
                    this.dialogBox.updateText();
                    this.dialogBox.setNextClickCallback(this.checkScript);
                }
                else if (currentActionID == "setPokemon") {
                    newPokemon = new code.Pokemon(this.scene);
                    newPokemon.loadInfo(pbawp.util.XMLParser.getAttribute(this.currentAction, "newPokemonID"));
                    this.player.unloadMovieClip();
                    this.player._swap(newPokemon);
                    this.player.reset();
                    this.player.loadMovieClip();
                    this.player.curHealth = Number(pbawp.util.XMLParser.getAttribute(this.currentAction, "health"));
                    this.updateBattleInfo();
                    this.checkScript();
                }
                else if (currentActionID == "attack") {
                    if (pbawp.util.XMLParser.getAttribute(this.currentAction, "attacker") == "opponent") {
                        this.queueMove(this.opponent.getMoveWithID(pbawp.util.XMLParser.getAttribute(this.currentAction, "attack")));
                    }
                    else if (pbawp.util.XMLParser.getAttribute(this.currentAction, "attack") == "random") {
                        this.queueMove(this.player.getRandomMove());
                    }
                    else {
                        this.queueMove(this.player.getMoveWithID(pbawp.util.XMLParser.getAttribute(this.currentAction, "attack")));
                    }
                    this.checkQueue();
                }
                else if (currentActionID == "faint") {
                    if (pbawp.util.XMLParser.getAttribute(this.currentAction, "fainter") == "opponent") {
                        this.setMaskEnabled(this.opponentMask, true, this.opponent);
                        this.opponent.faint();
                        this.dialogBox.addLineWithPluralCheck(code.GameWorld.constants.getOneLinerWithID("enemyFaint").replace("%name%", this.opponent.displayName), this.opponent.gender == "plural");
                        this.dialogBox.updateText();
                        this.dialogBox.setNextClickCallback(this.checkScript);
                    }
                    else {
                        this.setMaskEnabled(this.playerMask, true, this.player);
                        this.player.faint();
                        this.checkScript();
                    }
                }
                else if (currentActionID == "swapPokemon") {
                    newPokemonID = pbawp.util.XMLParser.getAttribute(this.currentAction, "newPokemonID");
                    if (newPokemonID == "cheat") {
                        newPokemonID = this.gameworld.player.getPokemonCallIn();
                    }
                    if (newPokemonID == "original") {
                        newPokemonID = this.gameworld.player.pokemon[this.previousPokemon].id;
                    }
                    if (this.gameworld.player.getPokemonWithType(newPokemonID) == null) {
                        swapPokemon = new code.Pokemon(this.scene);
                        swapPokemon.loadInfo(newPokemonID);
                        this.gameworld.player.pokemon.push(swapPokemon);
                    }
                    this.previousPokemon = this.gameworld.player.getPokemonLocation(this.player.id);
                    this.sendOutPokemon = this.gameworld.player.getPokemonLocation(newPokemonID);
                    this.startTransition();
                }
                else if (currentActionID == "removePokemon") {
                    this.gameworld.player.pokemon.pop();
                    this.checkScript();
                }
                else if (currentActionID == "continueBattle") {
                    this.checkBattleConditions();
                }
                else if (currentActionID == "startBattle") {
                    this.opponent.reset();
                    this.player.reset();
                    this.gotoBattleMenu();
                    this.checkQueue();
                }
                else if (currentActionID == "namePokemon") {
                    this.setAdvanceDialogEnabled(false);
                    this._setState(this.BATTLESTATE_GET_POKEMON);
                }
                else if (currentActionID == "map") {
                    this.gameworld.player.currentBattle++;
                    this.gameworld._setState(this.gameworld.GAMESTATE_MAP);
                }
                else if (currentActionID == "animation") {
                    character = pbawp.util.XMLParser.getAttribute(this.currentAction, "character") == "opponent" ? this.opponent : this.player;
                    character.loopAnimation = null;
                    character.playFrame(pbawp.util.XMLParser.getAttribute(this.currentAction, "animation"), this.checkScript);
                }
            }
            setupBattleInfo() {
                this._setState(this.BATTLESTATE_INTRO_DIALOG);
                if (this.opponent.dropsPokemon != null) {
                    this.opponentPokemon.loadInfo(this.opponent.dropsPokemon);
                }
                this.updateBattleInfo();
                this.dialogBox.updatePokemonDictionary(this.gameworld.player);
                this.dialogBox.replaceString("%opponent%", this.opponent.displayName);
            }
            updateBattleInfo() {
                this.playerBattleInfo.displayName.text = this.player.displayName;
                this.playerBattleInfo.health.text = this.player.curHealth + " / " + this.player.maxHealth;
                this.playerBattleInfo.healthBar.scaleX = this.player.curHealth / this.player.maxHealth;
                this.playerBattleInfo.healthBar.updateScale();
                this.opponentBattleInfo.displayName.text = this.opponent.displayName;
                this.playerBattleInfo.genderGotoAndStop(this.player.gender);
                this.opponentBattleInfo.genderGotoAndStop(this.opponent.gender);
            }
            _update() {
                super._update();
                if (this.player)
                    this.player._update();
                if (this.opponent)
                    this.opponent._update();
                if (this.opponentPokemon)
                    this.opponentPokemon._update();
                this.transitionEffect._update();
                this.dialogBox._update();
                this.playerBattleInfo.health.text = Math.round(this.player.maxHealth * this.playerBattleInfo.healthBar.scaleX) + " / " + this.player.maxHealth;
            }
            updatePokemonMoves() {
                for (let i = 0; i < this.attackButtons.length; i++) {
                    if (i < this.player.moves.length) {
                        this.attackButtons[i].setType(this.player.moves[i].elementType);
                        this.attackButtons[i].setNumber(i + 1);
                        if (this.player.moves[i].curPP == 0) {
                            this.attackButtons[i].removeEventListenerClick();
                            this.attackButtons[i].setEnabled(false);
                        }
                        else {
                            this.attackButtons[i].addEventListenerClick(() => this.performAttack(i));
                            this.attackButtons[i].setEnabled(true);
                        }
                        this.attackButtons[i].ppAmount.text = this.player.moves[i].curPP + "/" + this.player.moves[i].maxPP;
                        this.attackButtons[i].moveName.text = this.player.moves[i].displayName;
                    }
                }
            }
            updatePokemon() {
                this.gameworld.player.getCurrentPokemon()._swap(this.player);
                for (let i = 0; i < this.pokemonButtons.length; i++) {
                    this.pokemonButtons[i].setNumber(i + 1);
                    if (i < this.gameworld.player.pokemon.length) {
                        this.pokemonButtons[i].setType(this.gameworld.player.pokemon[i].elementType);
                        if (this.gameworld.player.pokemon[i].curHealth == 0) {
                            this.pokemonButtons[i].removeEventListenerClick();
                            this.pokemonButtons[i].setEnabled(false);
                        }
                        else {
                            this.pokemonButtons[i].addEventListenerClick(() => this.attemptSwitchPokemon(i));
                            this.pokemonButtons[i].setEnabled(true);
                        }
                        this.pokemonButtons[i].pokemonName.text = this.gameworld.player.pokemon[i].displayName;
                        this.pokemonButtons[i].pokemonHealth.text = this.gameworld.player.pokemon[i].curHealth + "/" + this.gameworld.player.pokemon[i].maxHealth;
                        code.FontHelper.updateTextField(this.pokemonButtons[i].pokemonName);
                    }
                    else {
                        this.pokemonButtons[i].setEnabled(false);
                    }
                }
            }
            setAdvanceDialogEnabled(b) {
                if (b) {
                    this.advanceDialogButton.setInteractive({ cursor: 'pointer' });
                }
                else {
                    this.advanceDialogButton.disableInteractive();
                }
                this.advanceDialogButton["-enabled-"] = b;
            }
            setFightMenuEnabled(b) {
                for (var i = 0; i < this.attackButtons.length; i++) {
                    if (i < this.player.moves.length) {
                        this.attackButtons[i].visible = b;
                    }
                    else {
                        this.attackButtons[i].visible = false;
                    }
                }
            }
            performAttack(attackNum) {
                var playerMove = this.player.moves[attackNum];
                this.performAttackMove(playerMove);
            }
            performAttackMove(attackMove) {
                console.log("player performing attack: " + attackMove.displayName);
                var opponentMove = this.opponent.getRandomMove();
                var playerSpeed = this.player.applySpeedEffects(attackMove.baseSpeed);
                var opponentSpeed = this.opponent.applySpeedEffects(opponentMove.baseSpeed);
                if (attackMove.baseSpeed >= opponentMove.baseSpeed) {
                    this.queueMove(attackMove);
                    this.queueMove(opponentMove);
                }
                else {
                    this.queueMove(opponentMove);
                    this.queueMove(attackMove);
                }
                this.checkQueue();
            }
            queueMove(newMove) {
                this.battleQueue.push(newMove);
            }
            checkQueue() {
                let finalText = null;
                this._setState(this.BATTLESTATE_DIALOG);
                if (this.battleQueue.length > 0) {
                    this.dialogBox.gotoAndStop("dialogOnly");
                    this.currentAttackMove = this.battleQueue.shift();
                    finalText = "";
                    console.log("current attack move: " + this.currentAttackMove.displayName + " --- " + this.currentAttackMove.owner);
                    if (this.currentAttackMove.owner == this.opponent) {
                        this.attacker = this.opponent;
                        this.defender = this.player;
                        this.remove(this.defender);
                        this.addAt(this.defender, this.getIndex(this.transitionEffect) - 1);
                        this.remove(this.attacker);
                        this.addAt(this.attacker, this.getIndex(this.transitionEffect) - 1);
                    }
                    else {
                        this.attacker = this.player;
                        this.defender = this.opponent;
                        this.remove(this.attacker);
                        this.addAt(this.attacker, this.getIndex(this.transitionEffect) - 1);
                        this.remove(this.defender);
                        this.addAt(this.defender, this.getIndex(this.transitionEffect) - 1);
                    }
                    this.swap(this.defender, this.getAt(this.getIndex(this.defender) - 1));
                    this.currentAttackMove.owner = this.attacker;
                    this.dialogBox.updateGenderPronounsWithCharacter(this.attacker);
                    this.attacker.preAttack();
                    if (this.attacker.isStatusTriggered("paralyze")) {
                        finalText = code.GameWorld.constants.getOneLinerWithID(this.attacker == this.opponent ? "enemyIsParalyzed" : "isParalyzed").replace("%name%", this.attacker.displayName);
                    }
                    else if (this.attacker.isStatusTriggered("confuse")) {
                        this.currentAttackMove = this.attacker.confuseMove;
                        finalText = code.GameWorld.constants.getOneLinerWithID(this.attacker == this.opponent ? "enemyIsConfused" : "isConfused").replace("%name%", this.attacker.displayName);
                    }
                    else {
                        finalText = code.GameWorld.constants.getOneLinerWithID(this.attacker == this.opponent ? "enemyPerformMove" : "performMove").replace("%name%", this.attacker.displayName).replace("%move%", this.currentAttackMove.displayName);
                    }
                    this.setAdvanceDialogEnabled(true);
                    this.dialogBox.addLineWithPluralCheck(finalText);
                    this.dialogBox.updateText();
                    this.dialogBox.setNextClickCallback(this.playAttackAnimation);
                }
                else {
                    this.player.postQueueStatusEffectUpdate();
                    if (this.player.isStatusTriggered("confuse")) {
                        this.performAttack(Math.floor(Math.random() * this.player.moves.length));
                    }
                    else if (this.player.isStatusTriggered("sleep")) {
                        this.queueMove(this.opponent.getRandomMove());
                        this.checkQueue();
                    }
                    else {
                        this._setState(this.BATTLESTATE_MENU);
                    }
                }
            }
            attackDodged() {
                this.defender.playFrame(this.defender.getFrame("dodge"));
                this.dialogBox.updateGenderPronounsWithCharacter(this.defender);
                this.currentAttackMove.usedMove();
                this.dialogBox.addLine(code.GameWorld.constants.getOneLinerWithID(this.defender == this.player ? "avoid" : "enemyAvoid").replace("%name%", this.defender.displayName));
                this.dialogBox.setNextClickCallback(this.checkAttackerStatusEffects);
                this.dialogBox.advanceLine();
                this.attacker.checkedRecoil = true;
            }
            checkPostAttackEffects() {
                var healthBar = null;
                if (this.defender.getDrain(this.currentAttackMove) > 0) {
                    this.attacker.incrementHealth(this.defender.getDrain(this.currentAttackMove));
                    healthBar = (this.attacker == this.player ? this.playerBattleInfo.healthBar : this.opponentBattleInfo.healthBar);
                    healthBar.updateHealth(this.attacker, this.checkDefenderStatusEffects);
                }
                else if (this.attacker.getStatusEffect("rest") != null && this.attacker.getStatusEffect("rest").checkNew()) {
                    this.dialogBox.addLineWithPluralCheck(code.GameWorld.constants.getOneLinerWithID(this.attacker == this.opponent ? "enemyBecameRested" : "becameRested").replace("%name%", this.attacker.displayName), this.attacker.gender == "plural");
                    this.attacker.applyDamageEffects("rest", this.currentAttackMove);
                }
            }
            checkBattleConditions() {
                console.log("check battle conditions");
                if (this.currentAttackMove != null) {
                    this.currentAttackMove.owner = this.attacker;
                    this.attacker.postAttack();
                }
                if (this.actions.length > 0) {
                    this.checkScript();
                }
                if (this.opponent.curHealth <= 0) {
                    this._setState(this.BATTLESTATE_WIN);
                }
                else if (this.player.curHealth <= 0) {
                    if (this.actions.length > 0) {
                        this.checkScript();
                    }
                    else {
                        this.battleQueue.splice(0);
                        this.dialogBox.addLine(code.GameWorld.constants.getOneLinerWithID("faint").replace("%pokemon%", this.player.displayName));
                        this.dialogBox.updateText();
                        this.dialogBox.setNextClickCallback(this.checkLose);
                        if (this.opponent.id == "mysteriousStranger") {
                            sendEvent(petaGA_GameCategory_Game, 'Die Mysterious Stranger', 'Pokémon Red White and Blue - Die Mysterious Stranger');
                        }
                        else if (this.opponent.id == "mcdonaldsCustomer") {
                            sendEvent(petaGA_GameCategory_Game, 'Die McDonald\'s Customer', 'Pokémon Red White and Blue - Die McDonald\'s Customer');
                        }
                        else if (this.opponent.id == "slaughterhouseWorkers") {
                            sendEvent(petaGA_GameCategory_Game, 'Die Slaughterhouse Workers', 'Pokémon Red White and Blue - Die Slaughterhouse Workers');
                        }
                        else if (this.opponent.id == "ronald") {
                            sendEvent(petaGA_GameCategory_Game, 'Die Ronald McDonald', 'Pokémon Red White and Blue - Die Ronald McDonald');
                        }
                    }
                }
                else {
                    this.checkQueue();
                }
            }
            setMaskEnabled(maskMC, newEnabled, maskee) {
                if (newEnabled) {
                    maskMC.x = 0;
                    maskMC.y = 0;
                    maskee.setMask(maskMC.createGeometryMask());
                }
                else {
                    maskMC.x = 600;
                    maskMC.y = 600;
                    maskee.setMask(null);
                }
            }
            attemptSwitchPokemon(pokemonNum) {
                if (pokemonNum == this.gameworld.player.currentPokemon) {
                    this.dialogBox.gotoAndStop("dialogOnly");
                    this.setAdvanceDialogEnabled(true);
                    this.dialogBox.addLine(code.GameWorld.constants.getOneLinerWithID("alreadyInBattle").replace("%pokemon%", this.player.displayName));
                    this.dialogBox.updateText();
                    this.dialogBox.setNextClickCallback(this.gotoBattleMenu);
                }
                else {
                    this.sendOutPokemon = pokemonNum;
                    this._setState(this.BATTLESTATE_POKEMON_DETAIL);
                }
            }
            closeStats() {
                this.remove(this.statsScreen);
                this.statsScreen = null;
            }
            _setState(newState) {
                console.log("setting new state: " + newState + " --- old state: " + this.battleState);
                this.gameworld.enableHelpButton(false);
                switch (newState) {
                    case this.BATTLESTATE_INTRO_DIALOG:
                        break;
                    case this.BATTLESTATE_MENU:
                        if (!this.gameworld.helpShown) {
                            this.gameworld.showHelp();
                            this.gameworld.helpShown = true;
                        }
                        this.setMaskEnabled(this.playerMask, false, this.player);
                        this.setMaskEnabled(this.opponentMask, false, this.opponent);
                        this.gameworld.enableHelpButton(true);
                        this.dialogBox.gotoAndStop("mainMenu");
                        this.setAdvanceDialogEnabled(false);
                        this.dialogBox.setText(code.GameWorld.constants.getOneLinerWithID("waitForAction").replace("%pokemon%", this.player.displayName));
                        break;
                    case this.BATTLESTATE_WIN:
                        this.opponentBattleInfoTween = this.scene.tweens.add({
                            targets: this.opponentBattleInfo,
                            "x": this.opponentBattleInfo.x - 400,
                            duration: 0.5 * 1000,
                            ease: Phaser.Math.Easing.Linear
                        });
                        this.playerBattleInfoTween = this.scene.tweens.add({
                            targets: this.playerBattleInfo,
                            "x": this.playerBattleInfo.x + 400,
                            duration: 0.5 * 1000,
                            ease: Phaser.Math.Easing.Linear
                        });
                        this.opponent.stopFrame("Defeated");
                        console.warn("this.opponent.stopFrame(\"defeat\");");
                        this.updatePokemon();
                        code.GameWorld.soundManager.playMusic("MusicWin", true);
                        this.dialogBox.gotoAndStop("dialogOnly");
                        this.loadScript(this.endWinDialog);
                        if (this.opponent.id == "mysteriousStranger") {
                            sendEvent(petaGA_GameCategory_Game, 'Win Mysterious Stranger', 'Pokémon Red White and Blue - Win Mysterious Stranger');
                        }
                        else if (this.opponent.id == "mcdonaldsCustomer") {
                            sendEvent(petaGA_GameCategory_Game, 'Win McDonald\'s Customer', 'Pokémon Red White and Blue - Win McDonald\'s Customer');
                        }
                        else if (this.opponent.id == "slaughterhouseWorkers") {
                            sendEvent(petaGA_GameCategory_Game, 'Win Slaughterhouse Workers', 'Pokémon Red White and Blue - Win Slaughterhouse Workers');
                        }
                        else if (this.opponent.id == "ronald") {
                            sendEvent(petaGA_GameCategory_Game, 'Win Ronald McDonald', 'Pokémon Red White and Blue - Win Ronald McDonald');
                        }
                        break;
                    case this.BATTLESTATE_GET_POKEMON:
                        this.opponentPokemon.visible = true;
                        this.opponentPokemon.loadMovieClip();
                        this.setMaskEnabled(this.playerMask, true, this.opponentPokemon);
                        this.opponentPokemon.appear(this.appearDone);
                        this.remove(this.opponentPokemon);
                        this.addAt(this.opponentPokemon, this.getIndex(this.player) + 1);
                        this.dialogBox.gotoAndStop("pokemonGet");
                        this.dialogBox.setNewPokemonName(this.opponentPokemon.displayName);
                        this.dialogBox.setText(code.GameWorld.constants.getOneLinerWithID("namePokemon").replace("%pokemon%", this.opponentPokemon.displayName));
                        break;
                    case this.BATTLESTATE_SWITCH_POKEMON:
                        this.dialogBox.backButton.visible = this.player.curHealth > 0;
                        this.setAdvanceDialogEnabled(false);
                        this.dialogBox.gotoAndStop("switchPokemon");
                        this.updatePokemon();
                        break;
                    case this.BATTLESTATE_POKEMON_DETAIL:
                        this.dialogBox.gotoAndStop("confirmPokemon");
                        this.dialogBox.backButton.visible = true;
                        this.setAdvanceDialogEnabled(false);
                        this.dialogBox.pokemonName.text = this.gameworld.player.pokemon[this.sendOutPokemon].displayName;
                        break;
                    case this.BATTLESTATE_FIGHT_MENU:
                        this.dialogBox.gotoAndStop("fight");
                        this.setAdvanceDialogEnabled(false);
                        this.setFightMenuEnabled(true);
                        this.updatePokemonMoves();
                }
                this.battleState = newState;
            }
        }
        code.BattleManager = BattleManager;
    })(code = pbawp.code || (pbawp.code = {}));
})(pbawp || (pbawp = {}));
var pbawp;
(function (pbawp) {
    var code;
    (function (code) {
        class Character extends Phaser.GameObjects.Container {
            constructor(scene) {
                super(scene);
                this.maxHealth = 0;
                this.curHealth = 0;
                this.prevHealth = 0;
                this.gender = "";
                this.displayName = "";
                this.displayPossessiveName = "";
                this.elementType = "Normal";
                this.lastDamageReceived = 0;
                this.lastDamageDealt = 0;
                this.evasion = 0;
                this.id = "";
                this.animationClip = null;
                this.curAnimation = "ready";
                this.curAnimationCallback = null;
                this.loopAnimation = "ready";
                this.noEffectCheck = false;
                this.isAddedEventListener_ENTER_FRAME = false;
                this.appearDone = () => {
                    if (this.appearCallback != null) {
                        this.appearCallback();
                    }
                    this.appearCallback = null;
                };
                this.moves = new Array();
                this.statusEffects = new Array();
                this.statEffects = new Array();
                this.animationFrames = new Object();
                this.startScreenShake = new Array();
                this.endScreenShake = new Array();
                this.initY = this.y;
            }
            loadFromXML(xml) {
                var a = null;
                this.maxHealth = Number(pbawp.util.XMLParser.getAttribute(xml, "health"));
                this.curHealth = this.maxHealth;
                this.prevHealth = this.curHealth;
                this.gender = pbawp.util.XMLParser.getAttribute(xml, "gender");
                this.displayName = pbawp.util.XMLParser.getAttribute(xml, "displayName");
                this.displayPossessiveName = pbawp.util.XMLParser.getAttribute(xml, "possessiveName");
                this.elementType = pbawp.util.XMLParser.getAttribute(xml, "type");
                this.id = pbawp.util.XMLParser.getAttribute(xml, "id");
                this.swfName = pbawp.util.XMLParser.getAttribute(xml, "swfName");
                this.statusEffects.splice(0);
                let readyFrame = pbawp.util.XMLParser.getAttribute(xml, "readyFrame");
                if (!isEmpty(readyFrame)) {
                    this.animationFrames["ready"] = readyFrame;
                    this.animationFrames["damage"] = pbawp.util.XMLParser.getAttribute(xml, "damageFrame");
                    this.animationFrames["dodge"] = pbawp.util.XMLParser.getAttribute(xml, "dodgeFrame");
                }
                else {
                    this.animationFrames["ready"] = null;
                    this.animationFrames["damage"] = null;
                    this.animationFrames["dodge"] = null;
                }
                let evasion = pbawp.util.XMLParser.getAttribute(xml, "evasion");
                if (!isEmpty(evasion)) {
                    this.evasion = Number(evasion);
                }
                this.moves.splice(0);
                let _moves = pbawp.util.XMLParser.getChildNode(xml, 'moves');
                let _move = pbawp.util.XMLParser.getChildNode(_moves, 'move');
                for (let _m of _move) {
                    a = new code.AttackMove(_m, this.scene);
                    a.owner = this;
                    this.moves.push(a);
                }
                this.confuseMove = new code.AttackMove(code.GameWorld.constants.getObjectWithID("confusion", "statusEffects"), this.scene);
                this.resetStatEffects();
                return xml;
            }
            _destroy() {
                this.unloadMovieClip();
            }
            getSWF(swfName) {
                if (swfName == "trainers/animation_asset_cheren.swf")
                    return new pbawp.assets.swf.character._Animation_asset_cherenSWF(this.scene);
                if (swfName == "trainers/animation_asset_profjuniper.swf")
                    return new pbawp.assets.swf.character._Animation_asset_profjuniperSWF(this.scene);
                if (swfName == "trainers/animation_asset_ghetsis.swf")
                    return new pbawp.assets.swf.character._Animation_asset_ghetsisSWF(this.scene);
                if (swfName == "trainers/animation_asset_ash.swf")
                    return new pbawp.assets.swf.character._Animation_asset_ashSWF(this.scene);
                if (swfName == "pokemon/animation_asset_pikachu.swf")
                    return new pbawp.assets.swf.character._Animation_asset_pikachuSWF(this.scene);
                if (swfName == "pokemon/animation_asset_tepig.swf")
                    return new pbawp.assets.swf.character._Animation_asset_tepigSWF(this.scene);
                if (swfName == "pokemon/animation_asset_snivy.swf")
                    return new pbawp.assets.swf.character._Animation_asset_snivySWF(this.scene);
                if (swfName == "pokemon/animation_asset_oshawott.swf")
                    return new pbawp.assets.swf.character._Animation_asset_oshawottSWF(this.scene);
                if (swfName == "pokemon/animation_asset_grimace.swf")
                    return new pbawp.assets.swf.character._Animation_asset_grimaceSWF(this.scene);
                if (swfName == "pokemon/animation_asset_jigglypuff.swf")
                    return new pbawp.assets.swf.character._Animation_asset_jigglypuffSWF(this.scene);
                if (swfName == "trainers/animation_asset_mcdonaldscustomer.swf")
                    return new pbawp.assets.swf.character._Animation_asset_mcdonaldsCustomerSWF(this.scene);
                if (swfName == "pokemon/animation_asset_miltank.swf")
                    return new pbawp.assets.swf.character._Animation_asset_miltankSWF(this.scene);
                if (swfName == "trainers/animation_asset_mysteriousstranger.swf")
                    return new pbawp.assets.swf.character._Animation_asset_mysteriousStrangerSWF(this.scene);
                if (swfName == "trainers/animation_asset_ronald.swf")
                    return new pbawp.assets.swf.character._Animation_asset_ronaldSWF(this.scene);
                if (swfName == "trainers/animation_asset_slaughterhouseworkers.swf")
                    return new pbawp.assets.swf.character._Animation_asset_slaughterhouseWorkersSWF(this.scene);
                return null;
            }
            loadMovieClip() {
                this.animationClip = this.getSWF(this.swfName);
                this.playFrame(this.getFrame("ready"));
                this.add(this.animationClip);
                this.isAddedEventListener_ENTER_FRAME = true;
            }
            unloadMovieClip() {
                if (this.animationClip != null) {
                    this.remove(this.animationClip);
                    this.stopFrame(this.getFrame("ready"));
                }
                this.isAddedEventListener_ENTER_FRAME = false;
            }
            getFrame(frameName) {
                return this.animationFrames[frameName];
            }
            performMove(a, callback = null) {
                this.startScreenShake = a.startScreenShake;
                this.endScreenShake = a.endScreenShake;
                this.playFrame(a.className, callback);
            }
            playFrame(frameName, callback = null) {
                console.log("playing frame: " + frameName + " --- " + this.displayName + " --- " + name);
                this.curAnimation = frameName;
                this.curAnimationCallback = callback;
                this.animationClip.gotoAndPlay(frameName);
            }
            stopFrame(frameName) {
                this.curAnimation = frameName;
                this.animationClip.gotoAndStop(frameName);
            }
            loopFrame(frameName) {
                this.playFrame(this.getFrame(frameName));
                this.loopAnimation = frameName;
            }
            _update() {
                if (!this.isAddedEventListener_ENTER_FRAME)
                    return;
                if (this.animationClip != null) {
                    if (this.startScreenShake.length > 0 && this.endScreenShake.length > 0) {
                        let currentFrame = this.animationClip.getCurrentFrame();
                        if (currentFrame == this.startScreenShake[0]) {
                            code.GameWorld.currentScreen.startShake();
                        }
                        else if (code.GameWorld.currentScreen.isShakeUpdateStarted && (currentFrame >= this.endScreenShake[0] || currentFrame < this.startScreenShake[0])) {
                            code.GameWorld.currentScreen.stopShake();
                            this.startScreenShake.shift();
                            this.endScreenShake.shift();
                        }
                    }
                    if (this.getFrame("ready") != null && this.animationClip.isDonePlayingCurrentLabel() && this.curAnimation != this.animationClip.getCurrentPlayingLabel()) {
                        // console.log("done playing frame: " + this.curAnimation);
                        if (this.curAnimationCallback != null) {
                            this.curAnimationCallback();
                        }
                        if (this.loopAnimation != null && this.getFrame(this.loopAnimation) != null) {
                            this.playFrame(this.getFrame(this.loopAnimation));
                        }
                    }
                }
            }
            applyAttack(a) {
                a.applyStatusEffects(this);
                var finalDamage = a.owner.applyStat("attack", a.baseDamage) / this.getStatFactor("defense");
                finalDamage = finalDamage * code.GameWorld.constants.getWeaknessResistanceFactor(a.elementType, this.elementType);
                finalDamage = Math.floor(finalDamage);
                //-----------------------------------
                if (game["cheat-finalDamage-multiplier"]) {
                    finalDamage *= game["cheat-finalDamage-multiplier"];
                }
                //-----------------------------------
                this.incrementHealth(-finalDamage);
                this.lastDamageReceived = finalDamage;
                a.owner.lastDamageDealt = finalDamage;
                a.applyStatEffects(this);
                a.usedMove();
            }
            applyConfuse(a) {
                this.incrementHealth(-a.baseDamage);
                this.lastDamageReceived = a.baseDamage;
            }
            canAttack() {
                let a = null;
                for (let a of this.moves) {
                    if (a.curPP > 0) {
                        return true;
                    }
                }
                return false;
            }
            didEvadeAttack(a) {
                var finalEvasion = this.applyStat("evasion", 100 - this.evasion);
                var ran = Math.random() * 100;
                if (ran > finalEvasion) {
                    return true;
                }
                return false;
            }
            applyStat(statID, baseStat) {
                return this.getStatEffect(statID).applyEffect(baseStat);
            }
            getStatFactor(statID) {
                return this.getStatEffect(statID).getEffectFactor();
            }
            incrementStat(statID, increment) {
                this.getStatEffect(statID).incrementLevel(increment);
            }
            getRecoil(a) {
                return -Math.floor(this.lastDamageDealt * a.recoil);
            }
            getDrain(a) {
                return Math.floor(this.lastDamageReceived * a.drain);
            }
            _swap(c) {
                this.maxHealth = c.maxHealth;
                this.curHealth = c.curHealth;
                this.gender = c.gender;
                this.animationFrames = c.animationFrames;
                this.displayName = c.displayName;
                this.moves = c.moves;
                this.confuseMove = c.confuseMove;
                this.struggleMove = c.struggleMove;
                this.statusEffects = c.statusEffects;
                this.statusEffects = c.statusEffects;
                this.statEffects = c.statEffects;
                this.evasion = c.evasion;
                this.swfName = c.swfName;
                this.elementType = c.elementType;
                this.id = c.id;
                this.displayPossessiveName = c.displayPossessiveName;
            }
            preAttack() {
                var s = null;
                var stat = null;
                this.noEffectCheck = false;
                for (let s of this.statusEffects) {
                    s.preAttack();
                }
                for (let stat of this.statEffects) {
                    stat.preAttack();
                }
            }
            postAttack() {
                var s = null;
                var i = NaN;
                var stat = null;
                this.lastDamageReceived = 0;
                for (let s of this.statusEffects) {
                    s.postAttack();
                }
                for (i = 0; i < this.statusEffects.length; i++) {
                    s = this.statusEffects[i];
                    if (s.turnsLeft <= 0) {
                        this.statusEffects.splice(i, 1);
                        i--;
                    }
                }
                for (let stat of this.statEffects) {
                    stat.postAttack();
                }
            }
            postQueueStatusEffectUpdate() {
                let s = null;
                for (s of this.statusEffects) {
                    s.postQueueStatusEffectUpdate();
                }
            }
            getRandomMove() {
                var a = null;
                var safeCounter = 0;
                do {
                    a = this.moves[Math.floor(Math.random() * this.moves.length)];
                    safeCounter++;
                } while (a.curPP <= 0 || safeCounter >= 5);
                return a;
            }
            getMoveWithID(moveID) {
                for (var i = 0; i < this.moves.length; i++) {
                    if (this.moves[i].id == moveID) {
                        return this.moves[i];
                    }
                }
                return null;
            }
            isStatusTriggered(statusType) {
                var s = null;
                for (let s of this.statusEffects) {
                    if (s.type == statusType) {
                        return s.triggered;
                    }
                }
                return false;
            }
            addStatusEffect(statusType) {
                var pa = null;
                var c = null;
                var t = null;
                var po = null;
                var s = null;
                var r = null;
                for (var i = 0; i < this.statusEffects.length; i++) {
                    if (this.statusEffects[i].type == statusType) {
                        return;
                    }
                }
                if (statusType == "paralyze") {
                    pa = new code.Paralyze();
                    this.statusEffects.push(pa);
                }
                else if (statusType == "confuse") {
                    c = new code.Confusion();
                    this.statusEffects.push(c);
                }
                else if (statusType == "trap") {
                    t = new code.Trap();
                    this.statusEffects.push(t);
                }
                else if (statusType == "poison") {
                    po = new code.Poison();
                    this.statusEffects.push(po);
                }
                else if (statusType == "sleep") {
                    s = new code.Sleep();
                    this.statusEffects.push(s);
                }
                else if (statusType == "rest") {
                    r = new code.Rest();
                    this.statusEffects.push(r);
                }
            }
            getStatusEffect(statusType) {
                let s = null;
                for (s of this.statusEffects) {
                    if (s.type == statusType) {
                        return s;
                    }
                }
                return null;
            }
            getStatEffect(statID) {
                let s = null;
                for (s of this.statEffects) {
                    if (s.type == statID) {
                        return s;
                    }
                }
                return null;
            }
            checkStatusEffect(statusType) {
                let s = null;
                if (this.isStatusTriggered(statusType)) {
                    s = this.getStatusEffect(statusType);
                    if (!s.checked) {
                        s.checked = true;
                        return true;
                    }
                }
                return false;
            }
            applySpeedEffects(baseSpeed) {
                var p = null;
                if (this.isStatusTriggered("paralyze")) {
                    p = this.getStatusEffect("paralyze");
                    baseSpeed = Math.floor(baseSpeed * p.speedMod);
                }
                return baseSpeed;
            }
            applyDamageEffects(statusType, a) {
                var t = null;
                var p = null;
                if (statusType == "trap") {
                    t = this.getStatusEffect("trap");
                    this.incrementHealth(-Math.floor(this.maxHealth * t.percentHealth));
                }
                else if (statusType == "poison") {
                    p = this.getStatusEffect("poison");
                    this.incrementHealth(-Math.floor(this.maxHealth * p.percentHealth));
                }
                else if (statusType == "recoil") {
                    this.incrementHealth(this.getRecoil(a));
                }
                else if (statusType == "rest") {
                    this.incrementHealth(this.maxHealth - this.curHealth);
                }
            }
            incrementHealth(addToHealth) {
                this.prevHealth = this.curHealth;
                this.curHealth = this.curHealth + addToHealth;
                this.curHealth = Math.min(this.curHealth, this.maxHealth);
                this.curHealth = Math.max(this.curHealth, 0);
            }
            faint() {
                this.alpha = 1;
                this.faintFadeTween = this.scene.tweens.add({
                    targets: this,
                    "alpha": 0,
                    duration: 0.5 * 1000
                });
                this.faintMoveTween = this.scene.tweens.add({
                    targets: this,
                    "y": this.y + 200,
                    duration: 0.5 * 1000
                });
                this.initY = this.y;
            }
            appear(callback = null) {
                this.appearCallback = callback;
                this.alpha = 0;
                this.appearFadeTween = this.scene.tweens.add({
                    targets: this,
                    "alpha": 1,
                    duration: 0.5 * 1000,
                    onComplete: this.appearDone
                });
                this.y = this.initY + 200;
                this.appearMoveTween = this.scene.tweens.add({
                    targets: this,
                    "y": this.initY,
                    duration: 0.5 * 1000
                });
            }
            reset() {
                this.y = this.initY;
                this.alpha = 1;
                this.statusEffects.splice(0);
                this.resetStatEffects();
            }
            resetStatEffects() {
                this.statEffects.splice(0);
                this.statEffects.push(new code.EvasionStatEffect());
                this.statEffects.push(new code.AccuracyStatEffect());
                this.statEffects.push(new code.MainStatEffect("attack"));
                this.statEffects.push(new code.MainStatEffect("defense"));
            }
        }
        code.Character = Character;
    })(code = pbawp.code || (pbawp.code = {}));
})(pbawp || (pbawp = {}));
var pbawp;
(function (pbawp) {
    var code;
    (function (code) {
        class StatusEffect {
            constructor() {
                this.turnsLeft = 0;
                this.triggered = false;
                this.isNew = false;
                this.checked = false;
                this.isNew = true;
            }
            preAttack() {
                this.checked = false;
            }
            postAttack() {
                this.turnsLeft--;
            }
            postQueueStatusEffectUpdate() {
            }
            checkNew() {
                if (this.isNew) {
                    this.isNew = false;
                    return true;
                }
                return false;
            }
        }
        code.StatusEffect = StatusEffect;
    })(code = pbawp.code || (pbawp.code = {}));
})(pbawp || (pbawp = {}));
///<reference path="StatusEffect.ts"/>
var pbawp;
(function (pbawp) {
    var code;
    (function (code) {
        class Confusion extends code.StatusEffect {
            constructor() {
                super();
                this.chance = 50;
                this.checkedConfusion = false;
                this.type = "confuse";
                this.turnsLeft = Math.floor(Math.random() * (4 - 1)) + 1;
            }
            preAttack() {
                super.preAttack();
                this.triggerConfusion();
            }
            postAttack() {
                super.postAttack();
                this.checkedConfusion = false;
            }
            postQueueStatusEffectUpdate() {
                this.triggerConfusion();
            }
            triggerConfusion() {
                var ran = NaN;
                if (!this.checkedConfusion) {
                    ran = Math.random() * 100;
                    if (ran <= this.chance) {
                        this.triggered = true;
                    }
                    else {
                        this.triggered = false;
                    }
                    console.log("confusion triggered: " + this.triggered);
                    this.checkedConfusion = true;
                }
            }
        }
        code.Confusion = Confusion;
    })(code = pbawp.code || (pbawp.code = {}));
})(pbawp || (pbawp = {}));
var pbawp;
(function (pbawp) {
    var code;
    (function (code) {
        class Constants {
            constructor() {
                this.xmlFile = "english";
            }
            getTrainerWithID(trainerID) {
                return this.getObjectWithID(trainerID, "trainers");
            }
            getPokemonWithID(pokemonID) {
                return this.getObjectWithID(pokemonID, "pokemons");
            }
            getBattleWithID(battleID) {
                return this.getObjectWithID(battleID, "battles");
            }
            getBattleWithIndex(battleIndex) {
                return this.getObjectWithIndex(battleIndex, "battles");
            }
            getMapWithID(mapID) {
                return this.getObjectWithID(mapID, "maps");
            }
            getMapWithIndex(mapIndex) {
                return this.getObjectWithIndex(mapIndex, "maps");
            }
            getTreasureWithID(treasureID) {
                return this.getObjectWithID(treasureID, "treasures");
            }
            getTreasureWithIndex(treasureIndex) {
                return this.getObjectWithIndex(treasureIndex, "treasures");
            }
            getTextWithID(textID) {
                return this.getObjectWithID(textID, "texts");
            }
            getBattleScriptWithID(battleScriptID) {
                return this.getObjectWithID(battleScriptID, "battleScripts");
            }
            getConfig() {
                return pbawp.util.XMLParser.getChildNode(this.xml, "config");
            }
            getElementWithName(elementName) {
                return pbawp.util.XMLParser.getChildNode(this.xml, elementName);
            }
            getOneLinerWithID(textID) {
                var textObject = this.getTextWithID(textID);
                var n = pbawp.util.XMLParser.getChildNode(textObject, "line");
                return pbawp.util.XMLParser.getAttribute(n, "string").split("\\n").join("\n");
            }
            getChildNodesArray(arrayName) {
                let array = Array.prototype.slice.call(pbawp.util.XMLParser.getChildNode(this.xml, arrayName)[0].childNodes);
                for (let i = array.length - 1; i >= 0; i--) {
                    if (array[i]["nodeName"] == "#text") {
                        array.splice(i, 1);
                    }
                }
                return array;
            }
            getObjectWithID(objectID, arrayName) {
                let arr = this.getChildNodesArray(arrayName);
                for (let object of arr) {
                    if (pbawp.util.XMLParser.getAttribute(object, "id") == objectID) {
                        return object;
                    }
                }
                return null;
            }
            getObjectWithIndex(objectIndex, arrayName) {
                let arr = this.getChildNodesArray(arrayName);
                if (objectIndex < arr.length) {
                    return arr[objectIndex];
                }
                return arr[0];
            }
            getWeaknessResistanceFactor(attackType, defendType) {
                console.log("getting weakness resistance factor: " + attackType + " --- defend: " + defendType);
                if (attackType == "normal") {
                    if (defendType == "rock") {
                        return 0.5;
                    }
                    if (defendType == "ghost") {
                        return 0;
                    }
                    if (defendType == "steel") {
                        return 0.5;
                    }
                }
                else if (attackType == "fire") {
                    if (defendType == "fire") {
                        return 0.5;
                    }
                    if (defendType == "water") {
                        return 0.5;
                    }
                    if (defendType == "grass") {
                        return 2;
                    }
                    if (defendType == "ice") {
                        return 2;
                    }
                    if (defendType == "bug") {
                        return 2;
                    }
                    if (defendType == "rock") {
                        return 0.5;
                    }
                    if (defendType == "dragon") {
                        return 0.5;
                    }
                    if (defendType == "steel") {
                        return 2;
                    }
                }
                else if (attackType == "water") {
                    if (defendType == "fire") {
                        return 2;
                    }
                    if (defendType == "water") {
                        return 0.5;
                    }
                    if (defendType == "grass") {
                        return 0.5;
                    }
                    if (defendType == "ground") {
                        return 2;
                    }
                    if (defendType == "rock") {
                        return 2;
                    }
                    if (defendType == "dragon") {
                        return 0.5;
                    }
                }
                else if (attackType == "grass") {
                    if (defendType == "fire") {
                        return 0.5;
                    }
                    if (defendType == "water") {
                        return 2;
                    }
                    if (defendType == "grass") {
                        return 0.5;
                    }
                    if (defendType == "poison") {
                        return 0.5;
                    }
                    if (defendType == "ground") {
                        return 2;
                    }
                    if (defendType == "flying") {
                        return 0.5;
                    }
                    if (defendType == "bug") {
                        return 0.5;
                    }
                    if (defendType == "rock") {
                        return 2;
                    }
                    if (defendType == "dragon") {
                        return 0.5;
                    }
                    if (defendType == "steel") {
                        return 0.5;
                    }
                }
                else if (attackType == "electric") {
                    if (defendType == "water") {
                        return 2;
                    }
                    if (defendType == "grass") {
                        return 0.5;
                    }
                    if (defendType == "electric") {
                        return 0.5;
                    }
                    if (defendType == "ground") {
                        return 0;
                    }
                    if (defendType == "flying") {
                        return 2;
                    }
                    if (defendType == "dragon") {
                        return 0.5;
                    }
                }
                else if (attackType == "ice") {
                    if (defendType == "fire") {
                        return 0.5;
                    }
                    if (defendType == "water") {
                        return 0.5;
                    }
                    if (defendType == "grass") {
                        return 2;
                    }
                    if (defendType == "ice") {
                        return 0.5;
                    }
                    if (defendType == "ground") {
                        return 2;
                    }
                    if (defendType == "flying") {
                        return 2;
                    }
                    if (defendType == "dragon") {
                        return 2;
                    }
                    if (defendType == "steel") {
                        return 0.5;
                    }
                }
                else if (attackType == "fighting") {
                    if (defendType == "normal") {
                        return 2;
                    }
                    if (defendType == "ice") {
                        return 2;
                    }
                    if (defendType == "poison") {
                        return 0.5;
                    }
                    if (defendType == "flying") {
                        return 0.5;
                    }
                    if (defendType == "psychic") {
                        return 0.5;
                    }
                    if (defendType == "bug") {
                        return 0.5;
                    }
                    if (defendType == "rock") {
                        return 2;
                    }
                    if (defendType == "ghost") {
                        return 0;
                    }
                    if (defendType == "dark") {
                        return 2;
                    }
                    if (defendType == "steel") {
                        return 2;
                    }
                }
                else if (attackType == "poison") {
                    if (defendType == "grass") {
                        return 2;
                    }
                    if (defendType == "poison") {
                        return 0.5;
                    }
                    if (defendType == "ground") {
                        return 0.5;
                    }
                    if (defendType == "rock") {
                        return 0.5;
                    }
                    if (defendType == "ghost") {
                        return 0.5;
                    }
                    if (defendType == "steel") {
                        return 0;
                    }
                }
                else if (attackType == "ground") {
                    if (defendType == "fire") {
                        return 2;
                    }
                    if (defendType == "grass") {
                        return 0.5;
                    }
                    if (defendType == "electric") {
                        return 2;
                    }
                    if (defendType == "poison") {
                        return 2;
                    }
                    if (defendType == "flying") {
                        return 0;
                    }
                    if (defendType == "bug") {
                        return 0.5;
                    }
                    if (defendType == "rock") {
                        return 2;
                    }
                    if (defendType == "steel") {
                        return 2;
                    }
                }
                else if (attackType == "flying") {
                    if (defendType == "grass") {
                        return 2;
                    }
                    if (defendType == "electric") {
                        return 0.5;
                    }
                    if (defendType == "fighting") {
                        return 2;
                    }
                    if (defendType == "bug") {
                        return 2;
                    }
                    if (defendType == "rock") {
                        return 0.5;
                    }
                    if (defendType == "steel") {
                        return 0.5;
                    }
                }
                else if (attackType == "psychic") {
                    if (defendType == "fighting") {
                        return 2;
                    }
                    if (defendType == "poison") {
                        return 2;
                    }
                    if (defendType == "psychic") {
                        return 0.5;
                    }
                    if (defendType == "dark") {
                        return 0;
                    }
                    if (defendType == "steel") {
                        return 0.5;
                    }
                }
                else if (attackType == "bug") {
                    if (defendType == "fire") {
                        return 0.5;
                    }
                    if (defendType == "grass") {
                        return 2;
                    }
                    if (defendType == "fighting") {
                        return 0.5;
                    }
                    if (defendType == "poison") {
                        return 0.5;
                    }
                    if (defendType == "flying") {
                        return 0.5;
                    }
                    if (defendType == "psychic") {
                        return 2;
                    }
                    if (defendType == "ghost") {
                        return 0.5;
                    }
                    if (defendType == "dark") {
                        return 2;
                    }
                    if (defendType == "steel") {
                        return 0.5;
                    }
                }
                else if (attackType == "rock") {
                    if (defendType == "fire") {
                        return 2;
                    }
                    if (defendType == "ice") {
                        return 2;
                    }
                    if (defendType == "fighting") {
                        return 0.5;
                    }
                    if (defendType == "ground") {
                        return 0.5;
                    }
                    if (defendType == "flying") {
                        return 2;
                    }
                    if (defendType == "bug") {
                        return 2;
                    }
                    if (defendType == "steel") {
                        return 0.5;
                    }
                }
                else if (attackType == "ghost") {
                    if (defendType == "normal") {
                        return 0;
                    }
                    if (defendType == "psychic") {
                        return 2;
                    }
                    if (defendType == "ghost") {
                        return 2;
                    }
                    if (defendType == "dark") {
                        return 0.5;
                    }
                    if (defendType == "steel") {
                        return 0.5;
                    }
                }
                else if (attackType == "dragon") {
                    if (defendType == "dragon") {
                        return 2;
                    }
                    if (defendType == "steel") {
                        return 0.5;
                    }
                }
                else if (attackType == "dark") {
                    if (defendType == "fighting") {
                        return 0.5;
                    }
                    if (defendType == "psychic") {
                        return 2;
                    }
                    if (defendType == "ghost") {
                        return 2;
                    }
                    if (defendType == "dark") {
                        return 0.5;
                    }
                    if (defendType == "steel") {
                        return 0.5;
                    }
                }
                else if (attackType == "steel") {
                    if (defendType == "fire") {
                        return 0.5;
                    }
                    if (defendType == "water") {
                        return 0.5;
                    }
                    if (defendType == "electric") {
                        return 0.5;
                    }
                    if (defendType == "ice") {
                        return 2;
                    }
                    if (defendType == "rock") {
                        return 2;
                    }
                    if (defendType == "steel") {
                        return 0.5;
                    }
                }
                return 1;
            }
            setText(b, t, f = true, overrideLanguage = "") {
                if (f) {
                    code.FontHelper.updateTextField(b.textLabel, overrideLanguage);
                }
                b.textLabel.text = t;
            }
            getColorForElement(e) {
                if (e == "grass") {
                    return 3064357;
                }
                if (e == "electric") {
                    return 10919680;
                }
                if (e == "fire") {
                    return 16720896;
                }
                if (e == "water") {
                    return 1756407;
                }
                if (e == "dark") {
                    return 2698103;
                }
                if (e == "poison") {
                    return 11365293;
                }
                if (e == "rock") {
                    return 11035688;
                }
                if (e == "psychic") {
                    return 6710886;
                }
                return 0;
            }
            getHTMLColorForElement(e) {
                if (e == "grass") {
                    return "#2EC225";
                }
                if (e == "electric") {
                    return "#A69F00";
                }
                if (e == "fire") {
                    return "#FF2400";
                }
                if (e == "water") {
                    return "#1ACCF7";
                }
                if (e == "peta") {
                    return "#FA09AE";
                }
                if (e == "dark") {
                    return "#292b77";
                }
                if (e == "poison") {
                    return "#ad6bad";
                }
                if (e == "rock") {
                    return "#a86428";
                }
                if (e == "psychic") {
                    return "#666666";
                }
                return "#000000";
            }
            getPetaLogo() {
                let c = this.getConfig();
                let overrideLogo = pbawp.util.XMLParser.getAttribute(c[0], "overrideLogo");
                if (overrideLogo == "useURLOfSite") {
                    return code.GameWorld.siteUrl.urlType();
                }
                return overrideLogo;
            }
            getPetaURL() {
                let urlObject = new Object();
                if (code.GameWorld.siteUrl.urlType() == "petaAsiaPacific" && code.GameWorld.constants.xmlFile == "english") {
                    return code.GameWorld.siteUrl.urlWithType("peta");
                }
                if (code.GameWorld.siteUrl.urlType() != "petaAsiaPacific" && code.GameWorld.constants.xmlFile == "chinese") {
                    return code.GameWorld.siteUrl.urlWithType("petaAsiaPacific");
                }
                return code.GameWorld.siteUrl.url();
            }
            getTreasureLink(treasureID) {
                let treasureLink = pbawp.util.XMLParser.getAttribute(this.getTreasureWithID(treasureID), "link");
                var petaURL = undefined;
                let config = this.getConfig();
                if (config && config[0] && pbawp.util.XMLParser.getAttribute(config[0], "treasuresUseURLOfCurrentSite") == "true") {
                    petaURL = this.getPetaURL();
                    petaURL = petaURL.replace("/swf", "");
                    if (code.GameWorld.constants.xmlFile == "chinese") {
                        return petaURL.concat(treasureLink.replace(".aspx", "-chinese.aspx"));
                    }
                    return petaURL.concat(treasureLink);
                }
                return treasureLink;
            }
        }
        code.Constants = Constants;
    })(code = pbawp.code || (pbawp.code = {}));
})(pbawp || (pbawp = {}));
///<reference path="Screen.ts"/>
var pbawp;
(function (pbawp) {
    var code;
    (function (code) {
        class Credits extends pbawp.code.Screen {
            constructor(refToGameWorld, scene) {
                super(refToGameWorld, scene);
                this.gotoBack = () => {
                    this.gameworld._setState(this.gameworld.GAMESTATE_GAME_WIN);
                };
                this.initializeView();
                code.GameWorld.constants.setText(this.backButton, code.GameWorld.constants.getOneLinerWithID("backButton"));
                this.backButton.addEventListenerClick(this.gotoBack);
            }
            initializeView() {
                this.view = new pbawp.assets.fla._Credits(this.scene);
                this.add(this.view);
                this.backButton = this.view.backButton;
            }
            stopInput() {
                this.backButton.removeEventListenerClick(this.gotoBack);
            }
        }
        code.Credits = Credits;
    })(code = pbawp.code || (pbawp.code = {}));
})(pbawp || (pbawp = {}));
var pbawp;
(function (pbawp) {
    var code;
    (function (code) {
        class DialogBox extends pbawp.assets.fla._DialogBox {
            constructor(scene) {
                super(scene);
                this.typeCounter = 0;
                this.typeString = "";
                this.newCallback = false;
                this.displayArrow = true;
                this.advanceLetter = () => {
                    var nextSpace = NaN;
                    var prevSpace = NaN;
                    var currentString = null;
                    var prevHeight = NaN;
                    this.typeCounter++;
                    if (this.typeCounter <= this.typeString.length) {
                        code.GameWorld.soundManager.playSound("dialog");
                        nextSpace = this.typeString.indexOf(" ", this.typeCounter);
                        if (nextSpace == -1) {
                            nextSpace = this.typeString.length;
                        }
                        prevSpace = Math.max(0, this.typeString.lastIndexOf(" ", this.typeCounter));
                        currentString = this.typeString.substr(this.typeCounter, nextSpace - this.typeCounter);
                        this.dialogText.text = this.typeString.substr(0, this.typeCounter);
                        prevHeight = this.dialogText.height;
                        this.dialogText.text = this.typeString.substr(0, nextSpace);
                        if (prevHeight != this.dialogText.height && (this.typeString.indexOf("\n", prevSpace) >= nextSpace || this.typeString.indexOf("\n", prevSpace) == -1)) {
                            this.dialogText.text = this.typeString.substr(0, prevSpace) + "\n" + this.typeString.substr(prevSpace + 1, this.typeCounter - (prevSpace + 1));
                        }
                        else {
                            this.dialogText.text = this.typeString.substr(0, this.typeCounter);
                        }
                    }
                    else {
                        this.dialogText.text = this.typeString.substr(0, this.typeString.length);
                        if (this.typeTimer)
                            this.typeTimer.remove();
                        if (this.displayArrow) {
                            this.dialogArrow.visible = true;
                            this.dialogArrowGotoAndStop("start");
                        }
                    }
                };
                this.initializeView();
                this.lines = new Array();
                this.dictionary = new Object();
                this.dialogArrow.visible = false;
                code.GameWorld.constants.setText(this.fightButton, code.GameWorld.constants.getOneLinerWithID("fightButton"));
                code.GameWorld.constants.setText(this.pokemonButton, code.GameWorld.constants.getOneLinerWithID("pokemonButton"));
                code.GameWorld.constants.setText(this.submitButton, code.GameWorld.constants.getOneLinerWithID("submitButton"));
                code.GameWorld.constants.setText(this.ignoreButton, code.GameWorld.constants.getOneLinerWithID("ignoreButton"));
                code.GameWorld.constants.setText(this.openButton, code.GameWorld.constants.getOneLinerWithID("openButton"));
                code.GameWorld.constants.setText(this.skipButton, code.GameWorld.constants.getOneLinerWithID("skipButton"));
                code.GameWorld.constants.setText(this.watchButton, code.GameWorld.constants.getOneLinerWithID("watchButton"));
                code.GameWorld.constants.setText(this.battleButton, code.GameWorld.constants.getOneLinerWithID("battleButton"));
                code.GameWorld.constants.setText(this.sendInButton, code.GameWorld.constants.getOneLinerWithID("sendInButton"));
                code.GameWorld.constants.setText(this.statsButton, code.GameWorld.constants.getOneLinerWithID("statsButton"));
                code.GameWorld.constants.setText(this.continueButton, code.GameWorld.constants.getOneLinerWithID("continueButton"));
                code.GameWorld.constants.setText(this.yesButton, code.GameWorld.constants.getOneLinerWithID("yes"));
                code.GameWorld.constants.setText(this.noButton, code.GameWorld.constants.getOneLinerWithID("no"));
            }
            //---------------------------------------------------------
            initializeView() {
                var attackButton1 = new code.AttackButton(this.scene);
                attackButton1.x = this.attackButton1.x;
                attackButton1.y = this.attackButton1.y;
                this.addAt(attackButton1, this.getIndex(this.attackButton1));
                //this.removeChild(this.attackButton1);
                this.attackButton1 = attackButton1;
                var attackButton2 = new code.AttackButton(this.scene);
                attackButton2.x = this.attackButton2.x;
                attackButton2.y = this.attackButton2.y;
                this.addAt(attackButton2, this.getIndex(this.attackButton2));
                //this.removeChild(this.attackButton2);
                this.attackButton2 = attackButton2;
                var attackButton3 = new code.AttackButton(this.scene);
                attackButton3.x = this.attackButton3.x;
                attackButton3.y = this.attackButton3.y;
                this.addAt(attackButton3, this.getIndex(this.attackButton3));
                //this.removeChild(this.attackButton3);
                this.attackButton3 = attackButton3;
                var attackButton4 = new code.AttackButton(this.scene);
                attackButton4.x = this.attackButton4.x;
                attackButton4.y = this.attackButton4.y;
                this.addAt(attackButton4, this.getIndex(this.attackButton4));
                //this.removeChild(this.attackButton4);
                this.attackButton4 = attackButton4;
                var pokemonButton1 = new code.PokemonSelectButton(this.scene);
                pokemonButton1.x = this.pokemonButton1.x;
                pokemonButton1.y = this.pokemonButton1.y;
                this.addAt(pokemonButton1, this.getIndex(this.pokemonButton1));
                //this.removeChild(this.pokemonButton1);
                this.pokemonButton1 = pokemonButton1;
                var pokemonButton2 = new code.PokemonSelectButton(this.scene);
                pokemonButton2.x = this.pokemonButton2.x;
                pokemonButton2.y = this.pokemonButton2.y;
                this.addAt(pokemonButton2, this.getIndex(this.pokemonButton2));
                //this.removeChild(this.pokemonButton2);
                this.pokemonButton2 = pokemonButton2;
                var pokemonButton3 = new code.PokemonSelectButton(this.scene);
                pokemonButton3.x = this.pokemonButton3.x;
                pokemonButton3.y = this.pokemonButton3.y;
                this.addAt(pokemonButton3, this.getIndex(this.pokemonButton3));
                //this.removeChild(this.pokemonButton3);
                this.pokemonButton3 = pokemonButton3;
                var pokemonButton4 = new code.PokemonSelectButton(this.scene);
                pokemonButton4.x = this.pokemonButton4.x;
                pokemonButton4.y = this.pokemonButton4.y;
                this.addAt(pokemonButton4, this.getIndex(this.pokemonButton4));
                //this.removeChild(this.pokemonButton4);
                this.pokemonButton4 = pokemonButton4;
                var newPokemonName = new code.NamePokemonTextField(this.scene);
                newPokemonName.x = this.newPokemonName.x;
                newPokemonName.y = this.newPokemonName.y;
                this.addAt(newPokemonName, this.getIndex(this.newPokemonName));
                //this.removeChild(this.pokemonButton4);
                this.newPokemonName = newPokemonName;
            }
            _update() {
                this.newPokemonName._update();
            }
            loadInfo(dialogID) {
                this.loadFromXML(code.GameWorld.constants.getTextWithID(dialogID));
            }
            loadFromXML(xml) {
                let newLine = null;
                this.lines.splice(0);
                let line = pbawp.util.XMLParser.getChildNode(xml, "line");
                for (let l of line) {
                    newLine = new code.DialogLine(pbawp.util.XMLParser.getAttribute(l, "string"));
                    let speed = pbawp.util.XMLParser.getAttribute(l, "speed");
                    if (!isEmpty(speed)) {
                        newLine.speed = Number(speed) * 1000;
                    }
                    this.addLine(newLine.string, newLine.speed);
                }
                this.updateText();
                return xml;
            }
            addLineWithPluralCheck(newLine, plural = false, newSpeed = 10) {
                newLine = newLine.replace("%use%", code.GameWorld.constants.getOneLinerWithID(!!plural ? "usePlural" : "useSingular"));
                newLine = newLine.replace("%is%", code.GameWorld.constants.getOneLinerWithID(!!plural ? "isPlural" : "isSingular"));
                this.addLine(newLine, newSpeed);
            }
            addLine(newLine, newSpeed = 10) {
                console.log("adding line: " + newLine);
                this.lines.push(new pbawp.code.DialogLine(newLine, newSpeed));
            }
            updateText() {
                var curLine = null;
                var s = undefined;
                if (this.lines.length > 0) {
                    curLine = this.lines.shift();
                    for (s in this.dictionary) {
                        if (this.isBeginningOfSentence(s, curLine.string) && this.shouldCheckCapitalization(s)) {
                            curLine.string = curLine.string.replace(s, this.dictionary[s].substr(0, 1).toUpperCase() + this.dictionary[s].substr(1, this.dictionary[s].length));
                        }
                        else {
                            curLine.string = curLine.string.replace(s, this.dictionary[s]);
                        }
                    }
                    this.typeText(curLine.string, curLine.speed);
                }
                else {
                    this.dialogArrow.visible = false;
                }
            }
            setNextClickCallback(f) {
                this.nextClickCallback = f;
                this.newCallback = true;
            }
            advanceLine() {
                if (this.nextClickCallback != null && this.typeCounter >= this.typeString.length && this.isDone()) {
                    this.newCallback = false;
                    this.nextClickCallback();
                    this.dialogArrow.visible = false;
                    if (!this.newCallback) {
                        this.nextClickCallback = null;
                    }
                }
                else if (this.typeCounter < this.typeString.length) {
                    this.typeCounter = this.typeString.length;
                    this.advanceLetter();
                    code.GameWorld.soundManager.playSound("dialogReveal");
                    console.log("advance to end of string: " + this.typeString);
                }
                else {
                    this.updateText();
                    console.log("advance to next line: " + this.lines.length);
                }
            }
            isDone() {
                return this.lines.length == 0 && this.typeCounter >= this.typeString.length;
            }
            replaceString(strToReplace, newString) {
                console.log("replace string: " + strToReplace + " --- with: " + newString);
                this.dictionary[strToReplace] = newString;
            }
            typeText(newString, speed = 50) {
                this.dialogArrow.visible = false;
                this.dialogText.text = "";
                this.typeCounter = 0;
                this.typeString = newString;
                this.typeTimer = this.scene.time.addEvent({
                    delay: speed,
                    callback: this.advanceLetter,
                    callbackScope: this,
                    loop: true
                });
            }
            setText(newText) {
                console.log("set dialog text: " + newText);
                this.typeCounter = this.typeString.length;
                this.dialogText.text = newText;
                if (this.typeTimer)
                    this.typeTimer.remove();
            }
            updatePokemonDictionary(player) {
                let p = null;
                var pokemon = player.pokemon;
                for (p of pokemon) {
                    this.replaceString("%" + p.id + "%", p.displayName);
                }
                this.replaceString("%selected%", player.getCurrentPokemon().displayName);
            }
            gotoAndStop(frame) {
                super.gotoAndStop(frame);
                this.displayArrow = frame == "dialogOnly" || frame == "mapDialog" || frame == "mapInfo";
                this.dialogBackground.visible = frame != "switchPokemon";
                if (frame == "mainMenu" || frame == "fight") {
                    this.dialogBackgroundGotoAndStop("half");
                }
                else if (frame == "dialogOnly" || frame == "pokemonGet" || frame == "confirmPokemon") {
                    this.dialogBackgroundGotoAndStop("full");
                    this.dialogArrowArrowGotoAndStop("white");
                }
                else if (frame == "mapDialog") {
                    this.dialogBackgroundGotoAndStop("speechBubble");
                    this.dialogArrowArrowGotoAndStop("black");
                }
                else {
                    this.dialogBackgroundGotoAndStop("map");
                }
                if (frame == "mapInfo") {
                    this.dialogArrowArrowGotoAndStop("white");
                }
            }
            setNewPokemonName(s) {
                this.newPokemonName.setEnabled(true);
                this.newPokemonName.inputTextField.value = s;
            }
            getNewPokemonName() {
                this.newPokemonName.setEnabled(false);
                return this.newPokemonName.inputTextField.value;
            }
            updateGenderPronounsWithCharacter(c) {
                this.replaceString("%heshe%", code.GameWorld.constants.getOneLinerWithID("heshe" + c.gender));
                this.replaceString("%himher%", code.GameWorld.constants.getOneLinerWithID("himher" + c.gender));
                this.replaceString("%hisher%", code.GameWorld.constants.getOneLinerWithID("hisher" + c.gender));
                this.replaceString("%himherself%", code.GameWorld.constants.getOneLinerWithID("himherself" + c.gender));
            }
            isBeginningOfSentence(checkString, withinString) {
                var lineBreakArray = null;
                var s = null;
                var periodArray = null;
                if (withinString.indexOf(checkString) == 0) {
                    return true;
                }
                lineBreakArray = withinString.split("\n");
                for (s of lineBreakArray) {
                    if (s.indexOf(checkString) == 0) {
                        return true;
                    }
                }
                periodArray = withinString.split(". ");
                for (s of periodArray) {
                    if (s.indexOf(checkString) == 0) {
                        return true;
                    }
                }
                return false;
            }
            shouldCheckCapitalization(string) {
                return string == "%heshe%" || string == "%himher%";
            }
        }
        code.DialogBox = DialogBox;
    })(code = pbawp.code || (pbawp.code = {}));
})(pbawp || (pbawp = {}));
var pbawp;
(function (pbawp) {
    var code;
    (function (code) {
        class DialogLine {
            constructor(newString, newSpeed = 10) {
                this.speed = 10;
                this.string = newString;
                this.speed = newSpeed;
            }
        }
        code.DialogLine = DialogLine;
    })(code = pbawp.code || (pbawp.code = {}));
})(pbawp || (pbawp = {}));
///<reference path="StatEffect.ts"/>
var pbawp;
(function (pbawp) {
    var code;
    (function (code) {
        class EvasionStatEffect extends code.StatEffect {
            constructor() {
                super();
                this.positiveEffect = new Array(0.75, 0.6, 0.5, 0.428, 0.375, 0.33);
                this.negativeEffect = new Array(1.33, 1.66, 2, 2.33, 2.66, 3);
                this.type = "evasion";
            }
        }
        code.EvasionStatEffect = EvasionStatEffect;
    })(code = pbawp.code || (pbawp.code = {}));
})(pbawp || (pbawp = {}));
var pbawp;
(function (pbawp) {
    var code;
    (function (code) {
        class Fader extends Phaser.GameObjects.Rectangle {
            constructor(refToGameWorld, scene) {
                super(scene, 0, 0, game.scale.width, game.scale.height, 0x000000, 1);
                this.fadeDone = () => {
                    if (this.fadeCallback != null) {
                        this.fadeCallback();
                    }
                };
                this.setOrigin(0, 0);
                this.gameworld = refToGameWorld;
                this.alpha = 0;
                this.setInteractive();
            }
            fadeIn(callback = null, speed = 0.5) {
                this.fade(1, 0, callback, speed);
            }
            fadeOut(callback = null, speed = 0.5) {
                this.fade(0, 1, callback, speed);
            }
            fade(from, to, callback, speed = 1) {
                this.alpha = from;
                this.fadeTween = this.scene.tweens.add({
                    targets: this,
                    "alpha": to,
                    duration: speed * 1000,
                    // yoyo: true,
                    onComplete: this.fadeDone
                });
                this.fadeCallback = callback;
            }
            isFading() {
                if (this.fadeTween == null) {
                    return false;
                }
                return this.fadeTween.isPlaying();
            }
        }
        code.Fader = Fader;
    })(code = pbawp.code || (pbawp.code = {}));
})(pbawp || (pbawp = {}));
var pbawp;
(function (pbawp) {
    var code;
    (function (code) {
        class FontHelper {
            static rewriteWordWrapping() {
                (function (setWordWrapWidth) {
                    Phaser.GameObjects.Text.prototype.setWordWrapWidth = function (t, e) {
                        if (typeof e === "undefined")
                            e = true;
                        // Now, call the original method
                        return setWordWrapWidth.apply(this, [t, e]);
                    };
                })(Phaser.GameObjects.Text.prototype.setWordWrapWidth);
            }
            static updateTextField(field, overrideLanguage = "") {
                var newFontName = null;
                var font = field.style.fontFamily;
                if (font != null) {
                    newFontName = "Agency FB";
                    if ((pbawp.code.GameWorld.constants.xmlFile == "chinese" || overrideLanguage == "chinese") && overrideLanguage != "english") {
                        if (font.indexOf("Agency") != -1 || font.indexOf("AGENCY") != -1) {
                            newFontName = "AGENCYCHINESE";
                        }
                        else if (font.indexOf("Junegull") != -1 || font.indexOf("JUNEGULL") != -1) {
                            newFontName = "JUNEGULLCHINESE";
                        }
                        else if (font.indexOf("Banda") != -1 || font.indexOf("BANDA") != -1) {
                            newFontName = "BANDACHINESE";
                        }
                    }
                    else {
                        if (font.indexOf("AGENCY") != -1 || font.indexOf("Agency") != -1) {
                            newFontName = "Agency FB";
                        }
                        else if (font.indexOf("JUNEGULL") != -1 || font.indexOf("Junegull") != -1) {
                            newFontName = "Junegull-Regular";
                        }
                        else if (font.indexOf("BANDA") != -1 || font.indexOf("Banda") != -1) {
                            newFontName = "Banda Regular";
                        }
                    }
                    field.setFontFamily(newFontName);
                }
            }
        }
        code.FontHelper = FontHelper;
    })(code = pbawp.code || (pbawp.code = {}));
})(pbawp || (pbawp = {}));
var pbawp;
(function (pbawp) {
    var code;
    (function (code) {
        class GameAlmostWin extends pbawp.code.Screen {
            constructor(refToGameWorld, scene) {
                super(refToGameWorld, scene);
                this.gameWin = () => {
                    this.timer.remove();
                    this.gameworld._setState(this.gameworld.GAMESTATE_GAME_WIN);
                };
                this.gotoSkip = () => {
                    this.gameWin();
                };
                this.initializeView();
                this.init();
                this.skipButton.setInteractive({ cursor: 'pointer' });
                this.skipButton.on('pointerup', this.gotoSkip);
                code.GameWorld.soundManager.playMusic("MusicMain", true);
            }
            initializeView() {
                this.view = new pbawp.assets.fla._GameAlmostWin(this.scene);
                this.add(this.view);
                this.skipButton = this.view.skipButton;
            }
            init() {
                this.timer = this.scene.time.addEvent({
                    delay: 2000,
                    callback: this.gameWin,
                    callbackScope: this,
                    loop: true
                });
            }
            stopInput() {
                this.skipButton.off('pointerup', this.gotoSkip);
                this.timer.remove();
            }
        }
        code.GameAlmostWin = GameAlmostWin;
    })(code = pbawp.code || (pbawp.code = {}));
})(pbawp || (pbawp = {}));
var pbawp;
(function (pbawp) {
    var code;
    (function (code) {
        class GameOver extends pbawp.code.Screen {
            constructor(refToGameWorld, scene) {
                super(refToGameWorld, scene);
                this.gotoContinue = () => {
                    if (pbawp.util.XMLParser.getAttribute(code.GameWorld.constants.getConfig(), "continueMode") == "healPokemon") {
                        this.gameworld.continueFromGameOver();
                    }
                    else {
                        this.gameworld.newGame();
                    }
                    this.gameworld._setState(this.gameworld.GAMESTATE_BATTLE);
                    sendEvent(petaGA_GameCategory_Game, 'Continue', 'Pokémon Red White and Blue - Continue');
                };
                this.gotoQuit = () => {
                    this.yesButton.visible = this.noButton.visible = this.areYouSureText.visible = true;
                    this.continueButton.visible = this.treasureButton.visible = this.quitButton.visible = false;
                    sendEvent(petaGA_GameCategory_Game, 'Quit', 'Pokémon Red White and Blue - Quit');
                };
                this.gotoQuitYES = () => {
                    this.gameworld._setState(this.gameworld.GAMESTATE_MAIN_MENU);
                };
                this.gotoTreasure = () => {
                    this.gameworld._setState(this.gameworld.GAMESTATE_TREASURE, 0.3);
                    sendEvent(petaGA_GameCategory_Game, 'Treasure', 'Pokémon Red White and Blue - Treasure');
                };
                this.gotoNo = () => {
                    this.yesButton.visible = this.noButton.visible = this.areYouSureText.visible = false;
                    this.continueButton.visible = this.treasureButton.visible = this.quitButton.visible = true;
                };
                this.initializeView();
                code.FontHelper.updateTextField(this.gameOverText);
                code.FontHelper.updateTextField(this.gameOver1);
                code.FontHelper.updateTextField(this.areYouSureText);
                this.gameOverText.text = code.GameWorld.constants.getOneLinerWithID("gameOver");
                code.GameWorld.constants.setText(this.continueButton, code.GameWorld.constants.getOneLinerWithID("continueButton"));
                code.GameWorld.constants.setText(this.yesButton, code.GameWorld.constants.getOneLinerWithID("yes"));
                code.GameWorld.constants.setText(this.treasureButton, code.GameWorld.constants.getOneLinerWithID("treasureButton"));
                code.GameWorld.constants.setText(this.noButton, code.GameWorld.constants.getOneLinerWithID("no"));
                code.GameWorld.constants.setText(this.quitButton, code.GameWorld.constants.getOneLinerWithID("quitButton"));
                this.gameOver1.text = code.GameWorld.constants.getOneLinerWithID("gameOverText");
                // this.gameOver1.mask = this.gameOverMask;
                if (this.gameworld.prevState != this.gameworld.GAMESTATE_TREASURE) {
                    this.tween = this.scene.tweens.add({
                        targets: this.gameOverMask,
                        "y": this.gameOver1.y,
                        duration: 5 * 1000,
                        ease: Phaser.Math.Easing.Linear
                    });
                }
                else {
                    this.gameOverMask.y = this.gameOver1.y;
                }
                this.yesButton.visible = this.noButton.visible = this.areYouSureText.visible = false;
                this.continueButton.addEventListenerClick(this.gotoContinue);
                this.quitButton.addEventListenerClick(this.gotoQuit);
                this.yesButton.addEventListenerClick(this.gotoQuitYES);
                this.treasureButton.addEventListenerClick(this.gotoTreasure);
                this.noButton.addEventListenerClick(this.gotoNo);
            }
            initializeView() {
                this.view = new pbawp.assets.fla._GameOver(this.scene);
                this.add(this.view);
                this.quitButton = this.view.quitButton;
                this.gameOverMask = this.view.gameOverMask;
                this.treasureButton = this.view.treasureButton;
                this.gameOver1 = this.view.gameOver1;
                this.areYouSureText = this.view.areYouSureText;
                this.continueButton = this.view.continueButton;
                this.gameOverText = this.view.gameOverText;
                this.noButton = this.view.noButton;
                this.yesButton = this.view.yesButton;
            }
            stopInput() {
                this.continueButton.removeEventListenerClick(this.gotoContinue);
                this.quitButton.removeEventListenerClick(this.gotoQuit);
                this.noButton.removeEventListenerClick(this.gotoNo);
                this.treasureButton.removeEventListenerClick(this.gotoTreasure);
                this.yesButton.removeEventListenerClick(this.gotoQuitYES);
            }
        }
        code.GameOver = GameOver;
    })(code = pbawp.code || (pbawp.code = {}));
})(pbawp || (pbawp = {}));
var pbawp;
(function (pbawp) {
    var code;
    (function (code) {
        class GameWin extends pbawp.code.Screen {
            constructor(refToGameWorld, scene) {
                super(refToGameWorld, scene);
                this.gotoContinue = () => {
                    this.gameworld.newGame();
                    this.gameworld._setState(this.gameworld.GAMESTATE_MAIN_MENU);
                };
                this.gotoTreasure = () => {
                    this.gameworld._setState(this.gameworld.GAMESTATE_TREASURE, 0.3);
                };
                this.gotoCredits = () => {
                    this.gameworld._setState(this.gameworld.GAMESTATE_CREDITS);
                };
                this.gotoShare = () => {
                    sendEvent(petaGA_GameCategory_Game, 'Share Video', 'Pokémon Red White and Blue - Share Video');
                    //if(!GameWorld.soundManager.muted) GameWorld.soundManager.mute();
                    var jscommand = "window.open(\'" + this.videoLink + "\',\'win\',\'height=550,width=550,toolbar=no,scrollba rs=yes\');";
                    // var url:URLRequest = new URLRequest("javascript:" + jscommand + " void(0);");
                    // navigateToURL(url,"_self");
                    setupPopUpWindowAnalytics(eval(jscommand));
                };
                this.initializeView();
                code.FontHelper.updateTextField(this.congratulationsText);
                code.FontHelper.updateTextField(this.winText);
                code.FontHelper.updateTextField(this.cheatText);
                this.gameworld.player.winGame();
                this.videoLink = code.GameWorld.constants.getTreasureLink("mcCrueltyVideo");
                this.add(new pbawp.assets.swf._WinSWF(this.scene));
                code.GameWorld.soundManager.playMusic("MusicMain", true);
                this.congratulationsText.text = code.GameWorld.constants.getOneLinerWithID("congratulations");
                code.GameWorld.constants.setText(this.playAgainButton, code.GameWorld.constants.getOneLinerWithID("playAgainButton"));
                code.GameWorld.constants.setText(this.treasureButton, code.GameWorld.constants.getOneLinerWithID("treasureButton"));
                code.GameWorld.constants.setText(this.creditsButton, code.GameWorld.constants.getOneLinerWithID("credits"));
                code.GameWorld.constants.setText(this.shareButton, code.GameWorld.constants.getOneLinerWithID("share"));
                this.winText.text = code.GameWorld.constants.getOneLinerWithID("win");
                // this.winText.mask = this.winTextMask;
                this.cheatText.text = code.GameWorld.constants.getOneLinerWithID("winCheat").replace("%cheat%", code.GameWorld.constants.getOneLinerWithID("cheatCode"));
                // this.cheatText.mask = this.cheatTextMask;
                if (this.gameworld.prevState != this.gameworld.GAMESTATE_TREASURE && this.gameworld.prevState != this.gameworld.GAMESTATE_CREDITS) {
                    this.tween = this.scene.tweens.add({
                        targets: this.winTextMask,
                        "y": this.winText.y,
                        duration: 5 * 1000,
                        ease: Phaser.Math.Easing.Linear
                    });
                    this.cheatTween = this.scene.tweens.add({
                        targets: this.cheatTextMask,
                        "y": this.cheatText.y,
                        duration: 9 * 1000,
                        ease: Phaser.Math.Easing.Linear
                    });
                }
                else {
                    this.winTextMask.y = this.winText.y;
                    this.cheatTextMask.y = this.cheatText.y;
                }
                this.playAgainButton.addEventListenerClick(this.gotoContinue);
                this.treasureButton.addEventListenerClick(this.gotoTreasure);
                this.creditsButton.addEventListenerClick(this.gotoCredits);
                this.shareButton.addEventListenerClick(this.gotoShare);
                this.view.updateTextFields();
            }
            initializeView() {
                this.view = new pbawp.assets.fla._GameWin(this.scene);
                this.add(this.view);
                this.congratulationsText = this.view.congratulationsText;
                this.treasureButton = this.view.treasureButton;
                this.winTextMask = this.view.winTextMask;
                this.cheatTextMask = this.view.cheatTextMask;
                this.playAgainButton = this.view.playAgainButton;
                this.creditsButton = this.view.creditsButton;
                this.winText = this.view.winText;
                this.cheatText = this.view.cheatText;
                this.shareButton = this.view.shareButton;
            }
            stopInput() {
                this.playAgainButton.removeEventListenerClick(this.gotoContinue);
                this.treasureButton.removeEventListenerClick(this.gotoTreasure);
                this.creditsButton.removeEventListenerClick(this.gotoCredits);
                this.shareButton.removeEventListenerClick(this.gotoShare);
            }
        }
        code.GameWin = GameWin;
    })(code = pbawp.code || (pbawp.code = {}));
})(pbawp || (pbawp = {}));
var pbawp;
(function (pbawp) {
    var code;
    (function (code) {
        class GameWorld extends Phaser.GameObjects.Container {
            constructor(scene /*p:Preloader*/) {
                super(scene);
                this.gamestate = 0;
                this.prevState = 0;
                this.savedState = 0;
                this.currentFadeSpeed = 0;
                this.currentKeyDown = 0;
                this.needsSound = false;
                this.helpShown = false;
                this.introShown = false;
                this.GAMESTATE_LOADING = 0;
                this.GAMESTATE_MAIN_MENU = 1;
                this.GAMESTATE_INTRO = 2;
                this.GAMESTATE_BATTLE = 3;
                this.GAMESTATE_MAP = 5;
                this.GAMESTATE_GAME_OVER = 6;
                this.GAMESTATE_GAME_WIN = 7;
                this.GAMESTATE_TREASURE = 8;
                this.GAMESTATE_GAME_ALMOST_WIN = 9;
                this.GAMESTATE_CREDITS = 10;
                this.DEPTH_SCREEN = 0;
                this.DEPTH_OVERLAY = 1;
                this.DEPTH_HELP = 2;
                this.DEPTH_FADER = 3;
                this.keyDown = (e) => {
                    this.currentKeyDown = e.keyCode;
                    if (!this.fader.isFading()) {
                        if (!this.currentScreen.keyIsDown(e)) {
                            if (e.keyCode == 32 && this.help != null) {
                                this.help.goPressed();
                            }
                        }
                    }
                };
                this.keyUp = (e) => {
                    if (this.currentKeyDown == e.keyCode && !this.fader.isFading()) {
                        if (!this.currentScreen.keyPressed(e)) {
                            if (e.keyCode == 32 && this.help != null) {
                                this.help.goReleased();
                            }
                            else if (e.keyCode == 86 && pbawp.util.XMLParser.getAttribute(GameWorld.constants.getElementWithName("gamegenie"), "versionNumberEnabled") == "true") {
                                this.overlay.versionNo.text = pbawp.util.XMLParser.getAttribute(GameWorld.constants.getElementWithName("config"), "versionNumber");
                                this.overlay.versionNo.visible = !this.overlay.versionNo.visible;
                            }
                        }
                    }
                };
                this.fadeDone = () => {
                    this.currentScreen._destroy();
                    this.remove(this.currentScreen);
                    this.currentScreen = null;
                    this._setState(this.savedState);
                    this.fader.fadeIn(null, this.currentFadeSpeed);
                };
                pbawp.code.GameWorld.siteUrl = new pbawp.code.URL(window.location.href.toString());
                this.mapOneOffs = new Object();
                // preloader = p;
                GameWorld.constants = new pbawp.code.Constants();
                GameWorld.constants.xml = pbawp.util.XMLParser.toXMLDoc(redWhiteAndBlue_xml);
                GameWorld.soundManager = new pbawp.code.SoundManager(this.scene);
                this.player = new pbawp.code.Player(this.scene);
                this._setState(Number(pbawp.util.XMLParser.getAttribute(GameWorld.constants.getElementWithName("gamegenie"), "firstScreen")));
            }
            init() {
                this.fader = new pbawp.code.Fader(this, this.scene);
                this.add(this.fader);
                this.scene.input.keyboard.on('keydown', this.keyDown);
                this.scene.input.keyboard.on('keyup', this.keyUp);
            }
            _setState(newState, fadeSpeed = 0.5) {
                if (this.currentScreen != null) {
                    console.log("removing current screen with state: " + this.gamestate);
                    this.savedState = newState;
                    this.currentScreen.stopInput();
                    this.fader.fadeOut(this.fadeDone, fadeSpeed);
                    this.currentFadeSpeed = fadeSpeed;
                    return;
                }
                if (newState != this.GAMESTATE_LOADING && this.overlay == null) {
                    this.overlay = new pbawp.code.Overlay(this, this.scene);
                    this.enableHelpButton(false);
                    this.add(this.overlay);
                }
                this.prevState = this.gamestate;
                switch (newState) {
                    case this.GAMESTATE_MAIN_MENU:
                        this.currentScreen = new pbawp.code.MenuMain(this, this.scene);
                        break;
                    case this.GAMESTATE_INTRO:
                        this.currentScreen = new pbawp.code.Intro(this, this.scene);
                        break;
                    case this.GAMESTATE_BATTLE:
                        this.currentScreen = new pbawp.code.BattleManager(this, this.scene);
                        break;
                    case this.GAMESTATE_MAP:
                        this.currentScreen = new pbawp.code.Map(this, this.scene);
                        break;
                    case this.GAMESTATE_GAME_OVER:
                        this.currentScreen = new pbawp.code.GameOver(this, this.scene);
                        break;
                    case this.GAMESTATE_GAME_WIN:
                        this.currentScreen = new pbawp.code.GameWin(this, this.scene);
                        break;
                    case this.GAMESTATE_TREASURE:
                        this.currentScreen = new pbawp.code.TreasureScreen(this, this.scene);
                        break;
                    case this.GAMESTATE_GAME_ALMOST_WIN:
                        this.currentScreen = new pbawp.code.GameAlmostWin(this, this.scene);
                        break;
                    case this.GAMESTATE_CREDITS:
                        this.currentScreen = new pbawp.code.Credits(this, this.scene);
                        break;
                    default:
                        this.currentScreen = new pbawp.code.MenuMain(this, this.scene);
                }
                if (this.currentScreen != null) {
                    console.log("adding current screen with state: " + newState);
                    this.addAt(this.currentScreen, this.DEPTH_SCREEN);
                }
                this.gamestate = newState;
                GameWorld.currentScreen = this.currentScreen;
            }
            newGame() {
                this.player.newGame();
            }
            continueFromGameOver() {
                this.player.continueFromGameOver();
            }
            showHelp() {
                this.help = new pbawp.code.Help(this, this.scene);
                this.add(this.help);
            }
            hideHelp() {
                this.remove(this.help);
                this.help = null;
            }
            enableHelpButton(newEnabled) {
                this.overlay.enableHelp(newEnabled);
            }
            _update() {
                if (this.currentScreen)
                    this.currentScreen._update();
            }
        }
        code.GameWorld = GameWorld;
    })(code = pbawp.code || (pbawp.code = {}));
})(pbawp || (pbawp = {}));
var pbawp;
(function (pbawp) {
    var code;
    (function (code) {
        class HealthBar extends pbawp.assets.fla._HealthBar {
            // private outline:GlowFilter;
            constructor(scene) {
                super(scene);
                this.yellowBar = false;
                this.onTweenUpdate = () => {
                    this.updateScale();
                };
                this.onTweenFinish = () => {
                    if (this.updateHealthDoneCallback != null) {
                        this.updateHealthDoneCallback();
                        this.updateHealthDoneCallback = null;
                    }
                };
                this.flashDone = () => {
                    this.yellowBar = false;
                    this.timer.remove();
                    if (this.parentContainer instanceof pbawp.assets.fla._PlayerBattleInfo) {
                        if (this.parentContainer.background != null) {
                            this.parentContainer.backgroundGotoAndStop("normal");
                            this.parentContainer.health.setColor("#" + (16777215).toString(16));
                        }
                        this.parentContainer.displayName.setColor("#" + (16777215).toString(16));
                    }
                    else if (this.parentContainer instanceof pbawp.assets.fla._OpponentBattleInfo) {
                        if (this.parentContainer.background != null) {
                            this.parentContainer.backgroundGotoAndStop("normal");
                        }
                        this.parentContainer.displayName.setColor("#" + (16777215).toString(16));
                    }
                    this.updateScale();
                    // this.outline.color = 0;
                    // TextField(parent.getChildByName("displayName")).filters = [this.outline];
                    // (this.parentContainer as pbawp.assets.fla._PlayerBattleInfo).hpText).setColor("#"+(16777215).toString(16));
                };
                this.addedToStage();
            }
            addedToStage() {
                /*this.outline = new GlowFilter(0,1,2,2,10);
                this.outline.quality = BitmapFilterQuality.MEDIUM;
                TextField(parent.getChildByName("displayName")).filters = [this.outline];*/
            }
            updateHealth(c, f = null) {
                if (c.curHealth < c.prevHealth) {
                    this.flashOnce();
                    c.prevHealth = c.curHealth;
                }
                this.updateHealthDoneCallback = f;
                this.tween = this.scene.tweens.add({
                    targets: this,
                    "scaleX": c.curHealth / c.maxHealth,
                    duration: 1 * 1000,
                    ease: Phaser.Math.Easing.Linear,
                    onUpdate: this.onTweenUpdate,
                    onComplete: this.onTweenFinish
                });
            }
            updateScale() {
                if (this.yellowBar) {
                    this.gotoAndStop("yellow");
                }
                else if (this.scaleX > 0.5) {
                    this.gotoAndStop("green");
                }
                else if (this.scaleX > 0.2) {
                    this.gotoAndStop("yellow");
                }
                else {
                    this.gotoAndStop("red");
                }
            }
            flashOnce() {
                this.yellowBar = true;
                if (this.parentContainer instanceof pbawp.assets.fla._PlayerBattleInfo) {
                    this.parentContainer.backgroundGotoAndStop("hit");
                    this.gotoAndStop("yellow");
                    this.parentContainer.health.setColor("#" + (16775168).toString(16));
                }
                else if (this.parentContainer instanceof pbawp.assets.fla._OpponentBattleInfo) {
                    this.parentContainer.backgroundGotoAndStop("hit");
                }
                this.gotoAndStop("yellow");
                this.timer = this.scene.time.addEvent({
                    delay: 250,
                    callback: this.flashDone,
                    callbackScope: this,
                    loop: true
                });
                // this.outline.color = 16386816;
                // TextField(parent.getChildByName("displayName")).filters = [this.outline];
                this.parentContainer.displayName.setColor("#" + (16775168).toString(16));
                // (this.parentContainer as pbawp.assets.fla._PlayerBattleInfo).hpText).setColor("#"+(16775168).toString(16));
            }
        }
        code.HealthBar = HealthBar;
    })(code = pbawp.code || (pbawp.code = {}));
})(pbawp || (pbawp = {}));
var pbawp;
(function (pbawp) {
    var code;
    (function (code) {
        class Help extends pbawp.assets.fla._Help {
            constructor(refToGameWorld, scene) {
                super(scene);
                this.gotoNoHelp = () => {
                    this.cancelButton.removeEventListenerClick(this.gotoNoHelp);
                    this.goButton.removeEventListenerClick(this.gotoNoHelp);
                    this.gameworld.hideHelp();
                };
                this.goPressed = () => {
                    //this.goButton.upState = this.goButton.downState;
                };
                this.goReleased = () => {
                    this.gotoNoHelp();
                };
                this.gameworld = refToGameWorld;
                this.helpText1.text = code.GameWorld.constants.getOneLinerWithID("help1");
                this.helpText2.text = code.GameWorld.constants.getOneLinerWithID("help2");
                this.helpText3.text = code.GameWorld.constants.getOneLinerWithID("help3");
                code.GameWorld.constants.setText(this.goButton, code.GameWorld.constants.getOneLinerWithID("helpButton"));
                this.cancelButton.addEventListenerClick(this.gotoNoHelp);
                this.goButton.addEventListenerClick(this.gotoNoHelp);
                this.bg.setInteractive();
            }
        }
        code.Help = Help;
    })(code = pbawp.code || (pbawp.code = {}));
})(pbawp || (pbawp = {}));
var pbawp;
(function (pbawp) {
    var code;
    (function (code) {
        class Intro extends pbawp.code.Screen {
            constructor(refToGameWorld, scene) {
                super(refToGameWorld, scene);
                this.typeCounter = 0;
                this.typeSpeed = 25;
                this.gotoNext = () => {
                    if (this.intro3.text.length != this.introText3.length && !this.gameworld.introShown) {
                        code.GameWorld.soundManager.playSound("dialogReveal");
                        this.intro1.text = this.introText1;
                        this.intro2.text = this.introText2;
                        this.intro3.text = this.introText3;
                        this.typeTimer.remove();
                    }
                    else {
                        this.gameworld.introShown = true;
                        this.gameworld._setState(this.gameworld.GAMESTATE_BATTLE);
                    }
                };
                this.advanceLetter = () => {
                    var nextSpace = NaN;
                    var prevSpace = NaN;
                    var currentString = null;
                    var prevHeight = NaN;
                    this.typeCounter++;
                    if (this.typeCounter <= this.typeString.length) {
                        code.GameWorld.soundManager.playSound("dialog");
                        nextSpace = this.typeString.indexOf(" ", this.typeCounter);
                        if (nextSpace == -1) {
                            nextSpace = this.typeString.length;
                        }
                        prevSpace = Math.max(0, this.typeString.lastIndexOf(" ", this.typeCounter));
                        currentString = this.typeString.substr(this.typeCounter, nextSpace - this.typeCounter);
                        this.typeTextField.text = this.typeString.substr(0, this.typeCounter);
                        prevHeight = this.typeTextField.height;
                        this.typeTextField.text = this.typeString.substr(0, nextSpace);
                        if (code.GameWorld.constants.xmlFile == "english" && prevHeight != this.typeTextField.height && (this.typeString.indexOf("\n", prevSpace) >= nextSpace || this.typeString.indexOf("\n", prevSpace) == -1)) {
                            this.typeTextField.text = this.typeString.substr(0, prevSpace) + "\n" + this.typeString.substr(prevSpace + 1, this.typeCounter - (prevSpace + 1));
                        }
                        else {
                            this.typeTextField.text = this.typeString.substr(0, this.typeCounter);
                        }
                    }
                    else {
                        this.typeTextField.text = this.typeString.substr(0, this.typeString.length);
                        this.typeTimer.remove();
                        if (this.typeTextField == this.intro1) {
                            this.typeText(this.introText2, this.intro2);
                        }
                        else if (this.typeTextField == this.intro2) {
                            this.typeText(this.introText3, this.intro3);
                        }
                    }
                };
                this.initializeView();
                code.GameWorld.constants.setText(this.goButton, code.GameWorld.constants.getOneLinerWithID("introButton"));
                this.introText1 = code.GameWorld.constants.getOneLinerWithID("intro1");
                this.introText2 = code.GameWorld.constants.getOneLinerWithID("intro2");
                this.introText3 = code.GameWorld.constants.getOneLinerWithID("intro3");
                if (code.GameWorld.constants.xmlFile == "chinese") {
                    this.intro3.y = this.intro3.y - 20;
                }
                code.FontHelper.updateTextField(this.intro1);
                code.FontHelper.updateTextField(this.intro2);
                code.FontHelper.updateTextField(this.intro3);
                this.intro1.text = "";
                this.intro2.text = "";
                this.intro3.text = "";
                this.typeText(this.introText1, this.intro1);
                this.goButton.addEventListenerClick(this.gotoNext);
            }
            initializeView() {
                this.view = new pbawp.assets.fla._Intro(this.scene);
                this.add(this.view);
                this.goButton = this.view.goButton;
                this.intro1 = this.view.intro1;
                this.intro2 = this.view.intro2;
                this.intro3 = this.view.intro3;
            }
            stopInput() {
                this.goButton.removeEventListenerClick(this.gotoNext);
                this.typeTimer.remove();
            }
            typeText(newString, field) {
                this.typeCounter = 0;
                this.typeString = newString;
                this.typeTextField = field;
                this.typeTimer = this.scene.time.addEvent({
                    delay: this.typeSpeed,
                    callback: this.advanceLetter,
                    callbackScope: this,
                    loop: true
                });
            }
        }
        code.Intro = Intro;
    })(code = pbawp.code || (pbawp.code = {}));
})(pbawp || (pbawp = {}));
var pbawp;
(function (pbawp) {
    var code;
    (function (code) {
        class MainStatEffect extends code.StatEffect {
            constructor(newType) {
                super();
                this.positiveEffect = new Array(1.5, 2, 2.5, 3, 3.5, 4);
                this.negativeEffect = new Array(0.66, 0.5, 0.4, 0.33, 0.285, 0.25);
                this.type = newType;
            }
        }
        code.MainStatEffect = MainStatEffect;
    })(code = pbawp.code || (pbawp.code = {}));
})(pbawp || (pbawp = {}));
var pbawp;
(function (pbawp) {
    var code;
    (function (code) {
        class Map extends pbawp.code.Screen {
            constructor(refToGameWorld, scene) {
                super(refToGameWorld, scene);
                this.treasureLink = "";
                this.treasureID = "";
                this.treasureOpen = false;
                this.mapScrollTime = 0;
                this.endMapScroll = false;
                this.endMap = "";
                this.advanceDialog = () => {
                    this.dialogBox.advanceLine();
                };
                this.ignoreTreasure = () => {
                    this.checkQueue();
                };
                this.ignoreTreasureGoogleAnalyticsIgnore = () => {
                    sendEvent(petaGA_GameCategory_Game, 'Ignore', 'Pokémon Red White and Blue - Ignore');
                };
                this.ignoreTreasureGoogleAnalyticsSkip = () => {
                    sendEvent(petaGA_GameCategory_Game, 'Skip', 'Pokémon Red White and Blue - Skip');
                };
                this.openTreasure = () => {
                    this.gameworld.player.unlockTreasure(this.treasureID);
                    this.treasure.openTreasure();
                    this.treasureOpen = true;
                    this.checkQueue();
                };
                this.openTreasureGoogleAnalyticsOpen = () => {
                    sendEvent(petaGA_GameCategory_Game, 'Open', 'Pokémon Red White and Blue - Open');
                };
                this.watchTreasure = () => {
                    sendEvent(petaGA_GameCategory_Game, 'View', 'Pokémon Red White and Blue - View');
                    if ( /*!GameWorld.soundManager.muted && */this.treasureID == "freeMeVideo") {
                        //GameWorld.soundManager.mute();
                    }
                    this.dialogBox.gotoAndStop("treasureDone");
                    var jscommand = "window.open(\'" + this.treasureLink + "\',\'win\',\'height=550,width=550,toolbar=no,scrollba rs=yes\');";
                    // var url:URLRequest = new URLRequest("javascript:" + jscommand + " void(0);");
                    // navigateToURL(url,"_self");
                    setupPopUpWindowAnalytics(eval(jscommand));
                };
                this.gotoBattle = () => {
                    this.gameworld.player.currentMap++;
                    this.gameworld._setState(this.gameworld.GAMESTATE_BATTLE);
                };
                this.checkQueue = () => {
                    if (this.actions.length > 0) {
                        this.currentAction = this.actions.shift();
                        this.this_currentAction_attribute_wait = pbawp.util.XMLParser.getAttribute(this.currentAction, "wait");
                        this.performCurrentAction();
                    }
                };
                this.this_currentAction_attribute_wait = "false";
                this.scrollMap = () => {
                    let map = null;
                    let toObject = null;
                    let currentY = -500;
                    for (var i = 0; i < this.maps.length; i++) {
                        map = this.maps[i];
                        if (this.endMapScroll && i == this.maps.length - 1) {
                            map["gotoAndStop"](this.endMap);
                        }
                        currentY = currentY + map.height;
                        map.x = 0;
                        map.y = -currentY;
                        toObject = new Object();
                        toObject["ease"] = Phaser.Math.Easing.Linear;
                        if (this.endMapScroll && i == this.maps.length - 1) {
                            toObject["y"] = 0;
                            this.mapScrollTime = this.mapScrollTime * map.height / this.maps[0].height;
                            if (pbawp.util.XMLParser.getAttribute(this.currentAction, "waitForFinish") == "true") {
                                toObject["onComplete"] = this.checkQueue;
                            }
                            else if (this.this_currentAction_attribute_wait == "true") {
                                this.checkQueue();
                            }
                        }
                        else {
                            toObject["y"] = map.y + map.height;
                        }
                        if (!this.endMapScroll && i == this.maps.length - 1) {
                            toObject["onComplete"] = this.scrollMap;
                        }
                        toObject["targets"] = map;
                        toObject["duration"] = this.mapScrollTime;
                        this.scene.tweens.add(toObject);
                    }
                };
                this.actions = new Array();
                this.characters = new Array();
                this.initializeView();
                this.maps = [this.mapBackground, this.mapBackground2];
                this.fader = new code.Fader(this.gameworld, this.scene);
                this.view.addAt(this.fader, this.view.getIndex(this.view.treasure) + 1);
                this.dialogBox.updatePokemonDictionary(this.gameworld.player);
                this.loadMap(this.gameworld.player.currentMap);
                this.checkQueue();
                this.dialogBox.ignoreButton.addEventListenerClick(this.ignoreTreasure);
                this.dialogBox.ignoreButton.addEventListenerClick(this.ignoreTreasureGoogleAnalyticsIgnore);
                this.dialogBox.skipButton.addEventListenerClick(this.ignoreTreasure);
                this.dialogBox.skipButton.addEventListenerClick(this.ignoreTreasureGoogleAnalyticsSkip);
                this.dialogBox.openButton.addEventListenerClick(this.openTreasure);
                this.dialogBox.openButton.addEventListenerClick(this.openTreasureGoogleAnalyticsOpen);
                this.dialogBox.battleButton.addEventListenerClick(this.gotoBattle);
                this.advanceDialogButton.setInteractive({ cursor: 'pointer' });
                this.advanceDialogButton.on('pointerup', this.advanceDialog, this);
                this.dialogBox.watchButton.addEventListenerClick(this.watchTreasure);
                this.dialogBox.continueButton.addEventListenerClick(this.ignoreTreasure);
                this.dialogBox.yesButton.addEventListenerClick(this.ignoreTreasure);
                this.dialogBox.noButton.addEventListenerClick(this.openTreasure);
                this.init();
                window["map"] = this;
            }
            initializeView() {
                this.view = new pbawp.assets.fla._Map(this.scene);
                this.add(this.view);
                this.treasure = new code.Treasure("treasure1", this.scene);
                this.treasure.x = this.view.treasure.x;
                this.treasure.y = this.view.treasure.y;
                this.view.addAt(this.treasure, this.view.getIndex(this.view.treasure));
                this.view.remove(this.view.treasure);
                this.view.treasure = this.treasure;
                this.treasure.visible = false;
                this.treasure.getTreasureMC().setOrigin(0.27, 0.1);
                this.treasure._setScale(-1, 1);
                this.mapBackground = this.view.mapBackground;
                this.mapBackground2 = this.view.mapBackground2;
                this.dialogBox = new code.DialogBox(this.scene);
                this.dialogBox.x = this.view.dialogBox.x;
                this.dialogBox.y = this.view.dialogBox.y;
                this.view.addAt(this.dialogBox, this.view.getIndex(this.view.dialogBox));
                this.view.remove(this.view.dialogBox);
                this.view.dialogBox = this.dialogBox;
                this.speechBubble = new pbawp.code.SpeechBubble(this.scene);
                this.speechBubble.x = this.view.speechBubble.x;
                this.speechBubble.y = this.view.speechBubble.y;
                this.view.addAt(this.speechBubble, this.view.getIndex(this.view.speechBubble));
                this.view.remove(this.view.speechBubble);
                this.view.speechBubble = this.speechBubble;
                this.advanceDialogButton = this.view.advanceDialogButton;
            }
            init() {
                this.treasure.setScale(0.66);
            }
            _update() {
                super._update();
                for (let m of this.characters) {
                    m.updateTint();
                }
            }
            _destroy() {
                for (let m of this.characters) {
                    m._destroy();
                }
                this.treasure._destroy();
                this.speechBubble._destroy();
            }
            stopInput() {
                this.dialogBox.ignoreButton.removeEventListenerClick(this.ignoreTreasure);
                this.dialogBox.ignoreButton.removeEventListenerClick(this.ignoreTreasureGoogleAnalyticsIgnore);
                this.dialogBox.skipButton.removeEventListenerClick(this.ignoreTreasure);
                this.dialogBox.skipButton.removeEventListenerClick(this.ignoreTreasureGoogleAnalyticsSkip);
                this.dialogBox.openButton.removeEventListenerClick(this.openTreasure);
                this.dialogBox.openButton.removeEventListenerClick(this.openTreasureGoogleAnalyticsOpen);
                this.dialogBox.battleButton.removeEventListenerClick(this.gotoBattle);
                this.advanceDialogButton.off('pointerup', this.advanceDialog, this);
                this.dialogBox.watchButton.removeEventListenerClick(this.watchTreasure);
                this.dialogBox.continueButton.removeEventListenerClick(this.ignoreTreasure);
                this.dialogBox.yesButton.removeEventListenerClick(this.ignoreTreasure);
                this.dialogBox.noButton.removeEventListenerClick(this.openTreasure);
            }
            loadMap(mapNum) {
                this.loadXML(code.GameWorld.constants.getMapWithIndex(mapNum));
            }
            loadXML(xml) {
                this.updateMap(pbawp.util.XMLParser.getAttribute(xml, "startMapMCName"));
                this.treasureID = pbawp.util.XMLParser.getAttribute(xml, "treasureID");
                this.treasureLink = code.GameWorld.constants.getTreasureLink(this.treasureID);
                this.actions.splice(0);
                let action = pbawp.util.XMLParser.getChildNode(xml, "action");
                for (let a of action) {
                    this.actions.push(a);
                }
                return xml;
            }
            chooseToWatchTreasure() {
                this.view.gotoAndStop("dialog");
                this.dialogBox.gotoAndStop("treasureOpen");
            }
            showTreasure() {
                this.view.gotoAndStop("dialog");
                this.dialogBox.gotoAndStop("treasureFind");
                this.dialogBox.dialogText.text = code.GameWorld.constants.getOneLinerWithID("foundChest").replace("%pokemon%", this.gameworld.player.getFirstPokemon().displayName);
            }
            performCurrentAction() {
                var characterString = null;
                var s = null;
                var m = null;
                var mc = null;
                var fromObject = null;
                var toObject = null;
                var time = NaN;
                var curCharacter = null;
                let currentActionID = pbawp.util.XMLParser.getAttribute(this.currentAction, "id");
                let currentAction_action = pbawp.util.XMLParser.getAttribute(this.currentAction, "action");
                let characterID = pbawp.util.XMLParser.getAttribute(this.currentAction, "characterID");
                let speed = Number(pbawp.util.XMLParser.getAttribute(this.currentAction, "speed"));
                console.log("performing current action: " + currentActionID);
                this.view.gotoAndStop("noDialog");
                this.speechBubble.alpha = 0;
                if (pbawp.util.XMLParser.getAttribute(this.currentAction, "needsOpen") == "true" && !this.treasureOpen) {
                    this.checkQueue();
                    return;
                }
                if (pbawp.util.XMLParser.getAttribute(this.currentAction, "needsSkip") == "true" && this.treasureOpen) {
                    this.checkQueue();
                    return;
                }
                if (pbawp.util.XMLParser.getAttribute(this.currentAction, "oncePerGame") == "true") {
                    if (this.gameworld.mapOneOffs[currentActionID]) {
                        this.checkQueue();
                        return;
                    }
                    this.gameworld.mapOneOffs[currentActionID] = true;
                }
                if (currentActionID == "setup") {
                    characterString = String(pbawp.util.XMLParser.getAttribute(this.currentAction, "characters")).split(", ").reverse();
                    for (let s of characterString) {
                        m = new code.MapCharacter(s, this.scene);
                        this.characters.push(m);
                        this.view.addAt(m, this.view.getIndex(this.treasure) + 1);
                    }
                }
                else if (currentActionID == "animateCharacter") {
                    console.warn("this.getCharacterWithID(this.currentAction.@characterID).playFromCurrentFrame();");
                    this.getCharacterWithID(characterID).playFromCurrentFrame();
                }
                else if (currentActionID == "stopAnimateCharacter") {
                    this.getCharacterWithID(characterID).stopOnCurrentFrame();
                }
                else if (currentActionID == "animate") {
                    mc = this.getCharacterWithID(characterID);
                    fromObject = pbawp.util.TweenHelper.TweenObjectForAction(this.currentAction, "from");
                    toObject = pbawp.util.TweenHelper.TweenObjectForAction(this.currentAction, "to");
                    if (this.this_currentAction_attribute_wait == "true") {
                        toObject["onComplete"] = this.checkQueue;
                    }
                    time = 0;
                    if (pbawp.util.XMLParser.getAttribute(this.currentAction, "time") == "scrollMap") {
                        time = this.mapScrollTime;
                        console.log("animating character : " + characterID + " --- time: " + time);
                    }
                    else {
                        time = Math.floor(parseFloat(pbawp.util.XMLParser.getAttribute(this.currentAction, "time")) * 1000);
                    }
                    time = Math.floor(time);
                    if (time == 0) {
                        for (let k in toObject) {
                            mc[k] = toObject[k];
                        }
                        if (toObject["onComplete"]) {
                            toObject["onComplete"]();
                        }
                    }
                    else {
                        toObject["targets"] = mc;
                        toObject["duration"] = time;
                        if (fromObject != null) {
                            for (let k in fromObject) {
                                mc[k] = fromObject[k];
                            }
                            this.scene.tweens.add(toObject);
                        }
                        else {
                            this.scene.tweens.add(toObject);
                        }
                    }
                }
                else if (currentActionID == "swapCharacter") {
                    this.getCharacterWithID(pbawp.util.XMLParser.getAttribute(this.currentAction, "oldCharacterID"))
                        ._swap(pbawp.util.XMLParser.getAttribute(this.currentAction, "newCharacterID"));
                    if (this.this_currentAction_attribute_wait == "true") {
                        this.getCharacterWithID(pbawp.util.XMLParser.getAttribute(this.currentAction, "newCharacterID")).playOnce(this.checkQueue);
                    }
                    else {
                        this.checkQueue();
                    }
                }
                else if (currentActionID == "dialog") {
                    this.speechBubble.alpha = 1;
                    this.view.gotoAndStop("characterSpeak");
                    this.dialogBox.gotoAndStop("mapDialog");
                    this.dialogBox.addLine(pbawp.util.XMLParser.getAttribute(this.currentAction, "text"));
                    this.dialogBox.updateText();
                    this.dialogBox.setNextClickCallback(this.checkQueue);
                    this.this_currentAction_attribute_wait /*this.currentAction.@wait*/ = "true";
                    //this.currentAction.@wait = "true";
                    curCharacter = this.getCharacterWithID(pbawp.util.XMLParser.getAttribute(this.currentAction, "characterID"));
                    this.speechBubble.appearFrom(curCharacter);
                }
                else if (currentActionID == "showTreasure") {
                    this.treasure.x = Number(pbawp.util.XMLParser.getAttribute(this.currentAction, "x"));
                    this.treasure.y = Number(pbawp.util.XMLParser.getAttribute(this.currentAction, "y"));
                    this.treasure.showTreasure();
                    this.treasure.visible = true;
                    this.checkQueue();
                }
                else if (currentActionID == "openTreasure") {
                    this.showTreasure();
                }
                else if (currentActionID == "watchTreasure") {
                    this.chooseToWatchTreasure();
                    this.dialogBox.dialogText.text = pbawp.util.XMLParser.getAttribute(this.currentAction, "text");
                }
                else if (currentActionID == "fadeOut") {
                    this.fader.fadeOut(this.this_currentAction_attribute_wait /*this.currentAction.@wait*/ == "true" ?
                        this.checkQueue : null, speed);
                }
                else if (currentActionID == "fadeIn") {
                    this.fader.fadeIn(this.this_currentAction_attribute_wait /*this.currentAction.@wait*/ == "true" ? this.checkQueue : null, speed);
                }
                else if (currentActionID == "swapMap") {
                    this.updateMap(pbawp.util.XMLParser.getAttribute(this.currentAction, "mapName"));
                }
                else if (currentActionID == "startBattle") {
                    this.view.gotoAndStop("dialog");
                    this.dialogBox.gotoAndStop("mapBattle");
                    this.dialogBox.dialogText.text = pbawp.util.XMLParser.getAttribute(this.currentAction, "text");
                }
                else if (currentActionID == "info") {
                    this.view.gotoAndStop("characterSpeak");
                    this.dialogBox.gotoAndStop("mapInfo");
                    this.dialogBox.addLine(pbawp.util.XMLParser.getAttribute(this.currentAction, "text"));
                    this.dialogBox.updateText();
                    this.dialogBox.setNextClickCallback(this.checkQueue);
                    this.this_currentAction_attribute_wait /*this.currentAction.@wait*/ = "true";
                }
                else if (currentActionID == "hideTreasure") {
                    this.treasure.hideTreasure();
                }
                else if (currentActionID == "gameover") {
                    //console.log('ExternalInterface.call("window.parent.sendEvent,petaGA_GameCategory_Game,"End","Pokemon Game Completion"]);')
                    //ExternalInterface.call("window.parent.sendEvent,petaGA_GameCategory_Game,"End","Pokemon Game Completion"]);
                    this.gameworld._setState(this.gameworld.GAMESTATE_GAME_ALMOST_WIN);
                }
                else if (currentActionID == "areYouSurePrompt") {
                    this.view.gotoAndStop("dialog");
                    this.dialogBox.gotoAndStop("treasureAreYouSure");
                    this.dialogBox.dialogText.text = pbawp.util.XMLParser.getAttribute(this.currentAction, "text");
                }
                else if (currentActionID == "scrollMap") {
                    let to = pbawp.util.TweenHelper.TweenObjectForAction(this.currentAction, "to");
                    to["targets"] = this.mapBackground;
                    to["duration"] = parseFloat(pbawp.util.XMLParser.getAttribute(this.currentAction, "time")) * 1000;
                    this.scene.tweens.add(to);
                }
                else if (currentActionID == "infiniteScrollMap") {
                    if (currentAction_action == "start") {
                        this.mapScrollTime = parseFloat(pbawp.util.XMLParser.getAttribute(this.currentAction, "time")) * 1000;
                        this.scrollMap();
                    }
                    else if (currentAction_action == "end") {
                        this.endMapScroll = true;
                        this.endMap = pbawp.util.XMLParser.getAttribute(this.currentAction, "endMap");
                    }
                    else if (currentAction_action == "startAndEnd") {
                        this.endMapScroll = true;
                        this.mapScrollTime = parseFloat(pbawp.util.XMLParser.getAttribute(this.currentAction, "time")) * 1000;
                        this.endMap = pbawp.util.XMLParser.getAttribute(this.currentAction, "endMap");
                        this.scrollMap();
                    }
                }
                else if (currentActionID == "delay") {
                    delayedCall(parseFloat(pbawp.util.XMLParser.getAttribute(this.currentAction, "seconds")) * 1000, () => {
                        this.checkQueue();
                    });
                }
                else if (currentActionID == "fadeMusic") {
                    code.GameWorld.soundManager.fadeMusic(pbawp.util.XMLParser.getAttribute(this.currentAction, "to"), parseFloat(pbawp.util.XMLParser.getAttribute(this.currentAction, "time")) * 1000);
                }
                else if (currentActionID == "playSound") {
                    let properties = pbawp.util.XMLParser.getAttribute(this.currentAction, "properties");
                    if (!isEmpty(properties)) {
                        toObject = pbawp.util.TweenHelper.TweenObjectForAction(this.currentAction, "to");
                        fromObject = pbawp.util.TweenHelper.TweenObjectForAction(this.currentAction, "from");
                        toObject["onComplete"] = code.GameWorld.soundManager.playSound;
                        toObject["onCompleteScope"] = code.GameWorld.soundManager;
                        toObject["onCompleteParams"] = new Array(pbawp.util.XMLParser.getAttribute(this.currentAction, "sound"));
                        toObject["targets"] = fromObject;
                        toObject["duration"] = parseFloat(pbawp.util.XMLParser.getAttribute(this.currentAction, "time")) * 1000;
                        this.scene.tweens.add(toObject);
                    }
                    else {
                        code.GameWorld.soundManager.playSound(pbawp.util.XMLParser.getAttribute(this.currentAction, "sound"));
                    }
                }
                if (this.this_currentAction_attribute_wait /*this.currentAction.@wait*/ != "true") {
                    this.checkQueue();
                }
            }
            updateMap(newMap) {
                let map = null;
                for (map of this.maps) {
                    map["gotoAndStop"](newMap);
                    map.y = 500 - map.height;
                }
            }
            getCharacterWithID(characterID) {
                var m = null;
                for (let m of this.characters) {
                    if (m.id == characterID) {
                        return m;
                    }
                }
                return null;
            }
        }
        code.Map = Map;
    })(code = pbawp.code || (pbawp.code = {}));
})(pbawp || (pbawp = {}));
var pbawp;
(function (pbawp) {
    var code;
    (function (code) {
        class MapCharacter extends Phaser.GameObjects.Container {
            constructor(initialClip, scene) {
                super(scene);
                this.animationDoneCallback = null;
                this.speechOffset = 74;
                this.tint = 0xFFFFFF;
                this.loadClip(initialClip);
                this.visible = true;
            }
            loadClip(clipID) {
                this.id = clipID;
                this.animationClip = (new pbawp.assets.swf._TopdownSWF(this.scene)).getChildByName(clipID);
                this.animationClip.x = 0;
                this.animationClip.y = 0;
                this.animationClip["gotoAndStop"](this.getRandomFrame());
                this.add(this.animationClip);
                if (this.animationClip.hasOwnProperty('speechOffset')) {
                    this.speechOffset = this.animationClip['speechOffset'];
                }
            }
            _destroy() {
                this.remove(this.animationClip);
                //GameWorld.preloader.getSWF(this.getSWFNameForClip(this.id)).addChild(this.animationClip);
            }
            _swap(newClip) {
                this.remove(this.animationClip);
                //GameWorld.preloader.getSWF(this.getSWFNameForClip(this.id)).addChild(this.animationClip);
                this.loadClip(newClip);
                this.animationClip["gotoAndStop"](0);
            }
            playOnce(callback = null) {
                this.animationDoneCallback = callback;
                this.animationClip["gotoAndPlay"](0, this.animationDoneCallback);
            }
            playFromFrame(frameNum = 0) {
                this.animationClip["gotoAndPlay"](frameNum);
            }
            playFromCurrentFrame() {
                if (this.animationClip.anims.isPaused) {
                    this.animationClip.anims.resume();
                }
                else {
                    this.playFromFrame(0);
                }
            }
            stopOnCurrentFrame() {
                this.animationClip.anims.pause();
            }
            getRandomFrame() {
                return Math.floor(Math.random() * (this.animationClip["totalFrames"] + 1));
            }
            updateTint() {
                //not supporting white tint for now
                // if (this.animationClip) this.animationClip.tint = this.tint;
            }
        }
        code.MapCharacter = MapCharacter;
    })(code = pbawp.code || (pbawp.code = {}));
})(pbawp || (pbawp = {}));
///<reference path="Screen.ts"/>
var pbawp;
(function (pbawp) {
    var code;
    (function (code) {
        class MenuMain extends pbawp.code.Screen {
            constructor(refToGameWorld, scene) {
                super(refToGameWorld, scene);
                this.shakeAmount = 3;
                this.shakeTime = 0.1;
                this.treasureState = 0;
                this.playState = 0;
                this.treasureShakeDone = () => {
                    if (this.treasureState == 0) {
                        this.treasureShakeTween = this.scene.tweens.add({
                            targets: this.treasureButton,
                            "x": this.treasureButton.x - this.shakeAmount,
                            duration: this.shakeTime * 0.25 * 1000,
                            // yoyo: true,
                            onComplete: this.treasureShakeDone
                        });
                    }
                    else if (this.treasureState == 1) {
                        this.treasureShakeTween = this.scene.tweens.add({
                            targets: this.treasureButton,
                            "x": this.treasureButton.x + this.shakeAmount * 2,
                            duration: this.shakeTime * 0.5 * 1000,
                            // yoyo: true,
                            onComplete: this.treasureShakeDone
                        });
                    }
                    else if (this.treasureState == 2) {
                        this.treasureShakeTween = this.scene.tweens.add({
                            targets: this.treasureButton,
                            "x": this.treasureButton.x - this.shakeAmount,
                            duration: this.shakeTime * 0.25 * 1000,
                            // yoyo: true,
                            onComplete: this.treasureShakeDone
                        });
                    }
                    this.treasureState++;
                };
                this.playShakeDone = () => {
                    if (this.playState == 0) {
                        this.playShakeTween = this.scene.tweens.add({
                            targets: this.playButton,
                            "x": this.playButton.x + this.shakeAmount,
                            duration: this.shakeTime * 0.25 * 1000,
                            // yoyo: true,
                            onComplete: this.playShakeDone
                        });
                    }
                    else if (this.playState == 1) {
                        this.playShakeTween = this.scene.tweens.add({
                            targets: this.playButton,
                            "x": this.playButton.x - this.shakeAmount * 2,
                            duration: this.shakeTime * 0.5 * 1000,
                            // yoyo: true,
                            onComplete: this.playShakeDone
                        });
                    }
                    else if (this.playState == 2) {
                        this.playShakeTween = this.scene.tweens.add({
                            targets: this.playButton,
                            "x": this.playButton.x + this.shakeAmount,
                            duration: this.shakeTime * 0.25 * 1000,
                            // yoyo: true,
                            onComplete: this.playShakeDone
                        });
                    }
                    this.playState++;
                };
                this.gotoPlay = () => {
                    //console.log('ExternalInterface.call("window.parent.sendEvent(petaGA_GameCategory_Game, "Play","Pokemon Game Initiation"]);');
                    //ExternalInterface.call("window.parent.sendEvent(petaGA_GameCategory_Game,"Play","Pokemon Game Initiation"]);
                    this.gameworld.newGame();
                    this.gameworld._setState(this.gameworld.GAMESTATE_INTRO);
                    sendEvent(petaGA_GameCategory_Game, 'Play', 'Pokémon Red White and Blue - Play');
                };
                this.gotoTreasure = () => {
                    this.gameworld._setState(this.gameworld.GAMESTATE_TREASURE, 0.3);
                };
                this.gotoChangeLanguage = () => {
                    console.log("change language");
                    if (code.GameWorld.constants.xmlFile == "english") {
                        code.GameWorld.constants.setText(this.changeLanguageButton, code.GameWorld.constants.getOneLinerWithID("languageEnglish"), true, "english");
                        code.GameWorld.constants.xmlFile = "chinese";
                        code.GameWorld.constants.xml = pbawp.util.XMLParser.toXMLDoc(redWhiteAndBlue_chinese_xml);
                    }
                    else {
                        code.GameWorld.constants.xmlFile = "english";
                        code.GameWorld.constants.xml = pbawp.util.XMLParser.toXMLDoc(redWhiteAndBlue_xml);
                        code.GameWorld.constants.setText(this.changeLanguageButton, code.GameWorld.constants.getOneLinerWithID("languageChinese"), true, "chinese");
                    }
                    this.view.titleLogoGotoAndStop(code.GameWorld.constants.xmlFile);
                    this.view.popLogoGotoAndStop(code.GameWorld.constants.xmlFile);
                    code.GameWorld.constants.setText(this.playButton, code.GameWorld.constants.getOneLinerWithID("playButton"));
                    code.GameWorld.constants.setText(this.treasureButton, code.GameWorld.constants.getOneLinerWithID("treasureButton"));
                };
                this.initializeView();
                console.log("WARN! CHECK IT!");
                if (pbawp.code.URL.shouldDefaultToChinese()) {
                    this.view.titleLogoGotoAndStop("chinese");
                }
                if (code.GameWorld.constants.xmlFile == "chinese") {
                    this.view.titleLogoGotoAndStop("chinese");
                    this.view.popLogoGotoAndStop("chinese");
                    code.GameWorld.constants.setText(this.changeLanguageButton, code.GameWorld.constants.getOneLinerWithID("languageEnglish"), true, "english");
                }
                else {
                    code.GameWorld.constants.setText(this.changeLanguageButton, code.GameWorld.constants.getOneLinerWithID("languageChinese"), true, "chinese");
                }
                code.GameWorld.constants.setText(this.playButton, code.GameWorld.constants.getOneLinerWithID("playButton"));
                code.GameWorld.constants.setText(this.treasureButton, code.GameWorld.constants.getOneLinerWithID("treasureButton"));
                if (this.gameworld.gamestate == this.gameworld.GAMESTATE_LOADING) {
                    // this.gameworld.overlay.alpha = 0;
                    this.treasureButton.alpha = 0;
                    this.playButton.alpha = 0;
                    this.popLogo.alpha = 0;
                    this.loadBarDone();
                }
                code.GameWorld.soundManager.playMusic("MusicMain", true);
                this.playButton.addEventListenerClick(this.gotoPlay);
                this.treasureButton.addEventListenerClick(this.gotoTreasure);
                this.changeLanguageButton.addEventListenerClick(this.gotoChangeLanguage);
                this.view.petaLogoGotoAndStop(code.GameWorld.constants.getPetaLogo());
            }
            initializeView() {
                this.view = new pbawp.assets.fla._MenuMain(this.scene);
                this.add(this.view);
                this.playButton = this.view.playButton;
                this.treasureButton = this.view.treasureButton;
                this.changeLanguageButton = this.view.changeLanguageButton;
                this.petaLogo = this.view.petaLogo;
                this.popLogo = this.view.popLogo;
            }
            stopInput() {
                this.playButton.removeEventListenerClick(this.gotoPlay);
                this.treasureButton.removeEventListenerClick(this.gotoTreasure);
                this.changeLanguageButton.removeEventListenerClick(this.gotoChangeLanguage);
            }
            loadBarDone() {
                // this.overlayTween = new Tween(this.gameworld.overlay,"alpha",Regular.easeOut,0,1,0.5,true);
                this.treasureButton.alpha = 0;
                this.treasureFadeTween = this.scene.tweens.add({
                    targets: this.treasureButton,
                    "alpha": 1,
                    duration: 0.5 * 1000
                });
                this.playFadeTween = this.scene.tweens.add({
                    targets: this.playButton,
                    "alpha": 1,
                    duration: 0.5 * 1000
                });
                this.logoTween = this.scene.tweens.add({
                    targets: this.popLogo,
                    "alpha": 1,
                    duration: 0.5 * 1000
                });
                this.treasureShakeDone();
                this.playShakeDone();
            }
        }
        code.MenuMain = MenuMain;
    })(code = pbawp.code || (pbawp.code = {}));
})(pbawp || (pbawp = {}));
///<reference path="../assets/fla/_NamePokemonTextField.ts"/>
var pbawp;
(function (pbawp) {
    var code;
    (function (code) {
        class NamePokemonTextField extends pbawp.assets.fla._NamePokemonTextField {
            constructor(scene) {
                super(scene);
                this.isEnabled = false;
                this.isAddedEventListener_ENTER_FRAME = false;
                this.setInputTextFieldContainerVisible(false);
            }
            _update() {
                if (!this.isAddedEventListener_ENTER_FRAME)
                    return;
                let elemDiv = document.getElementById('inputFieldWidthHelperID');
                elemDiv.style.font = this.inputTextField.style.font;
                elemDiv.style.fontSize = this.inputTextField.style.fontSize;
                elemDiv.innerText = this.inputTextField.value;
                let textWidth = elemDiv.clientWidth;
                this.cursor.x = elemDiv.clientWidth * this.scene.game.scale.displayScale.x;
                this.cursor.visible = textWidth < 170;
                if (textWidth >= 170) {
                    this.inputTextField.maxLength = this.inputTextField.value.length;
                }
                else {
                    this.inputTextField.maxLength = 100;
                }
            }
            setEnabled(newEnabled) {
                if (this.isEnabled && !newEnabled) {
                    this.isAddedEventListener_ENTER_FRAME = false;
                }
                else if (!this.isEnabled && newEnabled) {
                    this.isAddedEventListener_ENTER_FRAME = true;
                }
                this.isEnabled = newEnabled;
                if (this.isEnabled) {
                    this.initializeInput();
                }
                else {
                    super.destroyInput();
                }
            }
        }
        code.NamePokemonTextField = NamePokemonTextField;
    })(code = pbawp.code || (pbawp.code = {}));
})(pbawp || (pbawp = {}));
var pbawp;
(function (pbawp) {
    var code;
    (function (code) {
        /**
         * ...
         * @author Roman
         */
        class OpponentBattleInfo extends pbawp.assets.fla._OpponentBattleInfo {
            //---------------------------------------------------------
            initializeView() {
                var healthBar = new pbawp.code.HealthBar(this.scene);
                healthBar.x = this.healthBar.x;
                healthBar.y = this.healthBar.y;
                this.addAt(healthBar, this.getIndex(this.healthBar));
                this.remove(this.healthBar);
                this.healthBar = healthBar;
            }
            //---------------------------------------------------------
            constructor(scene) {
                super(scene);
                this.initializeView();
            }
        }
        code.OpponentBattleInfo = OpponentBattleInfo;
    })(code = pbawp.code || (pbawp.code = {}));
})(pbawp || (pbawp = {}));
var pbawp;
(function (pbawp) {
    var code;
    (function (code) {
        class Overlay extends pbawp.assets.fla._Overlay {
            constructor(refToGameWorld, scene) {
                super(scene);
                this.gotoHelp = () => {
                    this.gameworld.showHelp();
                };
                this.gotoMute = () => {
                    code.GameWorld.soundManager.mute();
                    this.updateMuteButtons();
                };
                this.gameworld = refToGameWorld;
                this.versionNo.visible = false;
                this.updateMuteButtons();
                this.helpButton.addEventListenerClick(this.gotoHelp);
                this.muteButton.addEventListenerClick(this.gotoMute);
                this.unmuteButton.addEventListenerClick(this.gotoMute);
            }
            enableHelp(newEnabled) {
                this.helpButton.visible = newEnabled;
            }
            updateMuteButtons() {
                this.muteButton.visible = !code.GameWorld.soundManager.muted;
                this.unmuteButton.visible = code.GameWorld.soundManager.muted;
            }
            ;
        }
        code.Overlay = Overlay;
    })(code = pbawp.code || (pbawp.code = {}));
})(pbawp || (pbawp = {}));
var pbawp;
(function (pbawp) {
    var code;
    (function (code) {
        class Paralyze extends code.StatusEffect {
            constructor() {
                super();
                this.chance = 25;
                this.speedMod = 0.75;
                this.type = "paralyze";
                this.turnsLeft = Math.floor(Math.random() * (4 - 1)) + 1;
            }
            preAttack() {
                super.preAttack();
                var ran = Math.random() * 100;
                if (ran <= this.chance) {
                    this.triggered = true;
                }
                else {
                    this.triggered = false;
                }
            }
            postAttack() {
                super.postAttack();
            }
        }
        code.Paralyze = Paralyze;
    })(code = pbawp.code || (pbawp.code = {}));
})(pbawp || (pbawp = {}));
var pbawp;
(function (pbawp) {
    var code;
    (function (code) {
        class Player {
            constructor(scene) {
                this.currentPokemon = 0;
                this.startBattlePokemon = 0;
                this.currentBattle = 0;
                this.currentMap = 0;
                this.gameWon = false;
                this.scene = scene;
                this.pokemon = new Array();
                this.treasuresUnlocked = new Array();
                this.pokemonCallIn = new Array("tepig", "snivy", "oshawott");
                this.newGame();
                var sharedObject = pbawp.util.SharedObject.getLocal("redWhiteAndBlue");
                if (sharedObject.data["treasures"]) {
                    this.treasuresUnlocked = sharedObject.data["treasures"];
                }
                if (sharedObject.data["gameWon"]) {
                    this.gameWon = sharedObject.data["gameWon"];
                }
                if (pbawp.util.XMLParser.getAttribute(code.GameWorld.constants.getElementWithName("gamegenie"), "allTreasures") == "true") {
                    this.unlockTreasure("freeMeVideo");
                    this.unlockTreasure("wallpaper");
                    this.unlockTreasure("tradingCards");
                }
            }
            getNewestPokemon() {
                return this.pokemon[this.pokemon.length - 1];
            }
            getCurrentPokemon() {
                return this.pokemon[this.currentPokemon];
            }
            getFirstPokemon() {
                return this.pokemon[0];
            }
            newGame() {
                this.currentPokemon = 0;
                this.currentBattle = Number(pbawp.util.XMLParser.getAttribute(code.GameWorld.constants.getElementWithName("gamegenie"), "firstBattle"));
                this.currentMap = Number(pbawp.util.XMLParser.getAttribute(code.GameWorld.constants.getElementWithName("gamegenie"), "firstMap"));
                this.pokemon.splice(0);
                this.pokemon.push(new code.Pokemon(this.scene));
                this.getNewestPokemon().loadInfo(pbawp.util.XMLParser.getAttribute(code.GameWorld.constants.getElementWithName("gamegenie"), "startingPokemon"));
                if (pbawp.util.XMLParser.getAttribute(code.GameWorld.constants.getElementWithName("gamegenie"), "allPokemon") == "true") {
                    this.pokemon.push(new code.Pokemon(this.scene));
                    this.getNewestPokemon().loadInfo("miltank");
                    this.pokemon.push(new code.Pokemon(this.scene));
                    this.getNewestPokemon().loadInfo("jigglypuff");
                    this.pokemon.push(new code.Pokemon(this.scene));
                    this.getNewestPokemon().loadInfo("grimace");
                }
            }
            continueFromGameOver() {
                this.currentPokemon = 0;
                for (var i = 0; i < this.pokemon.length; i++) {
                    this.pokemon[i].curHealth = this.pokemon[i].maxHealth;
                    this.pokemon[i].restorePP();
                }
            }
            getPokemonWithType(t) {
                var p = null;
                for (let p of this.pokemon) {
                    if (p.id == t) {
                        return p;
                    }
                }
                return null;
            }
            getPokemonLocation(t) {
                var p = null;
                for (var i = 0; i < this.pokemon.length; i++) {
                    p = this.pokemon[i];
                    if (p.id == t) {
                        return i;
                    }
                }
                return 0;
            }
            unlockTreasure(treasureID) {
                var s = null;
                var sharedObject = null;
                for (let s of this.treasuresUnlocked) {
                    if (s == treasureID) {
                        return;
                    }
                }
                this.treasuresUnlocked.push(treasureID);
                sharedObject = pbawp.util.SharedObject.getLocal("redWhiteAndBlue");
                sharedObject.data["treasures"] = this.treasuresUnlocked;
                sharedObject.flush();
            }
            isTreasureUnlocked(treasureID) {
                var s = null;
                for (let s of this.treasuresUnlocked) {
                    if (s == treasureID) {
                        return true;
                    }
                }
                return false;
            }
            winGame() {
                var sharedObject = pbawp.util.SharedObject.getLocal("redWhiteAndBlue");
                sharedObject.data["gameWon"] = true;
                sharedObject.flush();
                this.gameWon = true;
            }
            getPokemonCallIn() {
                if (this.pokemonCallIn.length == 0) {
                    this.pokemonCallIn = new Array("tepig", "snivy", "oshawott");
                }
                var ran = Math.floor(Math.random() * this.pokemonCallIn.length);
                var returnPokemon = this.pokemonCallIn.splice(ran, 1);
                return returnPokemon[0];
            }
            canActivateCheat() {
                return !this.cheatUsedInBattle && this.gameWon;
            }
            cheatActivated() {
                this.cheatUsedInBattle = true;
            }
            resetCheat() {
                this.cheatUsedInBattle = false;
            }
        }
        code.Player = Player;
    })(code = pbawp.code || (pbawp.code = {}));
})(pbawp || (pbawp = {}));
var pbawp;
(function (pbawp) {
    var code;
    (function (code) {
        /**
         * ...
         * @author Roman
         */
        class PlayerBattleInfo extends pbawp.assets.fla._PlayerBattleInfo {
            //---------------------------------------------------------
            initializeView() {
                var healthBar = new pbawp.code.HealthBar(this.scene);
                healthBar.x = this.healthBar.x;
                healthBar.y = this.healthBar.y;
                this.addAt(healthBar, this.getIndex(this.healthBar));
                this.remove(this.healthBar);
                this.healthBar = healthBar;
            }
            //---------------------------------------------------------
            constructor(scene) {
                super(scene);
                this.initializeView();
            }
        }
        code.PlayerBattleInfo = PlayerBattleInfo;
    })(code = pbawp.code || (pbawp.code = {}));
})(pbawp || (pbawp = {}));
var pbawp;
(function (pbawp) {
    var code;
    (function (code) {
        class Poison extends code.StatusEffect {
            constructor() {
                super();
                this.percentHealth = 0.125;
                this.type = "poison";
                this.turnsLeft = 1;
                this.triggered = true;
            }
            preAttack() {
                super.preAttack();
            }
            postAttack() {
            }
        }
        code.Poison = Poison;
    })(code = pbawp.code || (pbawp.code = {}));
})(pbawp || (pbawp = {}));
var pbawp;
(function (pbawp) {
    var code;
    (function (code) {
        class Pokemon extends pbawp.code.Character {
            constructor(scene) {
                super(scene);
            }
            loadInfo(pokemonID) {
                if (pokemonID != null && pokemonID != "") {
                    this.loadFromXML(code.GameWorld.constants.getPokemonWithID(pokemonID));
                }
            }
            loadFromXML(xml) {
                super.loadFromXML(xml);
                this.originalTrainerName = pbawp.util.XMLParser.getAttribute(xml, "originalTrainer");
                this.description = pbawp.util.XMLParser.getAttribute(xml, "description").split("\\n").join("\n");
                this.pokedexNumber = Number(pbawp.util.XMLParser.getAttribute(xml, "pokedexNumber"));
                this.species = pbawp.util.XMLParser.getAttribute(xml, "species");
                this.statWeight = pbawp.util.XMLParser.getAttribute(xml, "weight");
                this.statHeight = pbawp.util.XMLParser.getAttribute(xml, "height");
                return xml;
            }
            _swap(c) {
                super._swap(c);
                var p = c;
                this.originalTrainerName = p.originalTrainerName;
                this.description = p.description;
                this.pokedexNumber = p.pokedexNumber;
                this.species = p.species;
            }
            restorePP() {
                let a = null;
                for (a of this.moves) {
                    a.curPP = a.maxPP;
                }
            }
            playFrame(frameName, callback = null) {
                if (frameName != null) {
                    super.playFrame(frameName, callback);
                    this.animationClip.gotoAndPlay(frameName); //MovieClip(this.animationClip.getChildByName(id)).gotoAndPlay(frameName);
                }
                else if (callback != null) {
                    callback();
                }
            }
            stopFrame(frameName) {
                if (frameName != null) {
                    super.stopFrame(frameName);
                    this.animationClip.gotoAndStop(frameName); // MovieClip(animationClip.getChildByName(id)).gotoAndStop(frameName);
                }
            }
            loadMovieClip() {
                super.loadMovieClip();
                if (this.id == "pikachu") {
                    this.animationClip.x = 20;
                }
                else if (this.id == "oshawott") {
                    this.animationClip.x = -15;
                    this.animationClip.y = 3;
                }
                else {
                    this.animationClip.x = 0;
                }
            }
        }
        code.Pokemon = Pokemon;
    })(code = pbawp.code || (pbawp.code = {}));
})(pbawp || (pbawp = {}));
var pbawp;
(function (pbawp) {
    var code;
    (function (code) {
        class PokemonSelectButton extends pbawp.assets.fla._PokemonSelectButton {
            constructor(scene) {
                super(scene);
                this.isEnabled = false;
                this.elementType = "normal";
                this.down = () => {
                    this.gotoAndStop("mouseDown");
                    this.backgroundButtonGotoAndStop(this.elementType + "Down");
                    this.hoverImage.visible = false;
                };
                this.over = () => {
                    this.gotoAndStop("mouseOver");
                    this.backgroundButtonGotoAndStop(this.elementType + "Over");
                    this.hoverImage.visible = true;
                };
                this.out = () => {
                    this.gotoAndStop("mouseOut");
                    this.backgroundButtonGotoAndStop(this.elementType + "Out");
                    this.hoverImage.visible = false;
                };
                this.callback = null;
                this.hoverImage.scaleX = 0.98;
                this.tweenX = this.scene.tweens.add({
                    targets: this.hoverImage,
                    "scaleX": 1.01,
                    duration: 0.35 * 1000,
                    yoyo: true
                });
                this.hoverImage.scaleY = 0.98;
                this.tweenY = this.scene.tweens.add({
                    targets: this.hoverImage,
                    "scaleX": 1.01,
                    duration: 0.35 * 1000,
                    yoyo: true
                });
                this.gotoAndStop("disabled");
                this.hoverImage.visible = false;
            }
            setEnabled(newEnabled) {
                if (newEnabled && !this.isEnabled) {
                    this.background.setInteractive({ cursor: 'pointer' });
                    this.background.on('pointerdown', this.down);
                    this.background.on('pointerover', this.over);
                    this.background.on('pointerout', this.out);
                    this.out();
                }
                else if (!newEnabled && this.isEnabled) {
                    this.disableInteractive();
                    this.background.off('pointerdown', this.down);
                    this.background.off('pointerover', this.over);
                    this.background.off('pointerout', this.out);
                }
                if (!newEnabled) {
                    this.gotoAndStop("disabled");
                    if (this.positionNum == 1 || this.positionNum == 4) {
                        this.backgroundButtonGotoAndStop("disabledTLBR");
                    }
                    else if (this.positionNum == 2 || this.positionNum == 3) {
                        this.backgroundButtonGotoAndStop("disabledTRBL");
                    }
                }
                this.isEnabled = newEnabled;
            }
            setType(newType) {
                this.elementType = newType;
                this.backgroundButtonGotoAndStop(this.elementType + "Out");
                this.hoverImageGotoAndStop(this.elementType);
            }
            setNumber(newNumber) {
                this.positionNum = newNumber;
            }
            addEventListenerClick(callback) {
                if (this.callback)
                    return;
                this.callback = callback;
                this.background.on('pointerup', this.callback);
            }
            removeEventListenerClick() {
                if (this.callback) {
                    this.background.off('pointerup', this.callback);
                    this.callback = null;
                }
            }
        }
        code.PokemonSelectButton = PokemonSelectButton;
    })(code = pbawp.code || (pbawp.code = {}));
})(pbawp || (pbawp = {}));
var pbawp;
(function (pbawp) {
    var code;
    (function (code) {
        class Rest extends code.StatusEffect {
            constructor() {
                super();
                this.type = "rest";
                this.turnsLeft = 2;
            }
            preAttack() {
                super.preAttack();
                this.triggered = true;
            }
            postAttack() {
                super.postAttack();
                this.triggered = true;
            }
        }
        code.Rest = Rest;
    })(code = pbawp.code || (pbawp.code = {}));
})(pbawp || (pbawp = {}));
var pbawp;
(function (pbawp) {
    var code;
    (function (code) {
        class Sleep extends code.StatusEffect {
            constructor() {
                super();
                this.type = "sleep";
                this.turnsLeft = Math.floor(Math.random() * (3 - 1)) + 1;
            }
            preAttack() {
                super.preAttack();
                this.triggered = true;
            }
            postAttack() {
                super.postAttack();
            }
        }
        code.Sleep = Sleep;
    })(code = pbawp.code || (pbawp.code = {}));
})(pbawp || (pbawp = {}));
var pbawp;
(function (pbawp) {
    var code;
    (function (code) {
        class SoundManager {
            constructor(scene) {
                this.music = null;
                this.sounds = [];
                this.muted = false;
                this.currentMusic = "";
                this.scene = scene;
                this.soundDictionary = new Object();
                let gamegenie = code.GameWorld.constants.getElementWithName("gamegenie");
                if (pbawp.util.XMLParser.getAttribute(gamegenie, "mute") == "true") {
                    this.mute();
                }
                this.soundDictionary["MusicMain"] = "MusicMain2";
                this.soundDictionary["MusicBattle1"] = "MusicBattle";
                this.soundDictionary["MusicBattle2"] = "MusicBattle2";
                this.soundDictionary["MusicMap"] = "MusicMap";
                this.soundDictionary["MusicWin"] = "MusicWin";
                this.soundDictionary["buttonPress"] = "SoundButtonPress";
                this.soundDictionary["buttonRollover"] = "SoundButtonRollover";
                this.soundDictionary["chest"] = "SoundChest";
                this.soundDictionary["chestAppear"] = "SoundChestAppear";
                this.soundDictionary["dialog"] = "SoundDialogReveal";
                this.soundDictionary["dialogReveal"] = "SoundDialog";
                this.soundDictionary["dodge"] = "SoundDodge";
                this.soundDictionary["error"] = "SoundError";
                this.soundDictionary["statDown"] = "SoundStatDown";
                this.soundDictionary["statUp"] = "SoundStatUp";
                this.soundDictionary["switchPokemon"] = "SoundSwitchPokemon";
                this.soundDictionary["teleport"] = "SoundTeleport";
                this.soundDictionary["trap"] = "SoundTrap";
                this.soundDictionary["poison"] = "SoundPoison";
            }
            playMusic(filename, loop = false) {
                if (this.currentMusic == filename) {
                    return;
                }
                this.stopMusic();
                this.music = this.scene.sound.add(this.soundDictionary[filename]);
                this.music["filename"] = filename;
                this.music.loop = loop;
                this.music.play();
                this.music.setVolume(this.muted ? 0 : this.volumeForFile(filename));
                this.currentMusic = filename;
            }
            stopMusic() {
                this.currentMusic = "";
                if (this.music)
                    this.music.stop();
            }
            mute() {
                if (this.muted) {
                    this.muted = false;
                    this.music.setVolume(this.volumeForFile(this.music["filename"]));
                    sendEvent(petaGA_GameCategory_Game, 'Audio On', 'Pokémon Red White and Blue - Audio On');
                }
                else {
                    this.muted = true;
                    this.music.setVolume(0);
                    sendEvent(petaGA_GameCategory_Game, 'Audio Off', 'Pokémon Red White and Blue - Audio Off');
                }
            }
            playSound(filename) {
                let snd = this.soundDictionary.hasOwnProperty(filename) ? this.soundDictionary[filename] : filename;
                try {
                    let s = this.scene.sound.add(snd);
                    s["filename"] = filename;
                    s.play();
                    if (this.muted) {
                        s.setVolume(0);
                    }
                    else {
                        s.setVolume(this.volumeForFile(filename));
                    }
                    this.sounds.push(s);
                }
                catch (_a) {
                }
            }
            stopSound() {
                for (let s of this.sounds)
                    s.stop();
            }
            volumeForFile(filename) {
                if (filename == "MusicBattle1" || filename == "MusicBattle2") {
                    return 0.8 * 0.5;
                }
                if (filename == "dialog") {
                    return 0.15;
                }
                return 1 * 0.5;
            }
            fadeMusic(to, time) {
                if (this.music) {
                    let _music = this.music;
                    this.scene.tweens.add({
                        targets: _music,
                        "volume": 0,
                        duration: time,
                        ease: Phaser.Math.Easing.Linear,
                        onComplete: () => {
                            _music.stop();
                        }
                    });
                    this.music = null;
                }
                this.playMusic(to);
                this.music.setVolume(0);
                this.scene.tweens.add({
                    targets: this.music,
                    "volume": this.volumeForFile(to),
                    duration: time,
                    ease: Phaser.Math.Easing.Linear
                });
            }
        }
        code.SoundManager = SoundManager;
    })(code = pbawp.code || (pbawp.code = {}));
})(pbawp || (pbawp = {}));
var pbawp;
(function (pbawp) {
    var code;
    (function (code) {
        class SpeechBubble extends pbawp.assets.fla._SpeechBubble {
            constructor(scene) {
                super(scene);
                this.initialArrowHeight = this.arrow.height;
            }
            _destroy() {
            }
            appearFrom(c) {
                this.y = c.y + c.speechOffset;
                this.arrow.scaleY = 1;
                this.bubble.y = this.arrow.y + this.arrow.height * this.arrow.scaleY - 4;
                var offscreen = this.y + this.arrow.height * this.arrow.scaleY - 410;
                this.arrow.alpha = 1;
                if (offscreen > this.arrow.height * this.arrow.scaleY + 10) {
                    this.arrow.alpha = 0;
                    this.y = 406;
                    this.arrow.y = 0;
                    this.arrow.scaleY = 4 / this.initialArrowHeight;
                }
                else {
                    this.arrow.scaleY = (this.arrow.height - offscreen) / this.initialArrowHeight;
                    if (this.arrow.height * this.arrow.scaleY < 20) {
                        this.arrow.alpha = 0;
                    }
                }
                this.bubble.y = this.arrow.y + this.arrow.height * this.arrow.scaleY - 4;
            }
        }
        code.SpeechBubble = SpeechBubble;
    })(code = pbawp.code || (pbawp.code = {}));
})(pbawp || (pbawp = {}));
var pbawp;
(function (pbawp) {
    var code;
    (function (code) {
        class Stats extends pbawp.assets.fla._Stats {
            constructor(p, b, scene) {
                super(scene);
                this.gotoCancel = () => {
                    this.cancelButton.removeEventListenerClick(this.gotoCancel);
                    this.panelButton.off('pointerup', this.gotoCancel, this);
                    this.battleManager.closeStats();
                };
                var a = null;
                this.battleManager = b;
                this.pokemonInfoText.text = code.GameWorld.constants.getOneLinerWithID("statsTitle");
                this.dexNoText.text = code.GameWorld.constants.getOneLinerWithID("statsDexNo");
                this.nameText.text = code.GameWorld.constants.getOneLinerWithID("statsName");
                this.typeText.text = code.GameWorld.constants.getOneLinerWithID("statsType");
                this.otText.text = code.GameWorld.constants.getOneLinerWithID("statsOriginalTrainer");
                this.idNoText.text = code.GameWorld.constants.getOneLinerWithID("statsIDNo");
                this.infoText.text = code.GameWorld.constants.getOneLinerWithID("statsInfo");
                this.movesText.text = code.GameWorld.constants.getOneLinerWithID("statsMoves");
                this.heightWeight.text = code.GameWorld.constants.getOneLinerWithID("height") + " " + p.statHeight + " " + code.GameWorld.constants.getOneLinerWithID("weight") + " " + p.statWeight;
                this.dexNoValue.text = "" + p.pokedexNumber;
                this.nameValue.text = p.displayName;
                this.typeValue.text = p.elementType.substr(0, 1).toUpperCase() + p.elementType.substr(1, p.elementType.length);
                this.otValue.text = p.originalTrainerName;
                this.idNoValue.text = p.species;
                this.infoValue.text = p.description;
                this.pokemonName.text = p.displayName;
                this.genderGotoAndStop(p.gender);
                this.pokemonName.x = this.pokemonName.x - (this.gender.calculateWidth() * 0.5 + 5);
                this.gender.x = this.pokemonName.x + this.pokemonName.width * 0.5 + this.pokemonName.width * 0.5 + this.gender.calculateWidth() * 0.5;
                this.pokemonGotoAndStop(p.id);
                this.typeValue.setColor("#" + code.GameWorld.constants.getColorForElement(p.elementType).toString(16));
                this.movesValue.text = "";
                // this.movesValue.htmlText = "";
                for (let a of p.moves) {
                    this.movesValue.text = this.movesValue.text + a.displayName + "\n"; //("<font color=\"" + GameWorld.constants.getHTMLColorForElement(a.elementType) + "\">" + a.displayName + "</font><br />");
                }
                this.cancelButton.addEventListenerClick(this.gotoCancel);
                this.panelButton.setInteractive({ cursor: 'pointer' });
                this.panelButton.on('pointerup', this.gotoCancel, this);
                this.bg.setInteractive({ cursor: 'pointer' });
            }
            cancelPressed() {
                //this.cancelButton.upState = this.cancelButton.downState;
            }
            cancelReleased() {
                this.gotoCancel();
            }
        }
        code.Stats = Stats;
    })(code = pbawp.code || (pbawp.code = {}));
})(pbawp || (pbawp = {}));
var pbawp;
(function (pbawp) {
    var code;
    (function (code) {
        class Trainer extends pbawp.code.Character {
            constructor(scene) {
                super(scene);
                this.dropsPokemon = null;
            }
            loadInfo(trainerID) {
                this.loadFromXML(code.GameWorld.constants.getTrainerWithID(trainerID));
            }
            loadFromXML(xml) {
                super.loadFromXML(xml);
                let pokemonID = pbawp.util.XMLParser.getAttribute(xml, "pokemonID");
                if (!isEmpty(pokemonID)) {
                    this.dropsPokemon = pokemonID;
                }
                this.animationFrames["defeat"] = pbawp.util.XMLParser.getAttribute(xml, "defeatFrame");
                return xml;
            }
            playFrame(frameName, callback = null) {
                if (frameName != null) {
                    super.playFrame(frameName, callback);
                    if (this.animationClip.getChildByName(this.id) != null) {
                        this.animationClip.gotoAndPlay(frameName);
                    }
                    else {
                        this.animationClip.gotoAndPlay(frameName);
                    }
                }
                else if (callback != null) {
                    callback();
                }
            }
            stopFrame(frameName) {
                if (frameName != null) {
                    super.stopFrame(frameName);
                    if (this.animationClip.getChildByName(this.id) != null) {
                        this.animationClip.gotoAndStop(frameName);
                    }
                    else {
                        this.animationClip.gotoAndStop(frameName);
                    }
                }
            }
        }
        code.Trainer = Trainer;
    })(code = pbawp.code || (pbawp.code = {}));
})(pbawp || (pbawp = {}));
var pbawp;
(function (pbawp) {
    var code;
    (function (code) {
        class TransitionEffect extends Phaser.GameObjects.Container {
            constructor(scene) {
                super(scene);
                this.colorCallback = null;
                this.colorTime = 10;
                this.colorTimer = 10;
                this.isAddedEventListener_ENTER_FRAME = false;
                this.animationClip = new pbawp.assets.swf._AnimationTransitionSWF(this.scene);
                this.add(this.animationClip);
                this.x = 45;
                this.y = 215;
                this.visible = false;
            }
            playTransition() {
                this.visible = true;
                this.animationClip.gotoAndPlay();
            }
            fadeIn(m, callback) {
                this.fade(1, 0, m, callback);
            }
            fadeOut(m, callback) {
                this.fade(0, 1, m, callback);
            }
            fade(from, to, m, callback) {
                this.visible = true;
                this.finalColor = to;
                this.colorTimer = this.colorTime;
                this.colorCallback = callback;
                this.colorMovieClip = m;
                this.isAddedEventListener_ENTER_FRAME = true;
            }
            _update() {
                if (!this.isAddedEventListener_ENTER_FRAME)
                    return;
                this.colorTimer--;
                var percent = this.colorTimer / this.colorTime;
                if (this.finalColor == 1) {
                    percent = 1 - percent;
                }
                this.colorMovieClip.tint = Math.floor(0xFFFFFF * percent);
                if (this.colorTimer <= 0) {
                    this.isAddedEventListener_ENTER_FRAME = false;
                    this.colorCallback();
                }
            }
        }
        code.TransitionEffect = TransitionEffect;
    })(code = pbawp.code || (pbawp.code = {}));
})(pbawp || (pbawp = {}));
var pbawp;
(function (pbawp) {
    var code;
    (function (code) {
        class Trap extends code.StatusEffect {
            constructor() {
                super();
                this.percentHealth = 0.125;
                this.type = "trap";
                this.turnsLeft = Math.floor(Math.random() * (5 - 2)) + 2;
                this.triggered = true;
            }
            preAttack() {
                super.preAttack();
            }
            postAttack() {
                super.postAttack();
            }
        }
        code.Trap = Trap;
    })(code = pbawp.code || (pbawp.code = {}));
})(pbawp || (pbawp = {}));
var pbawp;
(function (pbawp) {
    var code;
    (function (code) {
        class Treasure extends Phaser.GameObjects.Container {
            constructor(childName = "treasure1", scene) {
                super(scene);
                //this.animationClip = new _TreasureboxSWF(this.scene).treasurebox;//getChildByName(childName);
                this.animationClip = new pbawp.assets.swf._TreasureboxSWF(this.scene).treasurebox; //getChildByName(childName);
                this.animationClip.x = 0;
                this.animationClip.y = 0;
                this.getTreasureMC().play("show");
                this.add(this.animationClip);
            }
            _destroy() {
                //GameWorld.preloader.getSWF("map/treasurebox.swf").addChild(this.animationClip);
            }
            _setScale(newScaleX, newScaleY = NaN) {
                if (isNaN(newScaleY))
                    newScaleY = newScaleX;
                this.animationClip.scaleX = newScaleX;
                this.animationClip.scaleY = newScaleY;
            }
            showTreasure(withSound = true) {
                if (withSound) {
                    code.GameWorld.soundManager.playSound("chestAppear");
                }
                this.getTreasureMC().play("show");
            }
            openTreasure() {
                code.GameWorld.soundManager.playSound("chest");
                this.getTreasureMC().play("open");
            }
            getTreasureMC() {
                return this.animationClip;
            }
            hideTreasure() {
                this.tween = this.scene.tweens.add({
                    targets: this,
                    "alpha": 0,
                    duration: 0.5 * 1000
                });
            }
        }
        code.Treasure = Treasure;
    })(code = pbawp.code || (pbawp.code = {}));
})(pbawp || (pbawp = {}));
var pbawp;
(function (pbawp) {
    var code;
    (function (code) {
        class TreasureButton extends pbawp.assets.fla._TreasureButton {
            constructor(scene) {
                super(scene);
                this.isEnabled = false;
                this.treasureID = "";
                this.over = () => {
                    code.GameWorld.soundManager.playSound("buttonRollover");
                    this.resetDownloadButton();
                    // this.downloadButton.upState = this.downloadButton.overState;
                    this.hoverImage.alpha = 1;
                };
                this.out = () => {
                    this.resetDownloadButton();
                    this.hoverImage.alpha = 0;
                };
                this.down = () => {
                    code.GameWorld.soundManager.playSound("buttonPress");
                    // this.downloadButton.upState = this.downloadButton.downState;
                };
                this.gotoDownload = () => {
                    if ( /*!GameWorld.soundManager.muted && */this.treasureID == "freeMeVideo") {
                        //GameWorld.soundManager.mute();
                    }
                    var jscommand = "window.open(\'" + this.treasureLink + "\',\'win\',\'height=550,width=550,toolbar=no,scrollba rs=yes\');";
                    // var url:URLRequest = new URLRequest("javascript:" + jscommand + " void(0);");
                    // navigateToURL(url,"_self");
                    setupPopUpWindowAnalytics(eval(jscommand));
                };
                this.delayOpenTimerDone = () => {
                    this.delayTimer.remove();
                    this.swf.openTreasure();
                    this.setEnabled(true);
                };
                this.hoverImage.scaleX = 1;
                this.tweenX = this.scene.tweens.add({
                    targets: this.hoverImage,
                    "scaleX": 1.1,
                    duration: 0.35 * 1000,
                    yoyo: true
                });
                this.hoverImage.scaleY = 1;
                this.tweenY = this.scene.tweens.add({
                    targets: this.hoverImage,
                    "scaleY": 1.1,
                    duration: 0.35 * 1000,
                    yoyo: true
                });
                this.hoverImage.alpha = 0;
                // buttonMode = true;
                // mouseChildren = false;
                this.setEnabled(false);
                code.GameWorld.constants.setText(this.downloadButton, code.GameWorld.constants.getOneLinerWithID("download"));
                // this.downloadStateUp = this.downloadButton.upState;
            }
            loadTreasureSWF(swfName) {
                this.swf = new code.Treasure(swfName, this.scene);
                this.swf._setScale(1);
                this.add(this.swf);
                this.swf.showTreasure(false);
                this.swf.x = this.swf.x - 125;
                this.swf.y = this.swf.y - 130;
            }
            stopInput() {
                this.downloadButton.removeEventListener_MOUSE_OVER(this.over);
                this.downloadButton.removeEventListener_MOUSE_OUT(this.out);
            }
            _destroy() {
                this.swf._destroy();
            }
            setEnabled(newEnabled) {
                if (this.isEnabled && !newEnabled) {
                    this._destroy();
                }
                else if (!this.isEnabled && newEnabled) {
                    this.downloadButton.addEventListener_MOUSE_OVER(this.over);
                    this.downloadButton.addEventListener_MOUSE_OUT(this.out);
                    this.downloadButton.addEventListener_MOUSE_DOWN(this.down);
                    this.downloadButton.addEventListenerClick(this.gotoDownload);
                }
                this.downloadButton.visible = newEnabled;
                // useHandCursor = newEnabled;
                this.isEnabled = newEnabled;
            }
            resetDownloadButton() {
                // this.downloadButton.upState = this.downloadStateUp;
            }
            playOpenAnimation(delay) {
                this.delayTimer = this.scene.time.addEvent({
                    delay: delay,
                    callback: this.delayOpenTimerDone,
                    callbackScope: this,
                    loop: true
                });
            }
        }
        code.TreasureButton = TreasureButton;
    })(code = pbawp.code || (pbawp.code = {}));
})(pbawp || (pbawp = {}));
var pbawp;
(function (pbawp) {
    var code;
    (function (code) {
        class TreasureScreen extends code.Screen {
            constructor(refToGameWorld, scene) {
                super(refToGameWorld, scene);
                this.gotoBack = () => {
                    this.gameworld._setState(this.gameworld.prevState, 0.3);
                };
                this.treasureArray = new Array();
                this.treasureIDs = new Array("mcCrueltyVideo", "wallpaper", "tradingCards");
                this.initializeView();
                code.GameWorld.constants.setText(this.backButton, code.GameWorld.constants.getOneLinerWithID("backButton"));
                this.treasureText.text = code.GameWorld.constants.getOneLinerWithID("treasure");
                this.freeMeVideoText.text = code.GameWorld.constants.getOneLinerWithID(!!this.gameworld.player.isTreasureUnlocked(this.treasureIDs[0]) ? "treasure1" : "treasureUnknown");
                this.wallpaperText.text = code.GameWorld.constants.getOneLinerWithID(!!this.gameworld.player.isTreasureUnlocked(this.treasureIDs[1]) ? "treasure2" : "treasureUnknown");
                this.tradingCardsText.text = code.GameWorld.constants.getOneLinerWithID(!!this.gameworld.player.isTreasureUnlocked(this.treasureIDs[2]) ? "treasure3" : "treasureUnknown");
                if (this.gameworld.player.treasuresUnlocked.length == 0) {
                    this.unlockedText.text = code.GameWorld.constants.getOneLinerWithID("noTreasureUnlocked");
                }
                else {
                    this.unlockedText.text = code.GameWorld.constants.getOneLinerWithID("treasureUnlocked").replace("%currentTreasures%", String(this.gameworld.player.treasuresUnlocked.length));
                }
                this.treasureArray.push(this.treasureButton1);
                this.treasureArray.push(this.treasureButton2);
                this.treasureArray.push(this.treasureButton3);
                var openDelay = 250;
                for (var i = 0; i < this.treasureArray.length; i++) {
                    this.treasureArray[i].loadTreasureSWF("treasure" + (i + 1));
                    if (this.gameworld.player.isTreasureUnlocked(this.treasureIDs[i])) {
                        this.treasureArray[i].playOpenAnimation(openDelay);
                        openDelay = openDelay + 250;
                    }
                    this.treasureArray[i].treasureLink = code.GameWorld.constants.getTreasureLink(this.treasureIDs[i]);
                    this.treasureArray[i].treasureID = this.treasureIDs[i];
                }
                this.backButton.addEventListenerClick(this.gotoBack);
            }
            initializeView() {
                this.view = new pbawp.assets.fla._TreasureScreen(this.scene);
                this.add(this.view);
                this.freeMeVideoText = this.view.freeMeVideoText;
                this.backButton = this.view.backButton;
                this.tradingCardsText = this.view.tradingCardsText;
                this.treasureButton1 = new code.TreasureButton(this.scene);
                this.treasureButton1.x = this.view.treasureButton1.x;
                this.treasureButton1.y = this.view.treasureButton1.y;
                this.view.addAt(this.treasureButton1, this.view.getIndex(this.view.treasureButton1));
                this.view.remove(this.view.treasureButton1);
                this.view.treasureButton1 = this.treasureButton1;
                this.treasureButton2 = new code.TreasureButton(this.scene);
                this.treasureButton2.x = this.view.treasureButton2.x;
                this.treasureButton2.y = this.view.treasureButton2.y;
                this.view.addAt(this.treasureButton2, this.view.getIndex(this.view.treasureButton2));
                this.view.remove(this.view.treasureButton2);
                this.view.treasureButton2 = this.treasureButton2;
                this.unlockedText = this.view.unlockedText;
                this.treasureButton3 = new code.TreasureButton(this.scene);
                this.treasureButton3.x = this.view.treasureButton3.x;
                this.treasureButton3.y = this.view.treasureButton3.y;
                this.view.addAt(this.treasureButton3, this.view.getIndex(this.view.treasureButton3));
                this.view.remove(this.view.treasureButton3);
                this.view.treasureButton3 = this.treasureButton3;
                this.wallpaperText = this.view.wallpaperText;
                this.treasureText = this.view.treasureText;
            }
            stopInput() {
                this.backButton.removeEventListenerClick(this.gotoBack);
                for (let t of this.treasureArray) {
                    t.stopInput();
                }
            }
            _destroy() {
                for (let t of this.treasureArray) {
                    t._destroy();
                }
            }
        }
        code.TreasureScreen = TreasureScreen;
    })(code = pbawp.code || (pbawp.code = {}));
})(pbawp || (pbawp = {}));
var pbawp;
(function (pbawp) {
    var util;
    (function (util) {
        class TweenHelper {
            static TweenObjectForAction(action, xmlProperty) {
                let propertiesArray = null;
                let tweenArray = null;
                let tweenObject = null;
                let i = NaN;
                let curProperty = null;
                let curTween = null;
                let attr = pbawp.util.XMLParser.getAttribute(action, xmlProperty);
                if (!isEmpty(attr)) {
                    propertiesArray = pbawp.util.XMLParser.getAttribute(action, "properties").split(",");
                    tweenArray = pbawp.util.XMLParser.getAttribute(action, xmlProperty).split(",");
                    tweenObject = new Object();
                    for (i = 0; i < propertiesArray.length; i++) {
                        curProperty = propertiesArray[i];
                        curTween = tweenArray[i];
                        if (curTween == "null") {
                            curTween = null;
                        }
                        if (curProperty == "alpha") {
                            tweenObject["alpha"] = Number(curTween);
                        }
                        else if (curProperty == "tint") {
                            tweenObject["tint"] = parseInt(curTween);
                        }
                        else if (curProperty == "x") {
                            tweenObject["x"] = Number(curTween);
                        }
                        else if (curProperty == "y") {
                            tweenObject["y"] = Number(curTween);
                        }
                    }
                    let ease = pbawp.util.XMLParser.getAttribute(action, "ease");
                    if (!isEmpty(ease)) {
                        tweenObject = TweenHelper.AddEaseToTween(ease, tweenObject);
                    }
                    let delay = pbawp.util.XMLParser.getAttribute(action, "delay");
                    if (!isEmpty(delay)) {
                        tweenObject["delay"] = Number(delay) * 1000;
                    }
                    return tweenObject;
                }
                return null;
            }
            static AddEaseToTween(easeString, tweenObject) {
                console.log("adding ease to object: " + easeString);
                if (easeString == "Linear.easeNone") {
                    tweenObject["ease"] = Phaser.Math.Easing.Linear;
                }
                return tweenObject;
            }
        }
        util.TweenHelper = TweenHelper;
    })(util = pbawp.util || (pbawp.util = {}));
})(pbawp || (pbawp = {}));
var pbawp;
(function (pbawp) {
    var code;
    (function (code) {
        class URL {
            constructor(urlString) {
                this.path = "";
                this.scheme = "";
                this.hostArray = new Array();
                this.originalString = urlString;
                var schemeEnd = this.originalString.indexOf(":");
                this.scheme = this.originalString.substr(0, schemeEnd);
                var hostStart = this.originalString.indexOf("//") + 2;
                if (this.originalString.indexOf("//") == -1) {
                    hostStart = 0;
                }
                var hostEnd = this.originalString.indexOf("/", hostStart);
                this.hostArray = this.originalString.substr(hostStart, hostEnd - hostStart).split(".");
                var pathStart = this.originalString.indexOf("/", hostEnd);
                var pathEnd = this.originalString.lastIndexOf("/");
                this.path = this.originalString.substr(pathStart, pathEnd - pathStart);
            }
            static shouldDefaultToChinese() {
                var hostUrl = window.location.href.toString();
                return hostUrl != null && (hostUrl.indexOf("asiapacific") != -1 || hostUrl.indexOf("papfeatures") != -1) || pbawp.code.GameWorld.siteUrl != null && pbawp.code.GameWorld.siteUrl.urlType() == "petaAsiaPacific";
            }
            urlWithType(newType) {
                var copyHostArray = this.hostArray;
                var indexToReplace = -1;
                var replaceString = "";
                if (newType == "petaAsiaPacific") {
                    if (copyHostArray.indexOf("features3") != -1) {
                        indexToReplace = copyHostArray.indexOf("features3");
                        replaceString = "features";
                    }
                    else if (copyHostArray.indexOf("indiafeatures") != -1) {
                        indexToReplace = copyHostArray.indexOf("indiafeatures");
                        replaceString = "features";
                    }
                    else if (copyHostArray.indexOf("features2") != -1) {
                        indexToReplace = copyHostArray.indexOf("features2");
                        replaceString = "features";
                    }
                    else if (copyHostArray.indexOf("petaindia") != -1) {
                        indexToReplace = copyHostArray.indexOf("petaindia");
                        replaceString = "peta";
                    }
                    else if (copyHostArray.indexOf("petakids") != -1) {
                        indexToReplace = copyHostArray.indexOf("petakids");
                        replaceString = "peta";
                    }
                    else if (copyHostArray.indexOf("peta2") != -1) {
                        indexToReplace = copyHostArray.indexOf("peta2");
                        replaceString = "peta";
                    }
                    if (copyHostArray.indexOf("com") != -1) {
                        copyHostArray[copyHostArray.indexOf("com")] = "org";
                    }
                }
                else if (newType == "peta") {
                    if (copyHostArray.indexOf("papfeatures") != -1) {
                        indexToReplace = copyHostArray.indexOf("papfeatures");
                        replaceString = "features";
                    }
                    else if (copyHostArray.indexOf("petaasiapacific") != -1) {
                        indexToReplace = copyHostArray.indexOf("petaasiapacific");
                        if (copyHostArray.indexOf("com") != -1) {
                            copyHostArray[copyHostArray.indexOf("com")] = "org";
                        }
                        replaceString = "peta";
                    }
                }
                if (indexToReplace >= 0 && indexToReplace < copyHostArray.length && replaceString.length > 0) {
                    copyHostArray[indexToReplace] = replaceString;
                }
                return this.url(copyHostArray);
            }
            url(newHostArray = null) {
                var h = null;
                if (newHostArray == null) {
                    newHostArray = this.hostArray;
                }
                var returnUrl = this.scheme.concat("://");
                for (h of newHostArray) {
                    returnUrl = returnUrl.concat(h + ".");
                }
                returnUrl = returnUrl.substr(0, returnUrl.length - 1);
                returnUrl = returnUrl.concat(this.path + "/");
                return returnUrl;
            }
            urlType() {
                if (this.hostArray != null) {
                    if (this.hostArray.indexOf("petakids") != -1 || this.hostArray.indexOf("features3") != -1) {
                        return "petaKids";
                    }
                    if (this.hostArray.indexOf("petaindia") != -1 || this.hostArray.indexOf("indiafeatures") != -1) {
                        return "petaIndia";
                    }
                    if (this.hostArray.indexOf("petaasiapacific") != -1 || this.hostArray.indexOf("papfeatures") != -1) {
                        return "petaAsiaPacific";
                    }
                    if (this.hostArray.indexOf("peta2") != -1 || this.hostArray.indexOf("features2") != -1) {
                        return "peta2";
                    }
                    if (this.hostArray.indexOf("peta") != -1 || this.hostArray.indexOf("features") != -1) {
                        return "peta";
                    }
                }
                return "petaPresents";
            }
        }
        code.URL = URL;
    })(code = pbawp.code || (pbawp.code = {}));
})(pbawp || (pbawp = {}));
var pbawp;
(function (pbawp) {
    var scene;
    (function (scene) {
        class Boot extends Phaser.Scene {
            init() {
                game.input.mouse.enabled = !game.device.input.touch;
                // new FitScaleManager(this.game).setup();
            }
            create() {
                game.scene.remove('Boot');
                game.scene.add('Preloader', pbawp.scene.Preloader, true);
            }
        }
        scene.Boot = Boot;
    })(scene = pbawp.scene || (pbawp.scene = {}));
})(pbawp || (pbawp = {}));
var pbawp;
(function (pbawp) {
    var scene;
    (function (scene) {
        var _Preloader = pbawp.assets.fla._Preloader;
        class Preloader extends Phaser.Scene {
            preload() {
                this.load.atlas('preloader-atlas', 'assets/imgs/atlas/preloader-atlas.png', 'assets/imgs/atlas/preloader-atlas.json');
                sendEvent(petaGA_GameCategory_Game, 'Load', 'Pokémon Red White and Blue - Load', false);
            }
            create() {
                let p = new _Preloader(this);
                this.children.add(p);
                // this.load.xml('blackAndBlue.xml', 'assets/xml/blackAndBlue.xml');
                this.load.pack('preloader', 'assets/pack.json');
                this.load.on('progress', (value) => {
                    p.bar.scaleX = value;
                }, this);
                this.load.on('complete', () => {
                    this.nextScene();
                });
                this.load.start();
            }
            nextScene() {
                game.scene.remove('Preloader');
                game.scene.add('ScreenMain', pbawp.scene.ScreenMain, true);
            }
        }
        scene.Preloader = Preloader;
    })(scene = pbawp.scene || (pbawp.scene = {}));
})(pbawp || (pbawp = {}));
var pbawp;
(function (pbawp) {
    var scene;
    (function (scene) {
        class ScreenMain extends Phaser.Scene {
            test() {
                /*let w = new pbawp.assets.swf._WinSWF(this);
                this.children.add(w);
    
                let t = new pbawp.assets.swf._TreasureboxSWF(this);
                this.children.add(t);
                t.gotoAndStop("show");
    
                let td = new pbawp.assets.swf._TopdownSWF(this).getChildByName("snorlaxFall");
                td.setPosition(100, 200);
                this.children.add(td);
    
                let _a = new pbawp.assets.swf._AnimationTransitionSWF(this);
                _a.gotoAndPlay();
                _a.setPosition(100, 200);
                this.children.add(_a);
    
                let _ash = new pbawp.assets.swf.character._Animation_asset_cherenSWF(this);
                _ash.gotoAndPlay('normal');
                _ash.setPosition(0, 0);
                this.children.add(_ash);
    
                let _pr = new pbawp.assets.fla._Preloader(this);
                this.children.add(_pr);
    
                let _st = new pbawp.assets.fla._Stats(this);
                this.children.add(_st);
                window["_st"]=_st;
    
                let _mm = new pbawp.assets.fla._MenuMain(this);
                this.children.add(_mm);
                window["_mm"]=_mm;
    
                let _ts = new pbawp.assets.fla._TreasureScreen(this);
                this.children.add(_ts);
                window["_ts"]=_ts;
    
                let _ov = new pbawp.assets.fla._Overlay(this);
                this.children.add(_ov);
                window["_ov"]=_ov;
    
                let _it = new pbawp.assets.fla._Intro(this);
                this.children.add(_it);
                window["_it"]=_it;
    
                let _pb = new pbawp.assets.fla._PlayerBattleInfo(this);
                _pb.setPosition(200, 200);
                this.children.add(_pb);
                window["_pb"]=_pb;
    
                let _cd = new pbawp.assets.fla._Credits(this);
                this.children.add(_cd);
                window["_cd"]=_cd;
    
                let _gw = new pbawp.assets.fla._GameAlmostWin(this);
                this.children.add(_gw);
                window["_gw"]=_gw;
    
                let _sb = new pbawp.assets.fla._SpeechBubble(this);
                this.children.add(_sb);
                window["_sb"]=_sb;*/
                let _gwi = new pbawp.assets.fla._GameWin(this);
                this.children.add(_gwi);
                window["_gwi"] = _gwi;
                /*let _gov = new pbawp.assets.fla._GameOver(this);
                this.children.add(_gov);
                window["_gov"]=_gov;
    
                let _ab = new pbawp.assets.fla._AttackButton(this);
                _ab.setPosition(200, 200);
                this.children.add(_ab);
                window["_ab"]=_ab;
    
                let _psb = new pbawp.assets.fla._PokemonSelectButton(this);
                _psb.setPosition(300, 200);
                this.children.add(_psb);
                window["_psb"]=_psb;
    
                let _hlp = new pbawp.assets.fla._Help(this);
                this.children.add(_hlp);
                window["_hlp"]=_hlp;
    
                let _map = new pbawp.assets.fla._Map(this);
                this.children.add(_map);
                window["_map"]=_map;
    
                let _bm = new pbawp.assets.fla._BattleManager(this);
                this.children.add(_bm);
                window["_bm"]=_bm;*/
                // let _Animation_asset_grimaceSWF = new pbawp.assets.swf.character._Animation_asset_grimaceSWF(this);
                // this.children.add(_Animation_asset_grimaceSWF);
                // window["_Animation_asset_grimaceSWF"]=_Animation_asset_grimaceSWF;
                // let _Animation_asset_jigglypuffSWF = new pbawp.assets.swf.character._Animation_asset_jigglypuffSWF(this);
                // this.children.add(_Animation_asset_jigglypuffSWF);
                // window["_Animation_asset_jigglypuffSWF"]=_Animation_asset_jigglypuffSWF;
                // let _Animation_asset_mcdonaldsCustomer = new pbawp.assets.swf.character._Animation_asset_mcdonaldsCustomerSWF(this);
                // this.children.add(_Animation_asset_mcdonaldsCustomer);
                // window["_Animation_asset_mcdonaldsCustomer"]=_Animation_asset_mcdonaldsCustomer;
                // let _Animation_asset_miltankSWF = new pbawp.assets.swf.character._Animation_asset_miltankSWF(this);
                // this.children.add(_Animation_asset_miltankSWF);
                // window["_Animation_asset_miltankSWF"]=_Animation_asset_miltankSWF;
                // let _Animation_asset_mysteriousStrangerSWF = new pbawp.assets.swf.character._Animation_asset_mysteriousStrangerSWF(this);
                // this.children.add(_Animation_asset_mysteriousStrangerSWF);
                // window["_Animation_asset_mysteriousStrangerSWF"]=_Animation_asset_mysteriousStrangerSWF;
                // let _Animation_asset_ronaldSWF = new pbawp.assets.swf.character._Animation_asset_ronaldSWF(this);
                // this.children.add(_Animation_asset_ronaldSWF);
                // window["_Animation_asset_ronaldSWF"]=_Animation_asset_ronaldSWF;
                // let _Animation_asset_slaughterhouseWorkersSWF = new pbawp.assets.swf.character._Animation_asset_slaughterhouseWorkersSWF(this);
                // this.children.add(_Animation_asset_slaughterhouseWorkersSWF);
                // window["_Animation_asset_slaughterhouseWorkersSWF"]=_Animation_asset_slaughterhouseWorkersSWF;
                // let _Animation_asset_pikachuSWF = new pbawp.assets.swf.character._Animation_asset_pikachuSWF(this);
                // this.children.add(_Animation_asset_pikachuSWF);
                // window["_Animation_asset_pikachuSWF"]=_Animation_asset_pikachuSWF;
            }
            create() {
                // this.test();
                this.gameWorld = new pbawp.code.GameWorld(this);
                this.children.add(this.gameWorld);
                this.gameWorld.init();
            }
            update() {
                this.gameWorld._update();
            }
        }
        scene.ScreenMain = ScreenMain;
    })(scene = pbawp.scene || (pbawp.scene = {}));
})(pbawp || (pbawp = {}));
var pbawp;
(function (pbawp) {
    var util;
    (function (util) {
        class BasicButton extends Phaser.GameObjects.Image {
            constructor(scene, x, y, texture, upFrame, overFrame, downFrame) {
                super(scene, x, y, texture, upFrame);
                this.setInteractive({ cursor: 'pointer' });
                this.on('pointerdown', () => this.setFrame(downFrame), this);
                this.on('pointerup', () => { this.setFrame(upFrame); pbawp.code.GameWorld.soundManager.playSound('SoundButtonPress'); }, this);
                this.on('pointerover', () => { this.setFrame(overFrame); pbawp.code.GameWorld.soundManager.playSound('SoundButtonRollover'); }, this);
                this.on('pointerout', () => this.setFrame(upFrame), this);
            }
            addEventListenerClick(callback) {
                this.on('pointerup', callback);
            }
            removeEventListenerClick(callback) {
                this.off('pointerup', callback);
            }
        }
        util.BasicButton = BasicButton;
    })(util = pbawp.util || (pbawp.util = {}));
})(pbawp || (pbawp = {}));
var pbawp;
(function (pbawp) {
    var util;
    (function (util) {
        class BasicLabeledButton extends Phaser.GameObjects.Container {
            constructor(scene, x, y, texture, textLabelContent, bgFrameName = 'basicLabeledButton') {
                super(scene, x, y);
                this.btn = new util.BasicButton(this.scene, 0, 0, texture, bgFrameName + '0000', bgFrameName + '0001', bgFrameName + '0002');
                this.add(this.btn);
                this.textLabel = this.scene.add.text(0, 0, textLabelContent, {
                    "fontFamily": "Agency FB",
                    "fontSize": 22,
                    "color": "#FFFFFF",
                    "align": 'center'
                });
                this.textLabel.setOrigin(0.5, 0.5);
                this.add(this.textLabel);
                this.btn.on('pointerup', () => { this.textLabel.setColor("#FFFFFF"); pbawp.code.GameWorld.soundManager.playSound('SoundButtonPress'); }, this);
                this.btn.on('pointerover', () => { this.textLabel.setColor("#FFFFFF"); pbawp.code.GameWorld.soundManager.playSound('SoundButtonRollover'); }, this);
                this.btn.on('pointerdown', () => this.textLabel.setColor("#000000"), this);
                this.btn.on('pointerout', () => this.textLabel.setColor("#FFFFFF"), this);
            }
            addEventListenerClick(callback) {
                this.btn.on('pointerup', callback);
            }
            removeEventListenerClick(callback) {
                this.btn.off('pointerup', callback);
            }
            addEventListener_MOUSE_OVER(callback) {
                this.btn.on('pointerover', callback);
            }
            removeEventListener_MOUSE_OVER(callback) {
                this.btn.off('pointerover', callback);
            }
            addEventListener_MOUSE_OUT(callback) {
                this.btn.on('pointerout', callback);
            }
            removeEventListener_MOUSE_OUT(callback) {
                this.btn.off('pointerout', callback);
            }
            addEventListener_MOUSE_DOWN(callback) {
                this.btn.on('pointerdown', callback);
            }
            removeEventListener_MOUSE_DOWN(callback) {
                this.btn.off('pointerdown', callback);
            }
        }
        util.BasicLabeledButton = BasicLabeledButton;
    })(util = pbawp.util || (pbawp.util = {}));
})(pbawp || (pbawp = {}));
var pbawp;
(function (pbawp) {
    var util;
    (function (util) {
        class SharedObject {
            constructor(name) {
                this.isLocalStorageSupported = false;
                this.data = null;
                this.name = name;
                this.data = {};
                this.checkLocalStorageSupported();
                this.createOrLoad();
            }
            static getLocal(name) {
                if (!SharedObject.instances.hasOwnProperty(name)) {
                    SharedObject.instances[name] = new SharedObject(name);
                }
                return SharedObject.instances[name];
            }
            flush() {
                if (!this.isLocalStorageSupported)
                    return;
                localStorage[this.name] = JSON.stringify(this.data);
            }
            createOrLoad() {
                if (!this.isLocalStorageSupported)
                    return;
                if (localStorage[this.name]) { //localStorage exist
                    this.data = JSON.parse(localStorage[this.name]);
                }
                else {
                    this.flush();
                }
            }
            checkLocalStorageSupported() {
                try {
                    this.isLocalStorageSupported = "localStorage" in window && window["localStorage"] !== null;
                }
                catch (e) {
                    this.isLocalStorageSupported = false;
                }
            }
        }
        SharedObject.instances = {};
        util.SharedObject = SharedObject;
    })(util = pbawp.util || (pbawp.util = {}));
})(pbawp || (pbawp = {}));
var pbawp;
(function (pbawp) {
    var util;
    (function (util) {
        class XMLParser {
            static toXMLDoc(xmlText) {
                let d;
                if (window["DOMParser"]) {
                    let parser = new DOMParser();
                    d = parser.parseFromString(xmlText, "text/xml");
                }
                else { // Internet Explorer
                    d = new ActiveXObject("Microsoft.XMLDOM");
                    d.async = false;
                    d.loadXML(xmlText);
                }
                return d;
            }
            static toXMLElement(xmlText) {
                let toXMLDoc = XMLParser.toXMLDoc(xmlText);
                if (toXMLDoc.children.length > 0)
                    return toXMLDoc.children[0];
                return null;
            }
            static getAttribute(node, qualifiedName) {
                if (!node.getAttribute) {
                    if (node["length"] && node["length"] >= 1) {
                        return XMLParser.getAttribute(node[0], qualifiedName);
                    }
                }
                return node.getAttribute(qualifiedName);
            }
            static getChildNode(node, tagName) {
                if (!node.getElementsByTagName) {
                    if (node["length"] && node["length"] >= 1) {
                        return XMLParser.getChildNode(node[0], tagName);
                    }
                    return null;
                }
                let hc = node.getElementsByTagName(tagName);
                // if (hc.length == 1) return hc[0];
                return hc;
            }
        }
        util.XMLParser = XMLParser;
    })(util = pbawp.util || (pbawp.util = {}));
})(pbawp || (pbawp = {}));
